import { j as s, $ as ma, a as fa, b as ba, c as ya, d as xa, e as _a, g as Ca, h as va, i as wa, n as L, O as Sa, k as Os, l as Bs, w as Bn, Z as Ia, H as ka, m as Ln, o as ye, p as io, r as mr, q as Da, t as fr, W as Ta, u as ja, A as Fa, F as Na, v as Pa, x as br, y as Hs, z as yr, B as Hn, C as Ra, D as Ea, E as La, G as Aa, I as $a, J as Oa, K as xr, L as Ba, M as Ha } from "./vendor-B4O8kiwH.js";
import f from "classnames";
import { I as N, T as H, a as q, r as js, B as ie, b as Jt, c as te, d as Me, S as Ws, e as Xe, f as Wa, g as Ma } from "./emoji-r0LV8WWJ.js";
import { E as OD, N as BD, j as HD, h as WD, i as MD } from "./emoji-r0LV8WWJ.js";
import { createContext as Ie, useContext as We, useRef as Q, useLayoutEffect as za, useState as V, useCallback as F, useEffect as Z, cloneElement as rn, isValidElement as Se, Component as xe, PureComponent as k, forwardRef as W, Children as Ee, createRef as O, memo as _r, useMemo as G, Fragment as et, createElement as Va, lazy as Ka, Suspense as Ua, useReducer as qa, useImperativeHandle as an } from "react";
import { useKey as Cr, useMount as ht, useUnmount as tt, useUpdateEffect as Je, useToggle as Ga, useSetState as Ya, useClickAway as vr, usePrevious as en, useDebounce as Qa } from "react-use";
import j from "moment-timezone";
import { v4 as tn } from "uuid";
import { noop as Xa } from "ts-essentials";
import Za from "react-dom";
function Ja(a) {
  let e = a;
  const t = [];
  function n(r) {
    if (r !== e) {
      for (const { type: i, handler: l, options: c } of t)
        e.removeEventListener(i, l, c), r.addEventListener(i, l, c);
      e = r;
    }
  }
  return { proxy: new Proxy({}, {
    get(r, i) {
      if (i === "addEventListener")
        return (c, d, h) => {
          t.push({ type: c, handler: d, options: h }), e.addEventListener(c, d, h);
        };
      if (i === "removeEventListener")
        return (c, d, h) => {
          const u = typeof h == "boolean" ? h : h?.capture ?? !1, p = t.findIndex((g) => {
            const m = typeof g.options == "boolean" ? g.options : g.options?.capture ?? !1;
            return g.type === c && g.handler === d && m === u;
          });
          p !== -1 && t.splice(p, 1), e.removeEventListener(c, d, h);
        };
      const l = e[i];
      return typeof l != "function" ? l : new Proxy(l, {
        apply(c, d, h) {
          return l.apply(e, h);
        }
      });
    }
  }), setWindow: n };
}
const Un = Ie(
  typeof window < "u" ? window : {}
);
function Nk({
  value: a,
  children: e
}) {
  const t = Q(null);
  return t.current || (t.current = Ja(a)), za(() => {
    t.current.setWindow(a);
  }, [a]), /* @__PURE__ */ s.jsx(Un.Provider, { value: t.current.proxy, children: e });
}
function Ms() {
  return We(Un);
}
const ei = "h-tooltip--tooltip__content", ti = "h-tooltip--tooltip__contentLight", ni = "h-tooltip--tooltip__contentHasHead", si = "h-tooltip--tooltip__body", oi = "h-tooltip--tooltip__head", ri = "h-tooltip--tooltip__arrow", pt = {
  content: ei,
  contentLight: ti,
  contentHasHead: ni,
  body: si,
  head: oi,
  arrow: ri
}, ai = 400;
function le({
  children: a,
  content: e,
  onOpenChange: t,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: i,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = ai,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: g,
  requireClick: m,
  light: b,
  ...y
}) {
  const v = Ms(), [w, S] = V(
    m ? !1 : void 0
  ), C = F(() => {
    S(!1), v.removeEventListener("click", C);
  }, [v]);
  Z(() => () => {
    v.removeEventListener("click", C);
  }, [C, v]);
  const x = ma();
  if (c || !e)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: a });
  const _ = (T) => {
    T.stopPropagation(), v[w ? "removeEventListener" : "addEventListener"](
      "click",
      C
    ), S(!w);
  }, I = f(
    pt.content,
    {
      [pt.contentHasHead]: !!r,
      [pt.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(fa, { children: /* @__PURE__ */ s.jsxs(
    ba,
    {
      open: w ?? (l ? !0 : void 0),
      defaultOpen: i,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: t,
      children: [
        /* @__PURE__ */ s.jsx(ya, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: m ? _ : void 0,
            ...g,
            ...y,
            children: a
          }
        ) : m && Se(a) ? rn(a, { onClick: _ }) : a }),
        /* @__PURE__ */ s.jsx(xa, { container: v.document.body, children: /* @__PURE__ */ s.jsx(
          _a,
          {
            id: x,
            side: n,
            sideOffset: 4,
            align: h,
            className: I,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: pt.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: pt.body, children: e }),
              /* @__PURE__ */ s.jsx(Ca, { className: pt.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const ii = "h-attachment--attachment__root", li = "h-attachment--attachment__icon", ci = "h-attachment--attachment__name", di = "h-attachment--attachment__buttons", mn = {
  root: ii,
  icon: li,
  name: ci,
  buttons: di
}, lo = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function hi(a) {
  const e = a.split(".").pop()?.toLowerCase();
  return !e || !lo[e] ? "file" : lo[e];
}
const Pk = (a) => {
  const {
    className: e,
    nameClassName: t,
    fileName: n,
    label: o,
    onDownload: r,
    onPreview: i,
    isPreviewLoading: l,
    isDownloadLoading: c,
    extraButtons: d,
    ...h
  } = a, u = f(
    {
      [mn.root]: !0
    },
    e
  );
  return /* @__PURE__ */ s.jsxs("div", { ...h, className: u, children: [
    /* @__PURE__ */ s.jsx(
      N,
      {
        className: mn.icon,
        name: hi(n),
        size: 24,
        color: "neutral.700"
      }
    ),
    /* @__PURE__ */ s.jsx(
      le,
      {
        content: o || n,
        wrap: "div",
        wrapProps: { className: f(mn.name, t) },
        children: /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "4", color: "secondary", children: o || n })
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: mn.buttons, children: [
      i && /* @__PURE__ */ s.jsx(
        q,
        {
          isLoading: l,
          variant: "secondary",
          icon: "eye",
          onClick: l ? void 0 : i
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        q,
        {
          isLoading: c,
          variant: "secondary",
          icon: "download",
          onClick: c ? void 0 : r
        }
      ),
      d
    ] })
  ] });
}, ui = {
  onError(a, e) {
    console.error(a, e);
  }
}, pi = Ie(ui), co = { error: null };
class jt extends xe {
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  constructor(e) {
    super(e), this.state = co, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
  }
  componentDidCatch(e, t) {
    this.props.onError?.(e, t), this.context?.onError?.(e, t);
  }
  static contextType = pi;
  resetErrorBoundary(...e) {
    this.props.onReset?.(...e), this.resetInternally();
  }
  resetInternally() {
    this.setState(co);
  }
  hasError(e) {
    return e !== null;
  }
  ensureErrorHandlerExists() {
    const { fallback: e, fallbackRender: t } = this.props, n = this.hasFallbackElement(e), o = this.hasFallbackRenderer(t);
    if (!n && !o)
      throw new Error(
        `${jt.name} requires either a fallback component or a fallback renderer`
      );
  }
  hasFallbackRenderer(e) {
    return typeof e == "function";
  }
  hasFallbackElement(e) {
    return e === null || typeof e == "string" || Se(e);
  }
  render() {
    const { error: e } = this.state, { fallbackRender: t, fallback: n } = this.props;
    if (this.ensureErrorHandlerExists(), !this.hasError(e))
      return this.props.children;
    if (this.hasFallbackElement(n))
      return n;
    if (this.hasFallbackRenderer(t))
      return t({
        error: e,
        resetErrorBoundary: this.resetErrorBoundary
      });
  }
}
function ln(a, e) {
  const t = a.displayName || a.name || "Unknown";
  return va(
    class extends xe {
      static displayName = `withErrorBoundary(${t})`;
      static defaultProps = a.defaultProps;
      render() {
        const o = a;
        return /* @__PURE__ */ s.jsx(jt, { ...e, children: /* @__PURE__ */ s.jsx(o, { ...this.props }) });
      }
    },
    a
  );
}
const gi = "h-avatar--avatar__root", An = {
  root: gi,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, mi = {
  24: 16,
  32: 20,
  40: 24
}, fi = ({
  icon: a,
  size: e,
  color: t = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: a, size: mi[e], color: t }), bi = "h-image--image__image", yi = "h-image--image__error", xi = "h-image--image__complete", as = {
  image: bi,
  error: yi,
  complete: xi
};
class zs extends xe {
  static defaultProps;
  mounted;
  constructor(e) {
    super(e), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: e } = this.props;
    this.handleSource(e);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { src: t } = this.props;
    e.src !== t && this.handleSource(e.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(e) {
    typeof e == "string" ? this.setState({
      imageSrc: e
    }) : e().then((t) => {
      this.mounted && typeof t == "string" && this.setState({
        imageSrc: t
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(e) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(e);
  }
  onError(e) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(e);
  }
  render() {
    const { className: e, src: t, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: i, loadingComplete: l } = this.state, c = f(
      {
        [as.image]: !0,
        [as.error]: !!i,
        [as.complete]: !!l
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
zs.defaultProps = {
  className: "",
  alt: ""
};
const _i = "h-avatar--imageAvatar__root", Ci = {
  root: _i
}, vi = ({
  src: a,
  alt: e = "avatar"
}) => /* @__PURE__ */ s.jsx(zs, { src: a, alt: e, className: Ci.root }), wi = "h-avatar--textAvatar__root", $n = {
  root: wi,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, Si = {
  24: $n["avatar-24"],
  32: $n["avatar-32"],
  40: $n["avatar-40"]
}, Ii = ({ text: a = "", size: e }) => /* @__PURE__ */ s.jsx("div", { className: f($n.root, Si[e]), children: a.trim().split(" ").map(
  (t, n, o) => o.length === 1 ? t : t[0]
).join("").slice(0, 2) }), ki = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Di {
  constructor(e) {
    this.colors = e, this.colors = e;
  }
  colors;
  generate(e) {
    const t = this.getRandomIndex(e);
    return this.colors[t];
  }
  getRandomIndex(e) {
    const t = wa(e);
    return Math.floor(t() * this.colors.length);
  }
}
var ee = /* @__PURE__ */ ((a) => (a.Icon = "Icon", a.Image = "Image", a.Text = "Text", a))(ee || {});
function gt(a) {
  return a.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function _e(a) {
  return !!a && a.trim().length !== 0;
}
function Ti(a) {
  if (a.icon)
    return {
      type: ee.Icon,
      icon: a.icon,
      backgroundColor: a.color?.backgroundColor,
      iconColor: a.color?.contentColor
    };
  const { user: e } = a;
  if (!e)
    return {
      type: ee.Icon,
      icon: "user-slash"
    };
  if (_e(e.avatar_url))
    return {
      type: ee.Image,
      src: e.avatar_url,
      alt: e.name || e.display_name || e.email || e.phone_number || e.given_name || e.family_name || ""
    };
  if (_e(e.name)) {
    const t = gt(e.name.trim()).split(" ");
    if (t.length === 1)
      return {
        type: ee.Text,
        text: t[0]?.[0] ?? ""
      };
    const n = t[0], o = t[t.length - 1];
    return {
      type: ee.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (_e(e.display_name))
    return {
      type: ee.Text,
      text: gt(e.display_name.trim())
    };
  if (_e(e.given_name) && _e(e.family_name))
    return {
      type: ee.Text,
      text: gt(e.given_name.trim())[0] + gt(e.family_name.trim())[0]
    };
  if (_e(e.given_name) && !_e(e.family_name))
    return {
      type: ee.Text,
      text: gt(e.given_name.trim())[0]
    };
  if (!_e(e.given_name) && _e(e.family_name))
    return {
      type: ee.Text,
      text: gt(e.family_name.trim())[0]
    };
  if (_e(e.email)) {
    const [t] = e.email.split("@");
    return {
      type: ee.Text,
      text: t.trim()
    };
  }
  return _e(e.phone_number) ? {
    type: ee.Text,
    text: e.phone_number.slice(-2)
  } : e.id ? {
    type: ee.Icon,
    icon: "user-secret"
  } : {
    type: ee.Icon,
    icon: "user-slash"
  };
}
const Ce = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, ho = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...Ce,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": Ce,
  "user-slash": Ce,
  "map-pin": Ce,
  "web-form": Ce,
  code: Ce,
  history: Ce,
  smile: Ce,
  key: Ce,
  webhooks: Ce,
  plug: Ce
}, ji = {
  24: An["avatar-24"],
  32: An["avatar-32"],
  40: An["avatar-40"]
};
class Fi extends k {
  static defaultProps = {
    size: "32",
    colorGenerator: new Di(ki)
  };
  getAvatarChild(e, t) {
    if (e.type === ee.Icon)
      return /* @__PURE__ */ s.jsx(
        fi,
        {
          size: t,
          icon: e.icon,
          color: e.iconColor
        }
      );
    if (e.type === ee.Image)
      return /* @__PURE__ */ s.jsx(vi, { src: e.src, alt: e.alt });
    if (e.type === ee.Text)
      return /* @__PURE__ */ s.jsx(Ii, { size: t, text: e.text });
  }
  calculateColor(e) {
    if (e.type === ee.Icon) {
      if (e.backgroundColor && e.iconColor)
        return {
          backgroundColor: e.backgroundColor,
          contentColor: e.iconColor
        };
      if (ho[e.icon])
        return ho[e.icon];
    }
    return e.type === ee.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : e.type === ee.Text ? this.props.colorGenerator.generate(e.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: e, size: t } = this.props, n = Ti(this.props), o = this.getAvatarChild(n, t), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          An.root,
          ji[t],
          e
        ),
        children: o
      }
    );
  }
}
const wr = ln(Fi, {
  fallback: null
}), Ni = "h-badge--badge__badge", Pi = "h-badge--badge__badgeSmall", Ri = "h-badge--badge__badgeMedium", Ei = "h-badge--badge__badgePrimary", Li = "h-badge--badge__badgeSecondary", Ai = "h-badge--badge__badgeSuccess", $i = "h-badge--badge__badgeInfo", Oi = "h-badge--badge__badgeWarning", Bi = "h-badge--badge__badgeError", He = {
  badge: Ni,
  badgeSmall: Pi,
  badgeMedium: Ri,
  badgePrimary: Ei,
  badgeSecondary: Li,
  badgeSuccess: Ai,
  badgeInfo: $i,
  badgeWarning: Oi,
  badgeError: Bi
}, Hi = {
  small: He.badgeSmall,
  medium: He.badgeMedium
}, Wi = {
  primary: He.badgePrimary,
  secondary: He.badgeSecondary,
  success: He.badgeSuccess,
  info: He.badgeInfo,
  warning: He.badgeWarning,
  error: He.badgeError
}, Mi = "badge";
function Ek(a) {
  const { className: e, size: t, variant: n, children: o, ...r } = a, i = f(
    He.badge,
    Hi[t],
    Wi[n],
    e
  );
  return /* @__PURE__ */ s.jsx("span", { className: i, ...r, "data-testid": Mi, children: o });
}
const B = W(function({
  flexWrap: e,
  flexDirection: t,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: i,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...e && { flexWrap: e },
    ...t && { flexDirection: t },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...i && { alignContent: i },
    ...l && { gap: js(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(ie, { ...h, style: p, ref: u, children: d });
}), zi = "h-banner--banner__root", Vi = "h-banner--banner__rootWithClose", Ki = "h-banner--banner__iconContainer", Ui = "h-banner--banner__closeIcon", qi = "h-banner--banner__headline", Gi = "h-banner--banner__rootInfo", Yi = "h-banner--banner__icon", Qi = "h-banner--banner__description", Xi = "h-banner--banner__rootWarning", Zi = "h-banner--banner__rootAnnouncement", Ji = "h-banner--banner__rootSuccess", el = "h-banner--banner__rootFail", be = {
  root: zi,
  rootWithClose: Vi,
  iconContainer: Ki,
  closeIcon: Ui,
  headline: qi,
  rootInfo: Gi,
  icon: Yi,
  description: Qi,
  rootWarning: Xi,
  rootAnnouncement: Zi,
  rootSuccess: Ji,
  rootFail: el
}, tl = (a, e) => {
  if (e !== void 0)
    return e;
  switch (a) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Lk = ({
  actionSlot: a,
  className: e,
  description: t,
  headline: n,
  icon: o,
  variant: r,
  onClose: i
}) => {
  const l = f(be.root, e, {
    [be.rootInfo]: r === "info",
    [be.rootAnnouncement]: r === "announcement",
    [be.rootWarning]: r === "warning",
    [be.rootSuccess]: r === "success",
    [be.rootFail]: r === "fail",
    [be.rootWithClose]: i
  }), c = tl(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(B, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: be.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: be.icon }) }),
      /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          H.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: be.headline,
            children: n
          }
        ),
        rn(t, {
          className: be.description
        })
      ] })
    ] }),
    a ? /* @__PURE__ */ s.jsx(B, { gap: "250", margin: "0 0 0 250", children: a }) : i && /* @__PURE__ */ s.jsx(
      q,
      {
        icon: "close",
        variant: "tertiary",
        className: be.closeIcon,
        onClick: i
      }
    )
  ] });
}, nl = "h-buttonGroup--buttonGroup__root", sl = "h-buttonGroup--buttonGroup__button", ol = "h-buttonGroup--buttonGroup__buttonWithBorder", rl = "h-buttonGroup--buttonGroup__buttonWithoutBorder", fn = {
  root: nl,
  button: sl,
  buttonWithBorder: ol,
  buttonWithoutBorder: rl
}, Ak = ({
  className: a,
  children: e,
  variant: t,
  size: n,
  disabled: o
}) => {
  const r = f(fn.root, a);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Ee.map(e, (i) => {
    if (!Se(i))
      return null;
    const l = (t ?? i.props.variant) === "secondary", c = f(i.props.className, {
      [fn.button]: !0,
      [fn.buttonWithBorder]: l,
      [fn.buttonWithoutBorder]: !l
    });
    return rn(i, {
      className: c,
      disabled: o ?? i.props.disabled,
      variant: t ?? i.props.variant,
      size: n
    });
  }) });
}, al = "h-divider--divider__root", il = "h-divider--divider__withChildren", ll = "h-divider--divider__horizontal", cl = "h-divider--divider__vertical", is = {
  root: al,
  withChildren: il,
  horizontal: ll,
  vertical: cl
}, qn = W(function({
  className: e,
  children: t,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: i,
  padding: l,
  ...c
}, d) {
  const h = n ?? (t ? "div" : "hr"), u = f(
    is.root,
    is[o],
    {
      [is.withChildren]: !!t
    },
    e
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": Jt(r) } : {},
    ...i ? { margin: js(i) } : {},
    ...l ? { padding: js(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof t == "string" ? /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", children: t }) : t
    }
  );
}), dl = "h-buttonList--buttonList__buttonList", hl = "h-buttonList--buttonList__inner", uo = {
  buttonList: dl,
  inner: hl
};
let ul = class extends k {
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(qn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: e });
  }
};
const pl = "h-buttonList--item__item", gl = "h-buttonList--item__icon", ml = "h-buttonList--item__button", fl = "h-buttonList--item__buttonDisabled", bl = "h-buttonList--item__buttonCentered", yl = "h-buttonList--item__checkmark", xl = "h-buttonList--item__buttonLoading", _l = "h-buttonList--item__buttonContent", ze = {
  item: pl,
  icon: gl,
  button: ml,
  buttonDisabled: fl,
  buttonCentered: bl,
  checkmark: yl,
  buttonLoading: xl,
  buttonContent: _l
}, Cl = function({
  icon: e,
  children: t,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: i,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const g = f(
    {
      [ze.item]: !0
    },
    n
  ), m = f(
    ze.button,
    {
      [ze.buttonCentered]: r,
      [ze.buttonLoading]: i,
      [ze.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: g, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: m,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: ze.buttonContent, children: [
          e && /* @__PURE__ */ s.jsx(N, { className: ze.icon, name: e }),
          /* @__PURE__ */ s.jsx(H.Paragraph, { variant: o ? "1" : "2", children: t })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: ze.checkmark
          }
        )
      ]
    }
  ) });
}, vl = W(Cl);
class po extends k {
  static get Item() {
    return vl;
  }
  static get Header() {
    return ul;
  }
  static get Divider() {
    return wl;
  }
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(
      {
        [uo.buttonList]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: uo.inner, children: e }) });
  }
}
const wl = () => /* @__PURE__ */ s.jsx(qn, { as: "li", margin: "100 0" }), Sl = "h-checkbox--checkbox__root", Il = "h-checkbox--checkbox__rootDisabled", kl = "h-checkbox--checkbox__rootChecked", Dl = "h-checkbox--checkbox__rootIndeterminate", Tl = "h-checkbox--checkbox__checkbox", jl = "h-checkbox--checkbox__input", mt = {
  root: Sl,
  rootDisabled: Il,
  rootChecked: kl,
  rootIndeterminate: Dl,
  checkbox: Tl,
  input: jl
};
class cn extends k {
  inputRef;
  constructor(e) {
    super(e), this.inputRef = O();
  }
  componentDidMount() {
    const e = this.inputRef.current;
    e && (e.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(e) {
    const t = this.inputRef.current;
    t && e.indeterminate !== this.props.indeterminate && (t.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: e,
      onChange: t,
      id: n,
      name: o,
      checked: r,
      indeterminate: i,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [mt.root]: !0,
        [mt.rootDisabled]: l,
        [mt.rootChecked]: r,
        [mt.rootIndeterminate]: i
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": i ? "mixed" : r,
          className: mt.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: mt.input,
          onChange: t || L,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Fl = "h-collapseCard--collapseCard__card", Nl = {
  card: Fl
}, Vs = Ie({
  isOpen: !1,
  onToggle: L
}), Pl = "h-collapseCard--content__content", Rl = "h-collapseCard--content__contentIsOpen", go = {
  content: Pl,
  contentIsOpen: Rl
};
class El extends k {
  static displayName = "CollapseCard.Content";
  getRootClassName(e) {
    return f(go.content, this.props.className, {
      [go.contentIsOpen]: e
    });
  }
  render() {
    const { children: e, className: t, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Vs.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: e
      }
    ) : null });
  }
}
function Gn(a) {
  return {
    role: "button",
    onClick: a,
    onKeyDown: (e) => {
      e.key === "Enter" && a(e);
    }
  };
}
const Ll = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Al = ["Escape", "Esc"], Yn = (a) => Ll.includes(a), Ft = (a) => Al.includes(a), $l = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], mo = $l.join(
  ':not([hidden]):not([tabindex="-1"]),'
), Sr = _r(function({
  containerRef: e,
  children: t,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: i,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = Q(null), u = Q(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = e || h;
  Cr(
    "Tab",
    (b) => {
      if (!d)
        return;
      const y = p.current?.querySelectorAll(mo), v = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!y)
        return;
      const w = y[0], S = y[y.length - 1];
      if (!b.shiftKey && document.activeElement === S || !b.shiftKey && l && v)
        return w?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === w || b.shiftKey && l && v) && (S?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const g = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(mo)?.focus() : o.current && o.current.focus());
    });
  }, m = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return ht(() => {
    c || (g(), i?.(!0));
  }), tt(() => {
    c || (m(), i?.(!1));
  }), Je(() => {
    n === !0 ? (u.current = document.activeElement, g()) : n === !1 && m(), i?.(!!n);
  }, [n]), e ? /* @__PURE__ */ s.jsx(s.Fragment, { children: t }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: t });
}), Ol = "h-dropdown--dropdown__dropdown", Bl = "h-dropdown--dropdown__dropdownOpen", Hl = "h-dropdown--dropdown__dropdownFromRight", Wl = "h-dropdown--dropdown__dropdownFromBottom", Ml = "h-dropdown--dropdown__dropdownAnimating", zl = "h-dropdown--dropdown__dropdownFixed", Vl = "h-dropdown--dropdown__loader", Kl = "h-dropdown--dropdown__error", Ul = "h-dropdown--dropdown__errorIcon", $e = {
  dropdown: Ol,
  dropdownOpen: Bl,
  dropdownFromRight: Hl,
  dropdownFromBottom: Wl,
  dropdownAnimating: Ml,
  dropdownFixed: zl,
  loader: Vl,
  error: Kl,
  errorIcon: Ul
};
class nt extends k {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  win;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(e) {
    super(e), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = O(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.win = this.getWindow(), this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const e = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: e.width,
        oldHeight: e.height
      };
    }
    return null;
  }
  componentDidUpdate(e, t, n) {
    const { isOpen: o, isLoading: r, errorMessage: i, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== e.isLoading || i !== e.errorMessage)) {
      const d = r !== e.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== e.isOpen && (this.win[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && this.win[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && this.win[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  getWindow() {
    return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentWillUnmount() {
    this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: e } = this.props;
    e();
  }
  animate(e, t, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: e,
        height: t,
        animating: !n
      }), this.timeoutAnimationStart = this.win.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = this.win.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(e) {
    if (!this.dropdownRef || !e.target) return;
    const t = e.target, { onClose: n } = this.props;
    this.dropdownRef.current && t !== this.dropdownRef.current && !this.dropdownRef.current.contains(t) && n();
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const e = this.dropdownRef.current.parentElement.getBoundingClientRect(), t = e.left + e.width / 2, n = e.top + e.height / 2, o = this.getWindow(), r = o.innerWidth / 2, i = o.innerHeight / 2;
      this.setState({
        fromRight: t > r,
        fromBottom: n > i,
        fromTop: n <= i
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: e, fromBottom: t, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {}, i = this.getWindow();
      return e ? r.right = `${i.innerWidth - o.right}px` : r.left = `${o.left}px`, t && (r.bottom = `${i.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: e,
      children: t,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: i,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...g
    } = this.props, { fromRight: m, fromBottom: b, animating: y, width: v, height: w } = this.state, S = f(
      {
        [$e.dropdown]: !0,
        [$e.dropdownOpen]: o,
        [$e.dropdownFromRight]: m,
        [$e.dropdownFromBottom]: b,
        [$e.dropdownAnimating]: y,
        [$e.dropdownFixed]: c
      },
      e
    );
    let C = { ...d };
    v && w && (C.width = `${v}px`, C.height = `${w}px`), c && (C = { ...C, ...this.getFixedPosition() });
    const x = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...g,
        className: S,
        ref: this.dropdownRef,
        style: C,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: $e.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: $e.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: $e.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          x && /* @__PURE__ */ s.jsx(
            Sr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: t
            }
          )
        ]
      }
    );
  }
}
const ql = "h-dropdownButton--dropdownButton__root", Gl = "h-dropdownButton--dropdownButton__wrapper", ls = {
  root: ql,
  wrapper: Gl
}, dn = Ie({
  toggleDropdown: L,
  openDropdown: L,
  closeDropdown: L,
  dropdownOpen: !1
});
class Nt extends xe {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  win;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(e) {
    super(e);
    const t = e.show ?? !1;
    this.state = {
      dropdownOpen: t,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.win = window, this.buttonWrapperRef = O(), this.buttonRef = O(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: t
    };
  }
  getWindow() {
    return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentDidMount() {
    this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(e) {
    this.toggleDropdownIfNeeded(e);
  }
  componentWillUnmount() {
    this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(e) {
    return e.show !== this.props.show;
  }
  handleKeyDown(e) {
    Ft(e.key) && this.state.dropdownOpen && (e.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(e) {
    this.shouldToggleDropdown(e) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(e, t = 0) {
    return this.win.setTimeout(e, t);
  }
  handleDropdownToggle() {
    const { dropdownOpen: e } = this.state, t = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!e);
      });
    }, n = this.shouldDropdownBeAboveButton();
    e ? t() : this.setState(
      { fromBottom: n },
      t
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(e) {
    const { allowEscClose: t, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, i = e ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: i }, this.setState({ dropdownOpen: i, pristine: !1 }), t && (i ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(i, o);
  }
  shouldDropdownBeAboveButton() {
    const e = this.buttonWrapperRef.current?.getBoundingClientRect();
    return e ? e.bottom > this.getWindow().innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: e,
      buttonProps: t,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: i,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: t?.className,
        ...t,
        onMouseEnter: i,
        onMouseLeave: l,
        ...Gn(this.handleDropdownToggle),
        children: n
      }
    ) : e && !n ? /* @__PURE__ */ s.jsx(
      q,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: i,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      te,
      {
        ref: this.buttonRef,
        icon: e,
        variant: "secondary",
        onMouseEnter: i,
        onMouseLeave: l,
        ...t,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: e,
      children: t,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: i,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: g,
      onMouseEnter: m,
      onMouseLeave: b,
      allowEscClose: y,
      destroyOnClose: v,
      ...w
    } = this.props, { dropdownOpen: S, pristine: C } = this.state, x = f({ [ls.root]: ls.root }, e);
    return /* @__PURE__ */ s.jsx(dn.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ...w, className: x, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: ls.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        nt,
        {
          restoreFocus: this.buttonRef,
          ...i,
          isOpen: S,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: g,
          children: (S || !C && !v) && o
        }
      )
    ] }) }) });
  }
}
const Yl = "h-collapseCard--header__header", Ql = "h-collapseCard--header__headerOpen", Xl = "h-collapseCard--header__headerHasDropdown", Zl = "h-collapseCard--header__headerStatic", Jl = "h-collapseCard--header__titleWrapper", ec = "h-collapseCard--header__title", tc = "h-collapseCard--header__chevronPlaceholder", Ve = {
  header: Yl,
  headerOpen: Ql,
  headerHasDropdown: Xl,
  headerStatic: Zl,
  titleWrapper: Jl,
  title: ec,
  chevronPlaceholder: tc
};
class nc extends k {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(e) {
    const { dropdown: t, className: n, nonCollapsible: o } = this.props;
    return f(
      Ve.header,
      {
        [Ve.headerOpen]: e,
        [Ve.headerHasDropdown]: !!t,
        [Ve.headerStatic]: !!o
      },
      n
    );
  }
  render() {
    const {
      children: e,
      className: t,
      title: n,
      avatar: o,
      dropdown: r,
      onDropdownToggle: i,
      dropdownTrigger: l,
      slotBeforeTitle: c,
      slotAfterTitle: d,
      wrap: h = "nowrap",
      compact: u,
      nonCollapsible: p,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(Vs.Consumer, { children: ({ isOpen: m, onToggle: b }) => {
      const y = this.getRootClassName(m);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...g,
          onClick: p ? void 0 : b,
          className: y,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(
              B,
              {
                alignItems: "center",
                padding: u ? "200 0" : "400 0",
                className: Ve.titleWrapper,
                children: [
                  c,
                  o,
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: Ve.titleWrapper,
                      onMouseDown: (v) => v.stopPropagation(),
                      children: /* @__PURE__ */ s.jsx(
                        H.Paragraph,
                        {
                          variant: "1",
                          wrap: h,
                          className: Ve.title,
                          children: e
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(B, { alignItems: "center", children: [
              d,
              !!r && /* @__PURE__ */ s.jsx(
                Nt,
                {
                  onClick: (v) => v.stopPropagation(),
                  icon: l ? void 0 : "dots-h",
                  dropdown: r,
                  buttonProps: { variant: "tertiary" },
                  onToggle: i,
                  children: l
                }
              ),
              p ? (
                // Reserve the chevron's footprint so a slotAfter (e.g. a
                // timestamp) stays column-aligned with collapsible siblings.
                /* @__PURE__ */ s.jsx("span", { className: Ve.chevronPlaceholder, "aria-hidden": !0 })
              ) : /* @__PURE__ */ s.jsx(
                q,
                {
                  icon: m ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const sc = "h-collapseCard--line__line", oc = "h-collapseCard--line__lineHasLabel", rc = "h-collapseCard--line__value", ac = "h-collapseCard--line__lineHideOverflow", bn = {
  line: sc,
  lineHasLabel: oc,
  value: rc,
  lineHideOverflow: ac
};
class ic extends k {
  render() {
    const { label: e, children: t, className: n, hideOverflow: o, ...r } = this.props, i = f(
      {
        [bn.line]: !0,
        [bn.lineHasLabel]: !!e,
        [bn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: i, children: [
      e && /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: e }),
      e ? /* @__PURE__ */ s.jsx("span", { className: bn.value, children: t }) : t
    ] });
  }
}
const lc = "h-collapseCard--readMore__readMore", cc = {
  readMore: lc
};
class dc extends k {
  render() {
    const { onClick: e, url: t, children: n, className: o, ...r } = this.props, i = f({ [cc.readMore]: !0 }, o);
    return t ? /* @__PURE__ */ s.jsx(H.ExternalLink, { ...r, href: t, className: i, children: n }) : /* @__PURE__ */ s.jsx(
      te,
      {
        variant: "secondary",
        ...r,
        onClick: e,
        className: i,
        children: n
      }
    );
  }
}
const hc = "h-collapseCard--status__status", uc = {
  status: hc
};
class pc extends k {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f({ [uc.status]: !0 }, t);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: e });
  }
}
class gc extends k {
  static defaultProps = {
    isOpen: !1
  };
  constructor(e) {
    super(e), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = ic;
  static Header = nc;
  static Content = El;
  static ReadMore = dc;
  static Status = pc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(e) {
    return e?.type?.displayName === "CollapseCard.Header" && Se(e);
  }
  isContent(e) {
    return e?.type?.displayName === "CollapseCard.Content" && Se(e);
  }
  getHeaderChildren() {
    return Ee.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Ee.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: e } = this.props;
    return f(Nl.card, e);
  }
  render() {
    const {
      className: e,
      onToggle: t,
      isOpen: n,
      children: o,
      containerRef: r,
      ...i
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Vs.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            ...i,
            ref: r,
            className: this.getRootClassName(),
            children: [
              this.getHeaderChildren(),
              this.getContentChildren()
            ]
          }
        )
      }
    );
  }
}
const Ok = ln(gc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), mc = "h-collapsible--collapsible__root", fc = "h-collapsible--collapsible__collapsible", bc = "h-collapsible--collapsible__children", cs = {
  root: mc,
  collapsible: fc,
  children: bc
};
class Bk extends k {
  childrenRef;
  resizeObserver = null;
  constructor(e) {
    super(e), this.childrenRef = O(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: e.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(e) {
    e.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const e = this.childrenRef.current;
    e && this.setState({
      childrenHeight: e.offsetHeight
    });
  }
  render() {
    const { className: e, header: t, isOpen: n, children: o, ...r } = this.props, { childrenHeight: i } = this.state, l = f(
      {
        [cs.root]: !0
      },
      e
    ), c = {
      maxHeight: n ? i : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: t }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: cs.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: cs.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const yc = "h-colorPicker--colorPicker__root", xc = {
  root: yc
}, _c = "h-colorPicker-input--colorPickerInput__input", Cc = {
  input: _c
}, vc = ({
  className: a,
  ...e
}) => /* @__PURE__ */ s.jsx(Me, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  Sa,
  {
    className: f(Cc.input, a),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...e
  }
) }), wc = "h-colorPicker-presets--colorPickerPresets__root", Sc = {
  root: wc
}, Ic = "h-colorPicker-presets-preset--colorPickerPreset__root", kc = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Dc = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", Tc = "h-colorPicker-presets-preset--colorPickerPreset__preset", yn = {
  root: Ic,
  rootIsSelected: kc,
  rootAlpha: Dc,
  preset: Tc
}, jc = ({
  color: a,
  onSelect: e,
  isSelected: t,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(yn.root, o, {
      [yn.rootIsSelected]: t,
      [yn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": a,
        className: yn.preset,
        style: { backgroundColor: a },
        onClick: () => {
          e?.(a);
        }
      }
    )
  }
);
Os([Bs]);
const Fc = ({
  presets: a,
  className: e,
  onChange: t,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  B,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(Sc.root, e),
    ...r,
    children: a.map((i) => /* @__PURE__ */ s.jsx(
      jc,
      {
        onSelect: t,
        color: i,
        isSelected: n === (i.startsWith("#") ? i : Bn(i).toHex()),
        alpha: o
      },
      i
    ))
  }
);
Os([Bs]);
const Nc = ({
  onChange: a,
  color: e,
  alpha: t,
  className: n,
  ...o
}) => {
  const r = F((i) => {
    setTimeout(() => {
      a?.(Bn(i).toHex());
    });
  }, []);
  return t ? /* @__PURE__ */ s.jsx(
    ka,
    {
      className: n,
      color: Bn(e ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    Ia,
    {
      className: n,
      color: e,
      onChange: a,
      ...o
    }
  );
};
Os([Bs]);
const Pc = "colorPickerTestId", Qn = ({
  className: a,
  color: e,
  onChange: t,
  alpha: n,
  children: o,
  ...r
}) => {
  const [i, l] = V();
  return G(() => {
    const c = e?.startsWith("#") ? e : Bn(e ?? "").toHex();
    l(c);
  }, [e]), /* @__PURE__ */ s.jsx(
    B,
    {
      flexDirection: "column",
      gap: "250",
      className: f(xc.root, a),
      "data-testid": Pc,
      ...r,
      children: Ee.map(
        o,
        (c) => Se(c) && rn(c, {
          onChange: t,
          color: i,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Qn.Input = vc;
Qn.Sliders = Nc;
Qn.Presets = Fc;
const Rc = "h-columns--columns__root", Ec = {
  root: Rc
}, Lc = "1fr", Ac = W(function({ as: e = "div", children: t, className: n, style: o, ...r }, i) {
  const c = Ee.toArray(t).map((d) => d.props.size ?? Lc).join(" ");
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...r,
      ref: i,
      className: f(Ec.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: t
    }
  );
}), $c = "h-columns-column--column__root", Oc = {
  root: $c
}, Bc = "h-columns-column-row--columnRow__root", Hc = "h-columns-column-row--columnRow__noMinHeight", Wc = "h-columns-column-row--columnRow__noVerticalPadding", Mc = "h-columns-column-row--columnRow__noHorizontalPadding", zc = "h-columns-column-row--columnRow__borderTop", Vc = "h-columns-column-row--columnRow__borderBottom", Kc = "h-columns-column-row--columnRow__scrollable", Uc = "h-columns-column-row--columnRow__slottable", Ke = {
  root: Bc,
  noMinHeight: Hc,
  noVerticalPadding: Wc,
  noHorizontalPadding: Mc,
  borderTop: zc,
  borderBottom: Vc,
  scrollable: Kc,
  slottable: Uc
}, qc = 1, Gc = W(function({
  as: e = "div",
  children: t,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: i,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...g
}, m) {
  const b = f(n, Ke.root, {
    [Ke.slottable]: u,
    [Ke.noVerticalPadding]: u ?? o,
    [Ke.noHorizontalPadding]: r,
    [Ke.borderTop]: l,
    [Ke.borderBottom]: c,
    [Ke.scrollable]: d,
    [Ke.noMinHeight]: i
  });
  return /* @__PURE__ */ s.jsx(
    e,
    {
      ...g,
      ref: m,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? qc : void 0
      },
      children: t
    }
  );
}), Yc = "h-columns-column-slot--columnSlot__root", Qc = "h-columns-column-slot--columnSlot__noVerticalPadding", fo = {
  root: Yc,
  noVerticalPadding: Qc
}, Xc = ({
  children: a,
  className: e,
  noVerticalPadding: t,
  placement: n = "start"
}) => {
  const o = f(fo.root, e, {
    [fo.noVerticalPadding]: t
  });
  return /* @__PURE__ */ s.jsx(
    B,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: a
    }
  );
}, pe = ({
  as: a,
  children: e,
  className: t
}) => /* @__PURE__ */ s.jsx(
  B,
  {
    as: a,
    flexDirection: "column",
    className: f(Oc.root, t),
    children: e
  }
);
pe.Row = Gc;
pe.Slot = Xc;
const Zc = "h-copyToClipboard--copyToClipboard__copyToClipboard", Jc = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", bo = {
  copyToClipboard: Zc,
  copyToClipboardTooltip: Jc
};
class ed extends xe {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(e) {
    super(e), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(e) {
    const t = document.body;
    if (!e || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = e, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", t.appendChild(n), n.select(), document.execCommand("copy"), t.removeChild(n);
  }
  handleClick(e) {
    const { disabled: t, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    t || (typeof r == "function" && r(e), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: e, children: t, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, i = f(
      bo.copyToClipboard,
      { [bo.copyToClipboardTooltip]: r && o },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: i, children: Ee.map(t, (l) => Se(l) ? rn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class Hk extends k {
  render() {
    const { buttonProps: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx(ed, { ...t, children: /* @__PURE__ */ s.jsx(q, { icon: "copy", variant: "secondary", ...e }) });
  }
}
const td = "h-simplePagination--simplePagination__paginationButton", yo = {
  paginationButton: td
}, nd = "simplePaginationTestId", sd = ({
  nextButtonClick: a = L,
  previousButtonClick: e = L,
  nextButtonText: t = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: i = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": nd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    te,
    {
      disabled: r || h,
      onClick: e,
      variant: "secondary",
      ...d,
      className: f(
        yo.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !i && /* @__PURE__ */ s.jsx(
    te,
    {
      disabled: o || h,
      onClick: a,
      variant: "secondary",
      ...c,
      className: f(
        yo.paginationButton,
        c?.className
      ),
      children: h ? u : t
    }
  )
] }), Xn = Ie(
  void 0
);
var de = /* @__PURE__ */ ((a) => (a.Foot = "table-foot", a.Body = "table-body", a.Head = "table-head", a.Row = "table-row", a.PaginationRow = "table-pagination-row", a.Td = "table-body-cell", a.Th = "table-header-cell", a.RowExpansionTrigger = "table-row-expansion-trigger", a.LoadingRow = "table-loading-row", a.LoadingFailedRow = "table-loading-failed-row", a.EmptyRow = "table-empty-row", a))(de || {});
const od = "h-table-tfoot--tfoot__root", rd = "h-table-tfoot--tfoot__rootIsLoading", xo = {
  root: od,
  rootIsLoading: rd
}, Ir = Ie(
  void 0
), _o = ({ className: a, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(Xn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(Ir.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...t,
    ref: n,
    className: f(
      {
        [xo.rootIsLoading]: o?.status.loading
      },
      xo.root,
      a
    ),
    "data-testid": de.Foot,
    children: e
  }
) }) }), ad = Object.assign(W(_o), { name: _o.name }), id = "h-table-thead--thead__root", ld = "h-table-thead--thead__rootIsLoading", Co = {
  root: id,
  rootIsLoading: ld
}, kr = Ie(
  void 0
), vo = ({ className: a, ...e }, t) => /* @__PURE__ */ s.jsx(Xn.Consumer, { children: (n) => {
  const o = f(Co.root, a, {
    [Co.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(kr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...e,
      ref: t,
      className: o,
      "data-testid": de.Head
    }
  ) });
} }), cd = Object.assign(W(vo), { name: vo.name }), Pt = (a) => {
  const e = We(Xn);
  if (!e)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const t = We(kr) || {
    isTableHead: !1
  }, n = We(Ir) || {
    isTableFoot: !1
  };
  return a.children({
    ...e,
    ...t,
    ...n
  });
}, dd = "h-table-tableFooter--tableFooter__root", hd = "h-table-tableFooter--tableFooter__rootIsLoading", wo = {
  root: dd,
  rootIsLoading: hd
}, So = ({ children: a, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Pt, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [wo.rootIsLoading]: o.loading
      },
      wo.root,
      e
    ),
    ...t,
    children: a
  }
) }), Ks = Object.assign(W(So), {
  name: So.name
});
function ud(a) {
  return Ee.toArray(a).reduce(
    (e, t) => {
      const n = t;
      return n.type === Ks ? e.footers.push(n) : e.children.push(n), e;
    },
    { children: [], footers: [] }
  );
}
var Wn = /* @__PURE__ */ ((a) => (a.PageNumber = "page-number", a.PrevPageButton = "prev-page-button", a.NextPageButton = "next-page-button", a))(Wn || {});
const pd = "h-pagination--pageNumber__button", gd = "h-pagination--pageNumber__text", md = "h-pagination--pageNumber__textSelected", ds = {
  button: pd,
  text: gd,
  textSelected: md
}, fd = ({
  number: a,
  isSelected: e = !1,
  onClick: t
}) => {
  const n = f(ds.text, {
    [ds.textSelected]: e
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    te,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => t(a),
      "data-testid": Wn.PageNumber,
      className: ds.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: a })
    }
  ) });
}, bd = "h-pagination--pagination__root", yd = "h-pagination--pagination__pageNumberSeparatorWrapper", Io = {
  root: bd,
  pageNumberSeparatorWrapper: yd
};
class xd extends xe {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(e) {
    super(e), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: e, pageCount: t, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [e, t, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(e) {
    const { currentPage: t, onPageChange: n } = this.props;
    e !== t && n(e);
  }
  areAllPagedDisplayable() {
    const { pageCount: e, pageRangeDisplayed: t } = this.props;
    return t >= e;
  }
  leadingTruncationIsNeeded() {
    const { start: t } = this.calculateMiddlePagesRange();
    return t - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: e } = this.props, { start: t, length: n } = this.calculateMiddlePagesRange(), o = t - 1 + n;
    return e - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: e } = this.props;
    return e - 2;
  }
  calculateMiddlePagesRange(e) {
    const { pageCount: t, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (e?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: Ln(
      n - r,
      2,
      t - o
    ), length: o };
  }
  createPageNumbers(e, t = 1) {
    return Array.from({ length: e }, (n, o) => o + t);
  }
  renderPageNumbers(e, t = 1) {
    return this.createPageNumbers(e, t).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(e) {
    const { currentPage: t } = this.props, n = e === t;
    return /* @__PURE__ */ s.jsx(
      fd,
      {
        number: e,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      e
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(e = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: Io.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(N, { name: "dots-h" }) }, `gap-${e}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: e } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(e)] : this.renderSinglePageNumber(e);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: e, length: t } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(t, e);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: e } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(Io.root, e), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        q,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Wn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        q,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Wn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const ko = ({ children: a, ...e }, t) => /* @__PURE__ */ s.jsx(Pt, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Ks, { children: /* @__PURE__ */ s.jsx("div", { ref: t, ...e, "data-testid": de.PaginationRow, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  xd,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), _d = Object.assign(W(ko), {
  name: ko.name
}), Cd = "h-table-tbody--tbody__root", vd = "h-table-tbody--tbody__rootIsLoading", wd = "h-table-tbody--tbody__rootIsLoadingFade", hs = {
  root: Cd,
  rootIsLoading: vd,
  rootIsLoadingFade: wd
}, Sd = "h-emptyState--emptyState__textWrapper", Id = "h-emptyState--emptyState__rootSmall", kd = "h-emptyState--emptyState__rootLarge", us = {
  textWrapper: Sd,
  rootSmall: Id,
  rootLarge: kd
}, Dd = ({
  className: a,
  title: e,
  description: t,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: i
}) => {
  const l = f(
    {
      [us.rootSmall]: r === "small",
      [us.rootLarge]: r === "large"
    },
    a
  );
  return /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: Jt(o) }),
        /* @__PURE__ */ s.jsxs(
          B,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: us.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "1", children: e }),
              /* @__PURE__ */ s.jsx(
                H.Paragraph,
                {
                  variant: "2",
                  as: typeof t == "string" ? "p" : "div",
                  children: t
                }
              )
            ]
          }
        ),
        i?.children && /* @__PURE__ */ s.jsx(te, { ...i })
      ]
    }
  );
};
function Td(a) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": de.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(Dd, { ...a }) }) }) });
}
function jd({
  onRetry: a,
  ...e
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": de.LoadingFailedRow, ...e, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", children: "Something went wrong..." }),
        a && /* @__PURE__ */ s.jsx(te, { variant: "tertiary", onClick: a, children: "Try again" })
      ]
    }
  ) }) });
}
function Fd({
  ...a
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": de.LoadingRow, ...a, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(Ws, {}),
        /* @__PURE__ */ s.jsx(ie, { margin: "300", children: /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const Do = ({ children: a, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Pt, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: i, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...t,
      "data-testid": de.Body,
      ref: n,
      className: f(
        {
          [hs.rootIsLoading]: o,
          [hs.rootIsLoadingFade]: o && c === "fade"
        },
        hs.root,
        e
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(Fd, {}),
        d && /* @__PURE__ */ s.jsx(jd, { onRetry: i }),
        l && /* @__PURE__ */ s.jsx(Td, { ...l }),
        h && a
      ]
    }
  );
} }), Nd = Object.assign(W(Do), { name: Do.name }), Pd = "h-table-td--td__root", Rd = "h-table-td--td__rootExtraPaddingForFirstChild", Ed = "h-table-td--td__rootStickyFooterTd", ps = {
  root: Pd,
  rootExtraPaddingForFirstChild: Rd,
  rootStickyFooterTd: Ed
}, To = ({ className: a, children: e, ...t }, n) => /* @__PURE__ */ s.jsx(Pt, { children: ({ rows: o, presentation: r, isTableFoot: i }) => {
  const l = f(
    ps.root,
    {
      [ps.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [ps.rootStickyFooterTd]: r.stickyFooter === !0 && i === !0
    },
    a
  );
  return /* @__PURE__ */ s.jsx(
    ie,
    {
      as: "td",
      ref: n,
      className: l,
      ...t,
      "data-testid": de.Td,
      children: e
    }
  );
} }), lt = Object.assign(W(To), { name: To.name }), Ld = "h-table-th--th__root", Ad = "h-table-th--th__rootSticky", $d = "h-table-th--th__rootShowBG", Od = "h-table-th--th__rootClickable", Bd = "h-table-th--th__icon", Hd = "h-table-th--th__contentWrapper", Wd = "h-table-th--th__tooltip", st = {
  root: Ld,
  rootSticky: Ad,
  rootShowBG: $d,
  rootClickable: Od,
  icon: Bd,
  contentWrapper: Hd,
  tooltip: Wd
};
class jo extends k {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (e) => e === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: e } = this.props, { context: t } = this;
    return {
      sortByThisColumn: t?.sorting.sortStatus?.sortBy === e,
      sortDirection: t?.sorting.sortStatus?.direction,
      columnIsSortable: t?.sorting.sortable && !ye(e) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(e) {
    const { sortByThisColumn: t, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: e,
      direction: "asc"
    };
    if (!t)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: e,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: e } = this.props, { context: t } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      e?.(n), o && !ye(r) && t?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(e) {
    return e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: st.icon,
        name: e === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Pt, { children: (e) => {
      this.context = e;
      const { sorting: t, presentation: n } = e;
      t.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: i,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), g = f(
        st.root,
        {
          [st.rootClickable]: u,
          [st.rootSticky]: n.stickyHeader,
          [st.rootShowBG]: n.headerWithBackground
        },
        o
      ), m = f({
        [st.tooltip]: i
      });
      return /* @__PURE__ */ s.jsx(
        ie,
        {
          as: "th",
          ...d,
          ref: c,
          className: g,
          onClick: this.getClickHandler(),
          "data-testid": de.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: st.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(le, { content: i, disabled: !i, children: /* @__PURE__ */ s.jsx("span", { className: m, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Fs = Object.assign(
  W(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(jo, { ...e, thRef: t });
    }
  ),
  { name: jo.name }
), Md = (a) => a === !1, zd = "h-table-tr--tr__trHoverable", Vd = "h-table-tr--tr__expansionTriggerWrapper", Kd = "h-table-tr--tr__expansionTriggerWrapperExpanded", Ud = "h-table-tr--tr__checkboxCell", qd = "h-table-tr--tr__checkboxCellExpanded", Gd = "h-table-tr--tr__expandedRowContentWrapper", ve = {
  trHoverable: zd,
  expansionTriggerWrapper: Vd,
  expansionTriggerWrapperExpanded: Kd,
  checkboxCell: Ud,
  checkboxCellExpanded: qd,
  expandedRowContentWrapper: Gd
}, Yd = ({
  rowId: a,
  isExpandable: e,
  isExpanded: t,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: i,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [ve.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": de.Row,
        children: [
          e && /* @__PURE__ */ s.jsx(
            lt,
            {
              className: f(ve.expansionTriggerWrapper, {
                [ve.expansionTriggerWrapperExpanded]: t
              }),
              children: o && /* @__PURE__ */ s.jsx(
                q,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right",
                  "data-testid": de.RowExpansionTrigger,
                  onClick: () => {
                    ye(a) || n(a);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            lt,
            {
              className: f(ve.checkboxCell, {
                [ve.checkboxCellExpanded]: t
              }),
              children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: i,
                  name: `selection-trigger-${a}`,
                  id: `selection-trigger-${a}`,
                  onChange: () => {
                    ye(a) || l(a);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    e && t && /* @__PURE__ */ s.jsxs("tr", { "data-testid": de.Row, children: [
      /* @__PURE__ */ s.jsx(lt, { className: ve.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(lt, { className: ve.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        lt,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: ve.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Qd = ({
  isExpandable: a,
  children: e,
  trRef: t,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: t, "data-testid": de.Row, children: [
  a && /* @__PURE__ */ s.jsx(lt, { className: ve.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e
] }), Xd = ({
  isExpandable: a,
  isSelectable: e,
  allRowsSelected: t,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: i,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: i, "data-testid": de.Row, children: [
  a && /* @__PURE__ */ s.jsx(Fs, { className: ve.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  e && /* @__PURE__ */ s.jsx(Fs, { className: ve.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    cn,
    {
      checked: t,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Fo extends k {
  context = void 0;
  isRowExpanded(e, t) {
    return e.includes(t);
  }
  hasSelectableRow() {
    const { rowId: e } = this.props;
    return this.context?.rows.selectableRows === !0 && !ye(e);
  }
  hasExpandableRow() {
    const { expandableContent: e, rowId: t } = this.props;
    return this.context?.rows.expandableRows === !0 && !ye(e) && !ye(t);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(Md);
  }
  rowIdIsPresent(e) {
    return !ye(e);
  }
  render() {
    const { children: e, expandableContent: t, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Pt, { children: (r) => {
      this.context = r;
      const { rows: i } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          Xd,
          {
            ...o,
            isExpandable: i.expandableRows,
            isSelectable: i.selectableRows,
            allRowsSelected: i.allRowsSelected,
            allRowsSelectedIndeterminate: i.allRowsSelectedIndeterminate,
            onAllRowsSelect: i.onAllRowsSelect,
            children: e
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Qd, { ...o, isExpandable: i.expandableRows, children: e });
      const l = ye(n) ? !1 : this.isRowExpanded(i.expandedRows, n), c = ye(n) ? !1 : i.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        Yd,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: i.onRowSelect,
          isExpandable: i.expandableRows,
          expandableContent: t,
          isSelectable: i.selectableRows,
          onExpansionToggle: i.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: e
        }
      );
    } });
  }
}
const Zd = Object.assign(
  W(function(e, t) {
    return /* @__PURE__ */ s.jsx(Fo, { ...e, trRef: t });
  }),
  { name: Fo.name }
), Jd = "h-table--table__wrapper", eh = "h-table--table__wrapperIsFramed", th = "h-table--table__wrapperIsLoading", nh = "h-table--table__innerWrapper", sh = "h-table--table__wrapperIsDisabled", oh = "h-table--table__table", ft = {
  wrapper: Jd,
  wrapperIsFramed: eh,
  wrapperIsLoading: th,
  innerWrapper: nh,
  wrapperIsDisabled: sh,
  table: oh
};
class Mn extends k {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(e) {
    super(e), this.state = {
      expandedRows: e.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    B,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(H.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(e) {
    this.state.expandedRows.includes(e) ? this.setState(({ expandedRows: t }) => ({
      expandedRows: t.filter((n) => n !== e)
    })) : this.setState(({ expandedRows: t }) => ({
      expandedRows: [...t, e]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: e,
        stickyHeader: t,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: i,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: g
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!e,
        stickyHeader: !!t,
        stickyFooter: !!n,
        hoverable: !!g
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? L
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? L,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!i,
        selectedRowIds: i?.selectedRowIds ?? [],
        onRowSelect: i?.onRowSelect ?? L,
        onAllRowsSelect: i?.onAllRowsSelect ?? L,
        allRowsSelected: i?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: i?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: e,
      className: t,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: i,
      nativeProps: l,
      tableRef: c
    } = this.props, d = ud(n), h = f(ft.wrapper, o?.className, {
      [ft.wrapperIsFramed]: e,
      [ft.wrapperIsLoading]: this.props.loading,
      [ft.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [ft.innerWrapper]: !0
      },
      i
    ), p = f(ft.table, t), g = this.getContextValue();
    return /* @__PURE__ */ s.jsx(jt, { fallback: Mn.fallback, children: /* @__PURE__ */ s.jsx(Xn.Provider, { value: g, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      g.pagination.paginated && /* @__PURE__ */ s.jsx(_d, {}),
      !g.pagination.paginated && d.footers
    ] }) }) });
  }
}
const ge = Object.assign(
  W(
    function(e, t) {
      return /* @__PURE__ */ s.jsx(Mn, { ...e, tableRef: t });
    }
  ),
  {
    name: Mn.name,
    Thead: cd,
    Tbody: Nd,
    Tfoot: ad,
    Tr: Zd,
    Th: Fs,
    Td: lt,
    Footer: Ks
  }
), rh = "h-helpIcon--helpIcon__infoIcon", ah = {
  infoIcon: rh
};
class Us extends k {
  render() {
    const {
      side: e,
      text: t,
      title: n,
      disabled: o,
      requireClick: r,
      className: i,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      le,
      {
        head: n,
        content: t,
        disabled: o,
        side: e,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(ah.infoIcon, i), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const Dr = ({
  columns: a
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: a.map(({ label: e, style: t, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(ge.Th, { columnId: o || e, style: t, children: [
  e,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Us, { side: "bottom", ...n })
] }, e || r)) }), ih = ({
  columns: a,
  data: e
}) => /* @__PURE__ */ s.jsxs(ge, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(ge.Thead, { children: /* @__PURE__ */ s.jsx(ge.Tr, { children: /* @__PURE__ */ s.jsx(Dr, { columns: a }) }) }),
  /* @__PURE__ */ s.jsx(ge.Tbody, { children: e.map((t, n) => /* @__PURE__ */ s.jsx(ge.Tr, { children: a.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(ge.Td, { children: o(t) }, r)) }, n)) })
] }), lh = ({
  data: a,
  rowId: e,
  columns: t,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  ge.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      ih,
      {
        data: o(a),
        columns: n
      }
    ),
    rowId: e,
    children: t.map(({ selector: r }, i) => /* @__PURE__ */ s.jsx(ge.Td, { children: r(a) }, i))
  }
), Wk = ({
  columns: a,
  subTableColumns: e,
  data: t,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: i,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: g
}) => {
  const m = a.filter((b) => b.sortable).reduce(
    (b, y) => y.columnId ? [...b, y.columnId] : b,
    []
  );
  return m.length && l && (l.sortableColumns = m), /* @__PURE__ */ s.jsxs(
    ge,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(e && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: g,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(ge.Thead, { children: /* @__PURE__ */ s.jsx(ge.Tr, { children: /* @__PURE__ */ s.jsx(Dr, { columns: a }) }) }),
        /* @__PURE__ */ s.jsx(ge.Tbody, { children: t.map((b, y) => /* @__PURE__ */ s.jsx(
          lh,
          {
            rowId: u ? u(b) : y,
            data: b,
            columns: a,
            subTableDataSelector: n,
            subTableColumns: e
          },
          y
        )) }),
        i && /* @__PURE__ */ s.jsx(ge.Footer, { children: /* @__PURE__ */ s.jsx(sd, { ...i }) })
      ]
    }
  );
}, ch = "h-datePickerOld--datePickerDay__root", dh = "h-datePickerOld--datePickerDay__rootActive", hh = "h-datePickerOld--datePickerDay__rootDisabled", uh = "h-datePickerOld--datePickerDay__rootDim", ph = "h-datePickerOld--datePickerDay__label", $t = {
  root: ch,
  rootActive: dh,
  rootDisabled: hh,
  rootDim: uh,
  label: ph
};
class gh extends k {
  render() {
    const {
      className: e,
      dim: t,
      active: n,
      disabled: o,
      children: r,
      onClick: i,
      ...l
    } = this.props, c = f(
      {
        [$t.root]: !0,
        [$t.rootDim]: t,
        [$t.rootActive]: n,
        [$t.rootDisabled]: !n && o
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: i,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: $t.label, children: r })
      }
    );
  }
}
const mh = "h-datePickerOld--datePickerOld__grid", fh = "h-datePickerOld--datePickerOld__gridItem", bh = "h-datePickerOld--datePickerOld__day", yh = "h-datePickerOld--datePickerOld__month", xh = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", _h = "h-datePickerOld--datePickerOld__timeButtonContainerRight", Ch = "h-datePickerOld--datePickerOld__arrowTime", vh = "h-datePickerOld--datePickerOld__arrow", wh = "h-datePickerOld--datePickerOld__dayNames", Sh = "h-datePickerOld--datePickerOld__dayName", Ih = "h-datePickerOld--datePickerOld__time", kh = "h-datePickerOld--datePickerOld__timeDisplay", X = {
  grid: mh,
  gridItem: fh,
  day: bh,
  month: yh,
  timeButtonContainerLeft: xh,
  timeButtonContainerRight: _h,
  arrowTime: Ch,
  arrow: vh,
  dayNames: wh,
  dayName: Sh,
  time: Ih,
  timeDisplay: kh
}, Mk = (a) => [0, 6].indexOf(a.getDay()) !== -1;
class Xt extends k {
  static defaultProps;
  static getDateValue(e) {
    const t = e.value instanceof Date ? e.value : /* @__PURE__ */ new Date();
    return new Date(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes()
    );
  }
  constructor(e) {
    super(e);
    const t = Xt.getDateValue(e.input);
    this.state = {
      selectedDate: t,
      showDate: t
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(e) {
    const { input: t } = this.props;
    e.input !== t && this.setState({
      selectedDate: Xt.getDateValue(e.input)
    });
  }
  generateGrid() {
    const { selectedDate: e, showDate: t } = this.state, { input: n, disabled: o, minDate: r, maxDate: i } = this.props, l = [], c = new Date(
      t.getFullYear(),
      t.getMonth(),
      1,
      e.getHours(),
      e.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = Xt.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const g = c.getTime(), m = new Date(g);
      l.push({
        date: m,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === t.getMonth(),
        selected: g === u,
        disabled: o(c) || !!(i && m > i) || !!(r && m < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(e) {
    const { showDate: t } = this.state, n = new Date(t.getTime());
    n.setMonth(t.getMonth() + e), this.setState({
      showDate: n
    });
  }
  nextMonth = (e) => {
    e.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (e) => {
    e.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(e, t) {
    e.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: t
    };
    o.getMonth() !== t.getMonth() && (r.showDate = t), this.setState(r), n(t);
  }
  goToTime(e, t, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: i }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + t), this.setState({
      selectedDate: c
    }), i(c);
  }
  nextMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, 15, "minutes");
  };
  prevMinutes = (e) => {
    e.preventDefault(), this.goToTime(e, -15, "minutes");
  };
  nextHour = (e) => {
    e.preventDefault(), this.goToTime(e, 1);
  };
  prevHour = (e) => {
    e.preventDefault(), this.goToTime(e, -1);
  };
  canGoPrevMonth() {
    const { minDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth(),
      1
    );
    return e < n;
  }
  canGoNextMonth() {
    const { maxDate: e } = this.props, { showDate: t } = this.state;
    if (e === null) return !0;
    const n = new Date(
      t.getFullYear(),
      t.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return e > n;
  }
  canGoDirection(e = "hours", t) {
    const n = e === "minutes" ? "setMinutes" : "setHours", o = e === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: i } = this.state, l = new Date(i.getTime());
    return l[n](l[o]() + t), !(l.getDate() !== i.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: e,
      input: t,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: i,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, e), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let g = null;
    try {
      g = d.toLocaleDateString("en-US", p);
    } catch (m) {
      g = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", m);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: X.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        g,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: X.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: X.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: X.grid, children: u.map((m) => /* @__PURE__ */ s.jsx("div", { className: X.gridItem, children: /* @__PURE__ */ s.jsx(
        gh,
        {
          onClick: (b) => this.handleDateClick(b, m.date),
          dim: !m.isThisMonth,
          active: m.selected,
          disabled: m.disabled,
          className: X.day,
          children: m.label
        }
      ) }, m.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: X.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: X.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: X.timeDisplay, children: `${io(
          c.getHours().toString(),
          2,
          "0"
        )}:${io(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: X.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
Xt.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Dh(a) {
  return Math.abs(a.diff(j())) < 25e3 ? "just now" : a.fromNow();
}
function Ns(a) {
  return j(a, j.ISO_8601).isValid();
}
function Dt(a) {
  return !!j.tz.zone(a ?? "");
}
const Pe = "HH:mm", Tr = mr(24), jr = mr(0, 60, 15), Fr = (a) => j("1995-12-25").format(a);
function Nr(a) {
  if (a < 0 || a > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Pr(a) {
  if (a < 0 || a > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Rr({
  hour: a,
  minute: e,
  timeFormat: t
}) {
  const n = j({ hour: a, minute: e });
  return {
    id: n.format(Pe),
    name: n.format(t)
  };
}
function Th(a, e) {
  return e?.map(({ hour: t, minute: n }) => (Nr(t), Pr(n), Rr({ hour: t, minute: n, timeFormat: a }))) || [];
}
function Er({
  hours: a,
  minutes: e,
  overrides: t,
  timeFormat: n
}) {
  return Da(
    a.reduce(
      (o, r, i) => [
        ...o,
        ...e.map((l, c) => (c === 0 && Nr(r), i === 0 && Pr(l), Rr({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(Th(n, t)),
    ["id"]
  );
}
const jh = "h-datePicker--datePicker__root", Fh = "h-datePicker--datePicker__navigationButton", Nh = "h-datePicker--datePicker__nextMonthButton", Ph = "h-datePicker--datePicker__prevMonthButton", kt = {
  root: jh,
  navigationButton: Fh,
  nextMonthButton: Nh,
  prevMonthButton: Ph
}, zn = {
  previousMonth({ ariaLabel: a, ...e }) {
    const t = f(
      kt.navigationButton,
      kt.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(N, { ...e, "aria-label": a, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: a, ...e }) {
    const t = f(
      kt.navigationButton,
      kt.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: t, children: /* @__PURE__ */ s.jsx(N, { ...e, "aria-label": a, size: 24, name: "angle-right" }) });
  }
}, Lr = (a) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: a.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Ar = ({ month: a }) => /* @__PURE__ */ s.jsx("span", { children: a.format("MMMM YYYY") }), $r = (a) => {
  const { value: e, presets: t, onSelect: n } = a, o = F(
    (r) => {
      n(r.key === e ? null : r);
    },
    [n, e]
  );
  return /* @__PURE__ */ s.jsxs(et, { children: [
    /* @__PURE__ */ s.jsx(qn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(po, { children: t.map((r) => /* @__PURE__ */ s.jsx(
      po.Item,
      {
        isSelected: r.key === e,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, Rh = "h-fieldLabel--fieldLabel__root", Eh = "h-fieldLabel--fieldLabel__label", Lh = "h-fieldLabel--fieldLabel__labelChildren", Ah = "h-fieldLabel--fieldLabel__rootRequired", $h = "h-fieldLabel--fieldLabel__helpIcon", Ot = {
  root: Rh,
  label: Eh,
  labelChildren: Lh,
  rootRequired: Ah,
  helpIcon: $h
}, Oh = "fieldLabel";
class qs extends k {
  render() {
    const { required: e, helpIcon: t, className: n, children: o, ...r } = this.props, i = f(Ot.root, n, {
      [Ot.rootRequired]: e
    });
    return /* @__PURE__ */ s.jsxs("div", { className: i, "data-testid": Oh, children: [
      /* @__PURE__ */ s.jsx("label", { className: Ot.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Ot.labelChildren, children: o }) }),
      !!t?.text && /* @__PURE__ */ s.jsx(
        Us,
        {
          ...t,
          className: f(Ot.helpIcon, t.className)
        }
      )
    ] });
  }
}
const Bh = "h-dropdownSelect--dropdownInfinite__item", Hh = "h-dropdownSelect--dropdownInfinite__list", No = {
  item: Bh,
  list: Hh
};
class Po extends k {
  render() {
    const {
      item: e,
      itemComponent: t,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: i,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, g = /* @__PURE__ */ s.jsx(
      t,
      {
        item: e,
        onSelect: o,
        onChange: r,
        onKeyDown: i,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(le, { ...n, children: g }, e.id) : g;
  }
}
const Wh = 6, Mh = 48;
class Gs extends k {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(e) {
    super(e), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = O(), this.infiniteListRef = O();
  }
  componentDidUpdate(e) {
    const { activeItem: t, items: n, pagination: o } = this.props, r = typeof e.activeItem == "object" && e.activeItem ? e.activeItem.id : e.activeItem, i = typeof t == "object" && t ? t.id : t;
    if (r !== i && i !== null) {
      const l = n.findIndex(
        (c) => c.id === i
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(e) {
    const { items: t } = this.props;
    return e < t.length;
  }
  isItemActive(e) {
    if (!e) return !1;
    const { activeItem: t } = this.props;
    return t ? typeof t == "object" && "id" in t ? e.id === t.id : e.id === t : !1;
  }
  isItemChecked(e) {
    if (!e) return !1;
    const { selectedItems: t } = this.props;
    return (t?.findIndex((o) => typeof o == "object" ? o.id === e.id : o === e.id) ?? -1) > -1;
  }
  isItemDisabled(e) {
    return e ? (this.props.disabledItems?.indexOf(e.id) ?? -1) >= 0 : !0;
  }
  getTooltip(e) {
    const { tooltipItems: t } = this.props;
    return !e || fr(t?.[e.id]) ? null : t?.[e.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: e, activeItem: t } = this.props;
    if (!t || !this.listRef.current) return;
    const n = typeof t == "object" && "id" in t ? t.id : t, o = e.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(e) {
    const { id: t } = this.props;
    return t ? `${t}-option-${e}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: e,
    style: t
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: i, clearSearch: l } = this.props, c = this.isItemLoaded(e), d = e === n.length - 1, h = c ? n[e] : { id: tn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: t, className: No.item, children: [
      /* @__PURE__ */ s.jsx(
        Po,
        {
          id: this.getItemId(e),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: i,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(Ta, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: e,
      pagination: t,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: i,
      clearSearch: l,
      itemsDisplayCount: c = Wh,
      itemHeight: d = Mh,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!t || !t.infinite || !t.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: No.list,
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: e.map((v, w) => {
            const S = ja(v) ? v : v.id.toString() || v.name.toString() || v.toString();
            return /* @__PURE__ */ s.jsx(
              Po,
              {
                id: this.getItemId(w),
                checked: this.isItemChecked(v),
                clearSearch: l,
                disabled: this.isItemDisabled(v),
                item: v,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: i,
                tooltip: this.getTooltip(v),
                active: this.isItemActive(v)
              },
              S
            );
          })
        }
      );
    const { nextEnable: p, itemCount: g } = t, m = g || (p ? e.length + c : e.length), b = {
      items: e,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, y = Math.min(
      m * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Fa, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: v }) => /* @__PURE__ */ s.jsx(
      Na,
      {
        ...b,
        ref: this.infiniteListRef,
        width: v,
        height: y,
        itemCount: m,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const zh = "h-selectItems-checkableBaseItem--checkableBaseItem__root", Vh = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", Kh = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", Uh = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", qh = "h-selectItems-checkableBaseItem--checkableBaseItem__content", Bt = {
  root: zh,
  rootActive: Vh,
  rootDisabled: Kh,
  checkbox: Uh,
  content: qh
};
class Ys extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  handleKeyDown(e) {
    const { disabled: t, onKeyDown: n } = this.props;
    (e.key === "Enter" || e.key === " ") && !t && (e.preventDefault(), this.handleChange()), n && n(e);
  }
  noop(e) {
    e.preventDefault();
  }
  render() {
    const {
      item: e,
      onChange: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: i,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(Bt.root, {
      [Bt.rootDisabled]: r,
      [Bt.rootActive]: c
    }), g = r ? L : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            cn,
            {
              id: e?.id,
              name: "",
              className: Bt.checkbox,
              checked: o,
              onChange: g,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: Bt.content, children: l })
        ]
      }
    );
  }
}
const Gh = "h-selectItems-emptySelectItem--emptySelectItem__root", Yh = "h-selectItems-emptySelectItem--emptySelectItem__name", Ro = {
  root: Gh,
  name: Yh
};
class Zn extends k {
  render() {
    const { label: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...t, className: Ro.root, children: /* @__PURE__ */ s.jsx("div", { className: Ro.name, children: e }) });
  }
}
const Qh = "h-selectItems-selectItem--selectItem__root", Xh = "h-selectItems-selectItem--selectItem__rootActive", Zh = "h-selectItems-selectItem--selectItem__name", Jh = "h-selectItems-selectItem--selectItem__nameBold", eu = "h-selectItems-selectItem--selectItem__nameWithDescription", tu = "h-selectItems-selectItem--selectItem__description", nu = "h-selectItems-selectItem--selectItem__icon", ot = {
  root: Qh,
  rootActive: Xh,
  name: Zh,
  nameBold: Jh,
  nameWithDescription: eu,
  description: tu,
  icon: nu
};
class Or extends xe {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: i,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = e, g = f(ot.root, {
      [ot.rootActive]: i
    }), m = f(ot.name, {
      [ot.nameBold]: o,
      [ot.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": i,
        className: g,
        disabled: r,
        onClick: () => {
          t(e);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: ot.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: m, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: ot.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const su = "h-selectItems-checkableSelectItem--checkableSelectItem__name", ou = {
  name: su
};
class zk extends k {
  render() {
    const { item: e, isLoading: t } = this.props, { name: n } = t ? { name: "Loading..." } : e;
    return /* @__PURE__ */ s.jsx(Ys, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: ou.name, children: n }) });
  }
}
const ru = "h-selectItems-tagSelectItem--tagSelectItem__root", au = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", iu = "h-selectItems-tagSelectItem--tagSelectItem__name", lu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", cu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", du = "h-selectItems-tagSelectItem--tagSelectItem__dot", bt = {
  root: ru,
  rootActive: au,
  name: iu,
  nameBold: lu,
  dotContainer: cu,
  dot: du
};
class Vk extends k {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: e,
      onSelect: t,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: i,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = e, u = f(bt.root, {
      [bt.rootActive]: l
    }), p = f(bt.name, {
      [bt.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          t(e), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: bt.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: bt.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const hu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", uu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", pu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", gu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", xn = {
  name: hu,
  dotContainer: uu,
  dot: pu,
  nameContainer: gu
};
class Kk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: e, item: t, checked: n } = this.props;
    typeof e == "function" && e(t, !n);
  }
  render() {
    const { item: e, isLoading: t, disabled: n } = this.props, { name: o, color: r } = t ? { name: "Loading...", color: "#000" } : e;
    return /* @__PURE__ */ s.jsx(
      Ys,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: xn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: xn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: xn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: xn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const mu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", fu = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", bu = "h-selectItems-avatarSelectItem--avatarSelectItem__names", yu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", xu = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", _u = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", Cu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", vu = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Ue = {
  root: mu,
  rootActive: fu,
  names: bu,
  primaryName: yu,
  secondaryName: xu,
  namesBold: _u,
  container: Cu,
  containerCheckable: vu
};
class wu extends k {
  static defaultProps = {
    checked: !1
  };
  getNames(e) {
    const t = /* @__PURE__ */ new Set();
    typeof e.name == "string" && t.add(e.name), typeof e.name != "string" && typeof e.display_name == "string" && t.add(e.display_name), typeof e.phone_number == "string" && t.add(e.phone_number), typeof e.email == "string" && t.add(e.email);
    const n = Array.from(t);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(e) {
    return typeof e.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: e.icon, size: 16 }) : /* @__PURE__ */ s.jsx(wr, { user: e });
  }
  renderContent() {
    const e = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, t = this.getAvatar(e), n = this.getNames(e), o = f(Ue.container, {
      [Ue.containerCheckable]: this.props.checkable
    }), r = f(Ue.names, {
      [Ue.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      t,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Ue.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Ue.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const e = this.renderContent(), { checkable: t, ...n } = this.props;
    if (t) {
      const g = n;
      return /* @__PURE__ */ s.jsx(Ys, { ...g, children: e });
    }
    const o = n, { item: r, disabled: i, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Ue.root, {
      [Ue.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: i,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          e,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Uk extends k {
  render() {
    return /* @__PURE__ */ s.jsx(wu, { checkable: !0, ...this.props });
  }
}
const Su = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", Iu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", ku = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Du = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", _n = {
  root: Su,
  rootActive: Iu,
  suggestion: ku,
  icon: Du
};
class qk extends xe {
  static defaultProps = {
    searchSuggestion: (e, t) => e.find((n) => n.name.toLowerCase() === t.toLowerCase()),
    renderSuggestion: (e) => `Add "${e}" tag`
  };
  constructor(e) {
    super(e), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(e) {
    const { searched: t, active: n } = this.props;
    t !== e.searched && this.searchItem(), n !== e.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: e, searched: t, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(e, t);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: e, onSuggest: t, clearSearch: n, triggerClose: o } = this.props;
    o?.(), t?.(e), n();
  }
  handleKeyDown(e) {
    this.props.active && e.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: e,
      triggerClose: t,
      onSuggest: n,
      searched: o,
      items: r,
      active: i,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const g = f(e, _n.root, {
      [_n.rootActive]: i
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": i,
        className: g,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: _n.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: _n.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const Tu = "h-selectItems-deselectItem--deselectItem__root", ju = "h-selectItems-deselectItem--deselectItem__rootDisabled", Fu = "h-selectItems-deselectItem--deselectItem__name", Nu = "h-selectItems-deselectItem--deselectItem__icon", Cn = {
  root: Tu,
  rootDisabled: ju,
  name: Fu,
  icon: Nu
};
class Gk extends k {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, ...r } = this.props, { name: i } = e, l = f(Cn.root, {
      [Cn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: Cn.name, children: i }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Cn.icon,
          onClick: () => {
            t(e);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const Pu = "h-selectItems-tagDeselectItem--tagDeselectItem__root", Ru = "h-selectItems-tagDeselectItem--tagDeselectItem__name", Eu = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", Lu = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", Au = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Ht = {
  root: Pu,
  name: Ru,
  icon: Eu,
  dotContainer: Lu,
  dot: Au
};
class Yk extends k {
  render() {
    const { item: e, onSelect: t, clearSearch: n, disabled: o, isLoading: r, ...i } = this.props, { name: l, color: c } = e, d = f(Ht.root);
    return /* @__PURE__ */ s.jsxs("div", { ...i, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Ht.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Ht.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Ht.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Ht.icon,
          onClick: () => {
            t(e);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const $u = "h-chip--chip__root", Ou = "h-chip--chip__rootLight", Bu = "h-chip--chip__rootNoBorder", Hu = "h-chip--chip__rootDisabled", Wu = "h-chip--chip__rootInteractable", Wt = {
  root: $u,
  rootLight: Ou,
  rootNoBorder: Bu,
  rootDisabled: Hu,
  rootInteractable: Wu
}, Mu = ({
  className: a,
  children: e,
  onClick: t,
  light: n,
  noBorder: o,
  disabled: r,
  ...i
}) => {
  const l = f(
    {
      [Wt.root]: !0,
      [Wt.rootLight]: n,
      [Wt.rootNoBorder]: o,
      [Wt.rootDisabled]: r,
      [Wt.rootInteractable]: typeof t == "function" && !r
    },
    a
  ), c = typeof t == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(ie, { ...i, as: c, className: l, onClick: t, children: e });
}, zu = "h-tag--tag__tagName", Vu = "h-tag--tag__tagNameTruncated", Ku = "h-tag--tag__icon", Uu = "h-tag--tag__deleteButton", qu = "h-tag--tag__deleteButtonDisabled", Gu = "h-tag--tag__deleteIcon", yt = {
  tagName: zu,
  tagNameTruncated: Vu,
  icon: Ku,
  deleteButton: Uu,
  deleteButtonDisabled: qu,
  deleteIcon: Gu
}, nn = ({
  className: a,
  tagNameClassName: e,
  children: t,
  onDelete: n,
  color: o,
  light: r,
  noBorder: i,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [yt.tagName]: !0,
      [yt.tagNameTruncated]: !l
    },
    e
  ), u = f(yt.deleteButton, {
    [yt.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    Mu,
    {
      ...d,
      className: a,
      light: r,
      noBorder: i,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: yt.icon,
            style: { backgroundColor: Jt(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: t }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: yt.deleteIcon }) })
      ]
    }
  );
}, Yu = "h-select--select__root", Qu = "h-select--select__rootDisabled", Xu = "h-select--select__inputWrapper", Zu = "h-select--select__control", Ju = "h-select--select__rootHasIcon", ep = "h-select--select__selection", tp = "h-select--select__selectionItem", np = "h-select--select__tag", sp = "h-select--select__tagName", op = "h-select--select__tagLimiter", rp = "h-select--select__text", ap = "h-select--select__rootSearchable", ip = "h-select--select__rootDropdownOpen", lp = "h-select--select__rootIsSearching", cp = "h-select--select__search", dp = "h-select--select__rootSingle", hp = "h-select--select__indicators", up = "h-select--select__spinner", pp = "h-select--select__clearIndicator", gp = "h-select--select__dropdownIndicator", mp = "h-select--select__dropdown", fp = "h-select--select__dropdownFixed", bp = "h-select--select__pagination", Y = {
  root: Yu,
  rootDisabled: Qu,
  inputWrapper: Xu,
  control: Zu,
  rootHasIcon: Ju,
  selection: ep,
  selectionItem: tp,
  tag: np,
  tagName: sp,
  tagLimiter: op,
  text: rp,
  rootSearchable: ap,
  rootDropdownOpen: ip,
  rootIsSearching: lp,
  search: cp,
  rootSingle: dp,
  indicators: hp,
  spinner: up,
  clearIndicator: pp,
  dropdownIndicator: gp,
  dropdown: mp,
  dropdownFixed: fp,
  pagination: bp
};
class Tt extends k {
  static contextType = Un;
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: Pa("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Or,
    emptyComponent: Zn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(e) {
    super(e), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = O(), this.searchRef = O(), this.listRef = O();
    const t = this.initSelectedItems(), n = this.initHighlightedIndex(t);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: t,
      highlightedIndex: n
    }, !Tt.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Tt.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(e, t) {
    const { dropdownOpen: n } = this.state;
    if (n !== t.dropdownOpen)
      if ((this.context ?? window)[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    br(e.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: e } = this.state;
    e && (this.context ?? window).removeEventListener(
      "click",
      this.handleClickOutside
    );
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: e } = this.props, { highlightedIndex: t } = this.state, n = `${e}-label`, o = `${e}-dropdown`, r = t !== null ? `${o}-option-${t}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(e) {
    return typeof e == "string" || typeof e == "number";
  }
  initSelectedItems() {
    const { selectedItems: e = [] } = this.props;
    return e.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(e = this.state.selectedItems) {
    const { multiple: t, items: n, hideSelectedItems: o } = this.props;
    if (!t && !o && e.length) {
      const r = this.resolveItem(e[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(e) {
    return this.isItemIdType(e) ? this.props.items.find((n) => n.id === e) : e;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    this.setState({ search: n }, () => {
      t?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(e = "toggle") {
    const { dropdownOpen: t } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (e === "toggle")
      return o?.(!t), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !t });
    if (e === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (e === "close" && t)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(e) {
    if (!this.controlRef || !(e.target instanceof Node)) return;
    const t = this.controlRef.current, { target: n } = e;
    n && n !== t && !t?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(e, t = "smooth") {
    this.setState({ highlightedIndex: e }, () => {
      if (e === null || e === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[e]?.scrollIntoView({
        behavior: t,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(e) {
    const { search: t, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: i, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = e.key === "Escape", h = e.key === "Enter", u = e.key === "ArrowUp", p = e.key === "ArrowDown", g = e.key === "Backspace";
    if ((h || u || p) && e.preventDefault(), p && !n)
      return e.preventDefault(), this.handleDropdown("open");
    if (d && (n && e.stopPropagation(), this.handleDropdown("close")), g && i && !t) {
      const m = r[r.length - 1];
      m && this.handleRemove(m);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(t), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const m = c[o], b = m && this.isItemDisabled(m);
        if (m && !b) {
          this.handleSelect(m);
          const y = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(y);
        }
      }
    }
  }
  handleSelect(e) {
    const { multiple: t, keepOpen: n, onSelect: o } = this.props;
    if (t) {
      const r = this.isItemSelected(e);
      this.handleChange(e, !r);
    } else
      this.setState({
        selectedItems: [e],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(e);
  }
  handleChange(e, t) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: t ? [...o, e] : o.filter((r) => r.id !== e.id)
    }), this.resetSearch(), n?.(e, t);
  }
  handleRemove(e, t) {
    t && (t.preventDefault(), t.stopPropagation()), this.handleChange(e, !1);
  }
  handleClear(e) {
    e.stopPropagation();
    const { onClear: t } = this.props;
    t?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(e) {
    e.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(e) {
    return e.name.toString().trim();
  }
  getAvailableItems() {
    const { search: e } = this.state, { items: t, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, i = new RegExp(Hs(e), "i");
    return t.filter((c) => {
      const d = [];
      return e && !o && (r && typeof r == "function" ? d.push(r(c, e)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && i.test(u.toString().trim());
        })
      ) : d.push(i.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(e) {
    return this.state.selectedItems.some(
      (t) => t.id === e.id
    );
  }
  isItemDisabled(e) {
    return this.props.disabledItems?.includes(e.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(e) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: e } = this.props, { selectedItems: t } = this.state;
    if (e && e > 0)
      return /* @__PURE__ */ s.jsx(B, { flexDirection: "column", children: t?.slice(e).map((n) => /* @__PURE__ */ s.jsxs(
        B,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(ie, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              q,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(e) {
    return this.props.renderSelection?.(e) ?? this.getItemName(e);
  }
  renderMultipleSelection() {
    const { selectedItems: e } = this.state, t = this.props.limit || e.length, n = t < e.length, o = e?.slice(0, t).map((r) => {
      const i = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: Y.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            nn,
            {
              className: Y.tag,
              tagNameClassName: Y.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: i
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        le,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            nn,
            {
              className: f(Y.tag, Y.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                e.length - t
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: e, selectedItems: t } = this.state, n = t[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: Y.text,
        "aria-hidden": !!e,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: e } = this.props;
    return !e && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: Y.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (t) => t.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !e,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: e, highlightedIndex: t, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: i,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: g,
      multiple: m
    } = this.props, b = f(
      {
        [Y.dropdown]: !0,
        [Y.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), y = this.getAvailableItems(), v = y[t ?? -1] ?? null, w = !y.length;
    return /* @__PURE__ */ s.jsxs(
      nt,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: e,
        "data-testid": "select-dropdown",
        children: [
          w && typeof i == "function" && /* @__PURE__ */ s.jsx(
            i,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: g,
              triggerClose: m ? void 0 : () => this.handleDropdown("close"),
              items: y,
              active: t === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !w && /* @__PURE__ */ s.jsx(
            Gs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: y,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: v,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: Y.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: e,
      disabled: t,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: i,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: g } = this.state, m = f(
      {
        [Y.root]: !0,
        [Y.rootSingle]: !r,
        [Y.rootDisabled]: t,
        [Y.rootSearchable]: i,
        [Y.rootDropdownOpen]: g,
        [Y.rootIsSearching]: !!p,
        [Y.rootHasIcon]: !!h
      },
      e
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: m,
        role: "combobox",
        "aria-expanded": g,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Me,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: g,
              disabled: t,
              className: Y.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: Y.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: t ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: Y.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: Y.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        Ws,
                        {
                          className: Y.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        q,
                        {
                          tabIndex: -1,
                          className: Y.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        q,
                        {
                          tabIndex: -1,
                          className: Y.dropdownIndicator,
                          icon: g ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (y) => {
                            y.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": g ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !t && g && this.renderDropdown()
        ]
      }
    );
  }
}
function yp(a) {
  return /* @__PURE__ */ s.jsx(
    jt,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Tt, { ...a })
    }
  );
}
const xp = "h-datePicker-timezoneSelector--timezoneSelector__root", _p = "h-datePicker-timezoneSelector--timezoneSelector__label", Eo = {
  root: xp,
  label: _p
}, Br = ({
  disabled: a,
  tooltipProps: e,
  selectedTimezone: t,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = F((h, u) => {
    const [p, g] = j.tz(h).format("Z").split(":"), [m, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(g) - (+parseInt(m) * 60 + parseInt(b));
  }, []), i = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${i(h)} ${h}`, c = G(() => {
    const h = j.tz.names().filter((g) => g !== o), u = {
      id: o,
      name: `Default ${i(o)}`
    }, p = h.sort(r).map((g) => ({ id: g, name: l(g) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Eo.root, children: [
    /* @__PURE__ */ s.jsx(qs, { className: Eo.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(le, { ...e, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      yp,
      {
        disabled: a,
        items: c,
        onSelect: d,
        selectedItems: [
          Dt(t) ? t : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, Cp = "h-fieldAlert--fieldAlert__root", vp = "h-fieldAlert--fieldAlert__alert", wp = "h-fieldAlert--fieldAlert__icon", gs = {
  root: Cp,
  alert: vp,
  icon: wp
}, Sp = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", Ip = {
  root: Sp
};
function kp({
  className: a,
  variant: e = "tertiary",
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    te,
    {
      ...t,
      variant: e,
      className: f(a, Ip.root)
    }
  );
}
const Dp = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function Jn({
  children: a,
  className: e,
  ...t
}) {
  const n = t.variant || "title", o = f(gs.root, e), [r, i] = V(!1), l = Dp[n], c = F(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      i(h < u);
    },
    [a]
  );
  return /* @__PURE__ */ s.jsxs(H.Input, { ...t, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: gs.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: gs.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(le, { content: a, children: a }) : a })
  ] });
}
Jn.Button = kp;
const Tp = "hmm A", jp = (a, e) => {
  const t = `${a}`.padStart(2, "0"), n = `${e}`.padStart(2, "0");
  return `${t}:${n}`;
}, Lo = (a, e) => {
  const t = a.hours(), n = a.minutes();
  return {
    id: jp(t, n),
    name: a.format(e)
  };
}, sn = ({
  hasDropDownIndicator: a = !0,
  allowCustomTimeInput: e = !1,
  timeOptions: t,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Tr,
  selectableMinutes: i = jr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, g] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [m, b] = V(""), y = G(
    () => t || Er({
      hours: r,
      minutes: i,
      overrides: n,
      timeFormat: l
    }),
    [
      t,
      r,
      i,
      n,
      l
    ]
  ), v = G(() => {
    const C = j(
      m || (typeof u == "object" ? u.id : u) || p,
      [l, Tp]
    );
    if (!C.isValid())
      return null;
    const _ = C.hours(), I = C.minutes();
    if (!d || d(_, I))
      return Lo(C, l);
    const T = _ <= 12, P = _ + 12, M = d(P, I);
    return T && M ? Lo(j({ hours: P, minutes: I }), l) : null;
  }, [u, m]), w = G(() => {
    if (!e)
      return y;
    const C = p ? y.filter(({ name: _ }) => _ !== v?.name) : y.filter(
      ({ name: _ }) => _.startsWith(m) && _ !== v?.name
    );
    if (!v)
      return C;
    const x = p !== v.id ? 0 : C.findIndex(
      (_) => j(_.id, [l]) > j(v.id, [l])
    );
    return C.splice(
      // If it's -1 then there was no later time, so add it to the end.
      x === -1 ? C.length : x,
      0,
      v
    ), C;
  }, [v, m, p, y]), S = F(
    (C) => {
      C?.id !== v?.id && b(""), c(C?.id || null), g(C?.id || null);
    },
    [v]
  );
  return Z(() => {
    u ? (b(""), g(
      typeof u == "object" ? u.id : u
    )) : g(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Tt,
    {
      searchable: !0,
      placeholder: Fr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: a,
      items: e ? w : y,
      onChange: L,
      onClear: S,
      onSelect: S,
      ...e && { onSearch: b }
    }
  );
}, Fp = "h-timePicker-range--timeRangePicker__root", Np = "h-timePicker-range--timeRangePicker__timePickerFrom", Pp = "h-timePicker-range--timeRangePicker__timePickerTo", Rp = "h-timePicker-range--timeRangePicker__arrowContainer", Ep = "h-timePicker-range--timeRangePicker__arrowContainerHasError", Lp = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", Ap = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", rt = {
  root: Fp,
  timePickerFrom: Np,
  timePickerTo: Pp,
  arrowContainer: Rp,
  arrowContainerHasError: Ep,
  arrowContainerHasWarning: Lp,
  arrowContainerHasSuccess: Ap
}, $p = ({
  className: a,
  disabled: e,
  endTime: t,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: i = Tr,
  selectableMinutes: l = jr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: g, endTime: m }, b] = V({
    startTime: d || null,
    endTime: t || null
  }), y = G(
    () => Er({
      hours: i,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [i, l, o, u]
  ), v = G(() => {
    const x = y.map(
      ({ id: T }) => j(T, [u])
    ), _ = j(g, [u]), I = g && x.findIndex(
      (T) => T > _
    ) || 0;
    return y.slice(I);
  }, [y, g, u]);
  Z(() => {
    const x = typeof d == "string", _ = typeof d == "string";
    (x && d !== g || _ && t !== m) && b((I) => ({
      ...I,
      ...x && { startTime: d },
      ..._ && { endTime: t }
    }));
  });
  const w = F(
    (x) => (_) => {
      b((I) => {
        const T = j(_, [u]), P = j(I.startTime, [u]), M = j(I.endTime, [u]), D = y.map(
          ({ id: ne }) => j(ne, [u])
        ), E = D.findIndex(
          (ne) => ne >= T
        ) || -1, A = x === "startTime" ? E : D.findIndex(
          (ne) => ne >= P
        ), K = x === "endTime" ? -1 : D.findIndex(
          (ne) => ne >= M
        ), se = {
          ...I,
          [x]: _,
          ...I.endTime !== null && x !== "endTime" && A >= K && {
            endTime: y[E + 1]?.id || null
          }
        };
        return n(se), se;
      });
    },
    [n]
  ), S = F(
    (x, _) => {
      const I = j(g, [u]);
      if (!I.isValid())
        return !0;
      const P = I.hours(), M = I.minutes();
      return P < x || P === x && M < _;
    },
    [g, u]
  ), C = (x) => r?.[x] || r || Fr(u);
  return /* @__PURE__ */ s.jsxs(ie, { className: f(rt.root, a), children: [
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: rt.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: e,
        hasDropDownIndicator: !1,
        timeOptions: y,
        onSelect: w("startTime"),
        placeholder: C("startTime"),
        allowCustomTimeInput: h,
        selectedItems: g ? [g] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      ie,
      {
        className: f(rt.arrowContainer, {
          [rt.arrowContainerHasError]: c === "error",
          [rt.arrowContainerHasWarning]: c === "warning",
          [rt.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: rt.timePickerTo,
        searchable: !0,
        disabled: e || !g,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: v,
        onSelect: w("endTime"),
        placeholder: C("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: S
        },
        selectedItems: m ? [m] : [],
        status: c
      }
    )
  ] });
};
class Qe {
  constructor(e, t, n) {
    this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n, this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n;
  }
  dateFormat;
  dateParser;
  dateRangeConstraint;
  static validationOK = { isValid: !0, error: null };
  isValidDate(e) {
    try {
      return this.dateParser(e).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(e) {
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: t, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(e);
    return o.isBefore(t, "day") ? {
      isValid: !1,
      error: `Date must be after ${t.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Qe.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(e), i = this.dateParser(t);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && r.isAfter(i, "day") ? {
      isValid: !1,
      error: `From date must be before ${i.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Qe.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: e,
    endDateInputValue: t
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(e), i = this.dateParser(t);
    return i.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && i.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : i.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Qe.validationOK;
  }
  isTimeOrderValid({
    startDate: e,
    endDate: t
  }) {
    return !e || !t ? Qe.validationOK : e.isAfter(t) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Qe.validationOK;
  }
}
const Op = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", Bp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", Hp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Wp = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", Mp = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", zp = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Vp = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", qe = {
  root: Op,
  rootPlacementTop: Bp,
  rootPlacementTopWithTimezoneSelector: Hp,
  rootPlacementBottom: Wp,
  fields: Mp,
  input: zp,
  alert: Vp
};
Array(24).fill(0).map((a, e) => e);
class Qs extends k {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      startDateInputValue: this.props.startDate?.format(t) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(t) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Qs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Qe(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncStartDateWithProps(e), this.syncEndDateWithProps(e), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: e, endDate: t } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: e,
      endDate: t
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(e) {
    const { endDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.endDate || t?.isSame(e.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(e) {
    const { startDate: t, timeRoundingStrategy: n } = this.props;
    if (!(t === e.startDate || t?.isSame(e.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(e, t) {
    const n = e.target.value;
    switch (t) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (e === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: i } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = t !== "" && !r ? i : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(e))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: e, endDateInputValue: t } = this.state;
    if (t === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: i } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: e,
      endDateInputValue: t
    }), l = e !== "" && !r ? i : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(t))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  getOverrides(e) {
    if (e !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(e, t, n, o, r, i, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: g,
      withTimePicker: m,
      withDateInput: b
    } = this.props, { timeOrderError: y } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(qs, { children: e === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Xe,
        {
          className: qe.input,
          placeholder: c.toLowerCase(),
          name: `input__${e}__${this.instanceId}`,
          value: r,
          onChange: (v) => this.handleInputValueChange(v, e),
          onFocus: () => u(e),
          autoComplete: "off",
          status: i ? "error" : void 0,
          disabled: d,
          active: h === e
        }
      ),
      m && /* @__PURE__ */ s.jsx("div", { className: qe.input, children: /* @__PURE__ */ s.jsx(
        le,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            sn,
            {
              disabled: !n,
              overrides: this.getOverrides(t),
              selectedItems: o ? [o] : void 0,
              status: y ? "error" : void 0,
              ...l,
              timeFormat: g,
              onSelect: (v) => p(t, v)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: e, endDateError: t, timeOrderError: n } = this.state;
    return e || t || n || null;
  }
  renderErrors() {
    const e = this.getError();
    return /* @__PURE__ */ s.jsx(
      Jn,
      {
        className: qe.alert,
        variant: e ? "error" : void 0,
        children: e
      }
    );
  }
  render() {
    const {
      startDate: e,
      startTime: t,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: i
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(qe.root, {
      [qe.rootPlacementTop]: u === "top",
      [qe.rootPlacementTopWithTimezoneSelector]: u === "top" && i,
      [qe.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: qe.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          e,
          t,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const Kp = "dateRangePickerTestId";
class Up extends k {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const {
      startDate: t,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: i,
      focusedInput: l = "startDate"
    } = e;
    this.state = {
      startTime: t ? j(t).format(Pe) : null,
      endTime: n ? j(n).format(Pe) : null,
      timezone: Dt(o) ? o : j.tz.guess(!0),
      presetKey: i?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey(e), this.updateTimezoneFromProps(e), this.updatePresetKey(e);
  }
  visibleCalendarMonthRef = O();
  updatePresetKey(e) {
    const { presetKey: t } = this.props;
    e.presetKey !== t && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === t)?.key ?? null
    });
  }
  updateTimezoneFromProps(e) {
    const { timezone: t } = this.props;
    e.timezone !== t && Dt(t) && this.setState({ timezone: t });
  }
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props, n = this.dateFormat;
    return {
      minDate: t ? j(t, n) : j("0001-01-01"),
      maxDate: e ? j(e, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { startDate: t, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: e },
      () => this.onDatesChange({ startDate: t, endDate: n }, o)
    );
  }
  onStartDateChange(e) {
    this.onDatesChange({ startDate: e, endDate: this.props.endDate });
  }
  onEndDateChange(e) {
    this.onDatesChange({ endDate: e, startDate: this.props.startDate });
  }
  onDatesChange(e, t = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: i } = this.props, l = this.addTimezoneToDate(
      e.startDate,
      r
    ), c = this.addTimezoneToDate(
      e.endDate,
      r
    );
    let d = l?.clone().startOf(i) || null, h = c?.clone().endOf(i) || null, u = e.startDate?.clone().startOf(i) || null, p = e.endDate?.clone().endOf(i) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          startTime: e.startDate?.clone().startOf(i).format(Pe) ?? null,
          endTime: e.endDate?.clone().startOf(i).format(Pe) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      e.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(e.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    if (!e)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: t, endDate: n, key: o } = e;
      this.onDatesChange({ startDate: t, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(e, t) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [e]: t
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Dt(t) ? e.clone().tz(t, !0) : e.clone().startOf(n);
  }
  handleFocusChange(e) {
    this.setState({ focusedInput: e ?? "startDate" });
  }
  addTimeToDate(e, t, n) {
    if (!e)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, i] = t.split(":");
    return !r || !i ? n === "startDate" ? e.clone().startOf(o) : e.clone().endOf(o) : e.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(i, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: t } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !e.isBetween(n, o, t);
  }
  updateTimeOnDateChange({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(e) || this.setState({
      startTime: n ? j(n).format(Pe) : null
    }), o?.isSame(t) || this.setState({
      endTime: o ? j(o).format(Pe) : null
    });
  }
  recalculateDatePickerKey({
    startDate: e,
    endDate: t
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (t && e && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !t) && !(!o && t)) {
      if (o && !t) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && t) {
        if (o.isSame(t, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: e,
      endDate: t,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: i } = this.state;
    if (!o)
      return null;
    const l = !!e || !!t, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Br,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: i
      }
    );
  }
  renderInputFields(e) {
    const {
      withDateInput: t,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: i,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: g
    } = this.props;
    if (u !== e || !t && !n)
      return null;
    const { startTime: m, endTime: b, focusedInput: y } = this.state, { minDate: v, maxDate: w } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Qs,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: m,
        endTime: b,
        minDate: v,
        maxDate: w,
        disabled: i,
        withDateInput: t,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: e,
        timeRoundingStrategy: g,
        focusedInput: y
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      $r,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, startDate: o, endDate: r } = this.props, i = n ? () => /* @__PURE__ */ s.jsx("span", {}) : zn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : zn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Kp,
        className: f(kt.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              yr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Lr,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: i,
                renderNavNextButton: l,
                renderMonthElement: Ar,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...t
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const qp = "h-datePicker-single-inputFields--datePickerInputFields__root", Gp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Yp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Qp = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Xp = "h-datePicker-single-inputFields--datePickerInputFields__input", Zp = "h-datePicker-single-inputFields--datePickerInputFields__alert", at = {
  root: qp,
  rootPlacementTop: Gp,
  rootPlacementTopWithTimezoneSelector: Yp,
  rootPlacementBottom: Qp,
  input: Xp,
  alert: Zp
};
class Xs extends k {
  dateValidators;
  instanceId;
  constructor(e) {
    super(e);
    const { dateFormat: t } = e;
    this.state = {
      dateInputValue: this.props.date?.format(t) ?? "",
      dateError: null
    }, this.instanceId = Xs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Qe(
      e.dateFormat,
      this.parseDateString,
      { maxDate: e.maxDate, minDate: e.minDate }
    );
  }
  componentDidUpdate(e) {
    this.syncDateWithProps(e);
  }
  static instanceCount = 0;
  syncDateWithProps(e) {
    const { date: t, timeRoundingStrategy: n } = this.props, o = j(t);
    if (!(t === e.date || o?.isSame(j(e.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(e) {
    const t = this.ensureValidChars(e.target.value);
    this.setState({ dateInputValue: t }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: e } = this.state;
    if (e === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: t, error: n } = this.dateValidators.isSingleDateValid(e);
    if (!t) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(e))
    );
  }
  parseDateString(e) {
    return j(e, this.props.dateFormat, !0);
  }
  ensureValidChars(e) {
    return e.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: e, dateFormat: t, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Xe,
      {
        className: at.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: t.toLowerCase(),
        disabled: e,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: e,
      time: t,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: i,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !e && !r, d = !e || r;
    return /* @__PURE__ */ s.jsx(
      le,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: at.input, children: /* @__PURE__ */ s.jsx(
          sn,
          {
            disabled: d,
            onSelect: i,
            selectedItems: t ? [t] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: e } = this.state;
    return /* @__PURE__ */ s.jsx(
      Jn,
      {
        className: at.alert,
        variant: e ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: e, placement: t } = this.props, n = f(at.root, {
      [at.rootPlacementTop]: t === "top",
      [at.rootPlacementTopWithTimezoneSelector]: t === "top" && e,
      [at.rootPlacementBottom]: t === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Jp = "datePickerTestId";
class eg extends k {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(e) {
    super(e);
    const { date: t, timezone: n, presets: o, presetKey: r } = e;
    this.state = {
      time: t ? j(t).format(Pe) : null,
      timezone: Dt(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: i }) => i === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(e) {
    this.updateTimeOnDateChange(e), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = O();
  getDateConstraints() {
    const { maxDate: e, minDate: t } = this.props;
    return {
      minDate: t || j("0001-01-01"),
      maxDate: e || j("9999-12-31")
    };
  }
  onTimezoneChange(e) {
    const { date: t } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: e }, () => this.onDateChange(t, n));
  }
  onDateChange(e, t = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, i = this.addTimezoneToDate(e, o);
    let l = i?.clone().startOf(r) || null, c = e?.clone().startOf(r) || null;
    if (this.setState({ presetKey: t }), t) {
      this.setState(
        {
          time: e?.clone().startOf(r).format(Pe) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: t
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(i, n), c = this.addTimeToDate(e, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(e) {
    e ? this.onDateChange(e.date, e.key) : this.onDateChange(null);
  }
  handleTimeChange(e) {
    const { date: t } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: e
      }),
      () => this.onDateChange(t)
    );
  }
  addTimezoneToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Dt(t) ? j(e).clone().tz(t, !0) : e.clone().startOf(n);
  }
  addTimeToDate(e, t) {
    if (!e) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = t.split(":");
    return !o || !r ? e.clone().startOf(n) : e.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(e) {
    const { disabled: t, timeRoundingStrategy: n } = this.props;
    if (t)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !e.isBetween(o, r, n);
  }
  updateTimeOnDateChange(e) {
    const { date: t } = this.props;
    e.date?.isSame(t) || this.setState({
      time: t ? j(t).format(Pe) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: e } = this.props, t = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (t && e && !e.isSame(t, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: e, disabled: t, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const i = !!e, l = !i && !t, c = !i || t || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Br,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(e) {
    const {
      dateFormat: t,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: i,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: g
    } = this.props;
    if (p !== e || !o && !r)
      return null;
    const { time: m } = this.state, { minDate: b, maxDate: y } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        dateFormat: t,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: m,
        date: u,
        minDate: b,
        maxDate: y,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: i,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: e,
        timeRoundingStrategy: g
      }
    );
  }
  renderPresets() {
    const { presets: e } = this.props, { presetKey: t } = this.state;
    return e?.length ? /* @__PURE__ */ s.jsx(
      $r,
      {
        value: t,
        presets: e,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: e, calendarProps: t, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, i = n ? () => /* @__PURE__ */ s.jsx("span", {}) : zn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : zn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Jp,
        className: f(kt.root, e),
        children: [
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              yr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Lr,
                daySize: 32,
                renderNavPrevButton: i,
                renderNavNextButton: l,
                renderMonthElement: Ar,
                initialVisibleMonth: () => o || j(),
                onFocusChange: L,
                focused: !0,
                transitionDuration: 0,
                ...t
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const tg = "h-dialer--dialer__dialer", ng = "h-dialer--dialer__number", sg = "h-dialer--dialer__letters", og = "h-dialer--dialer__asterisk", On = {
  dialer: tg,
  number: ng,
  letters: sg,
  asterisk: og
}, rg = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: On.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Qk extends k {
  render() {
    const { className: e, onInput: t, ...n } = this.props, o = f(On.dialer, e);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: rg.map((r) => /* @__PURE__ */ Va(
      "div",
      {
        className: f(On.number),
        ...Gn(() => t(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(H.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: On.letters, children: r.letters }) })
    )) });
  }
}
const ag = "h-fieldWrapper--fieldWrapper__root", ig = "h-fieldWrapper--fieldWrapper__rootDisabled", lg = "h-fieldWrapper--fieldWrapper__label", cg = "h-fieldWrapper--fieldWrapper__alert", vn = {
  root: ag,
  rootDisabled: ig,
  label: lg,
  alert: cg
}, dg = "fieldWrapper";
class z extends k {
  static hasStatus(e, t) {
    return e?.[t] ? e?.touched === void 0 || e.touched === !0 : !1;
  }
  static getStatusMessage(e, t) {
    if (this.hasStatus(e, t))
      return e?.[t];
  }
  static getStatus(e) {
    return z.hasStatus(e, "error") ? "error" : z.hasStatus(e, "warning") ? "warning" : z.hasStatus(e, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: e, description: t } = this.props;
    let n = t, o;
    return z.hasStatus(e, "error") ? (n = z.getStatusMessage(e, "error"), o = "error") : z.hasStatus(e, "warning") ? (n = z.getStatusMessage(e, "warning"), o = "warning") : z.hasStatus(e, "success") && (n = z.getStatusMessage(e, "success"), o = "success"), /* @__PURE__ */ s.jsx(Jn, { variant: o, className: vn.alert, children: n });
  }
  render() {
    const {
      className: e,
      labelFor: t,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      vn.root,
      {
        [vn.rootDisabled]: i
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": dg,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            qs,
            {
              required: r,
              htmlFor: t,
              helpIcon: l,
              className: vn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Ps extends k {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: i,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Xe,
          {
            status: z.getStatus(o),
            disabled: i,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const hg = "h-dropdownSelect--dropdownSelectContainer__search", ug = "h-dropdownSelect--dropdownSelectContainer__pagination", pg = "h-dropdownSelect--dropdownSelectContainer__selectionActions", gg = "h-dropdownSelect--dropdownSelectContainer__extra", wn = {
  search: hg,
  pagination: ug,
  selectionActions: pg,
  extra: gg
}, mg = "DROP_SEARCH_INPUT";
class Hr extends xe {
  listRef;
  searchRef;
  static getDerivedStateFromProps(e, t) {
    const { dropdownOpen: n } = e, o = { ...t };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(e) {
    super(e), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = O(), this.searchRef = O();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(e) {
    const { dropdownOpen: t } = this.props;
    !e.dropdownOpen && t && this.onOpen();
  }
  getInput() {
    const { searchValue: e } = this.state;
    return {
      name: mg,
      value: e,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(e) {
    const { key: t } = e, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: i, disabledItems: l = [] } = this.props, c = i.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (t === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "Home")
      e.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "End")
      e.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (t === "Enter") {
      e.preventDefault();
      const h = i[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const g = p.some((m) => (typeof m == "object" ? m.id : m) === h.id);
          this.onChange(h, !g);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(e) {
    const { key: t } = e, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: i = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !i.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (t === "Escape")
      o();
    else if (t === "ArrowDown") {
      if (e.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (t === "ArrowUp") {
      if (e.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else t === "Home" ? (e.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : t === "End" && (e.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(e) {
    const { onSearch: t } = this.props, { value: n } = e.target;
    typeof t == "function" && t(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(e) {
    const { onSelect: t, keepOpen: n, triggerClose: o } = this.props;
    typeof t == "function" && t(e), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(e, t) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(e, t), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: e } = this.props;
    e ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: e } = this.props;
    if (e && this.searchRef.current) {
      const t = this.searchRef.current.querySelector("input");
      t && t.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: e } = this.props, { searchValue: t } = this.state;
    t && (typeof e == "function" && e(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: e,
      itemComponent: t,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: i,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: g,
      onChange: m,
      onClear: b,
      onClearText: y,
      triggerClose: v,
      dropdownOpen: w,
      emptyMessage: S,
      selectedItems: C,
      disabledItems: x,
      tooltipItems: _,
      activeItem: I,
      itemsDisplayCount: T,
      itemHeight: P,
      renderSuggestion: M,
      searchSuggestion: D,
      ...E
    } = this.props;
    if (!w)
      return null;
    const { searchValue: A, activeItemIndex: K } = this.state, se = i.length === 0, ne = i[K] ?? I ?? i[0] ?? null, $ = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...E, className: $, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: wn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Ps,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: wn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: A,
            onSuggest: g,
            triggerClose: h ? void 0 : v,
            clearSearch: this.clearSearch,
            items: i,
            searchSuggestion: D,
            renderSuggestion: M
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !se && /* @__PURE__ */ s.jsx(
          Gs,
          {
            ref: this.listRef,
            pagination: d,
            items: i,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: C,
            disabledItems: x,
            itemComponent: t,
            tooltipItems: _,
            itemsDisplayCount: T,
            itemHeight: P,
            activeItem: ne
          }
        ),
        se && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: S || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: wn.selectionActions, children: /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "secondary",
          disabled: C?.length === 0,
          onClick: b,
          children: y || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: wn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          te,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          te,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class Wr extends k {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: Zn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: e,
      items: t,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: i,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: g,
      suggestionComponent: m,
      children: b,
      buttonProps: y,
      dropdownProps: v,
      containerProps: w,
      pagination: S,
      emptyComponent: C,
      emptyMessage: x,
      selectedItems: _,
      disabledItems: I,
      tooltipItems: T,
      activeItem: P,
      itemsDisplayCount: M,
      itemHeight: D,
      optionComponent: E,
      renderSuggestion: A,
      searchSuggestion: K,
      ...se
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Nt,
      {
        ...se,
        className: e,
        buttonProps: { variant: "secondary", ...y },
        dropdownProps: v,
        dropdown: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: ne, dropdownOpen: $ }) => /* @__PURE__ */ s.jsx(
          Hr,
          {
            ...w,
            items: t,
            itemComponent: g,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: m,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: i,
            onClearText: l,
            onKeyDown: c,
            triggerClose: ne,
            dropdownOpen: $,
            pagination: S,
            emptyComponent: C,
            emptyMessage: x,
            selectedItems: _,
            disabledItems: I,
            tooltipItems: T,
            activeItem: P,
            itemsDisplayCount: M,
            itemHeight: D,
            optionComponent: E,
            renderSuggestion: A,
            searchSuggestion: K
          }
        ) }),
        children: b
      }
    );
  }
}
const fg = "h-fieldButton--fieldButton__button", bg = {
  button: fg
}, Xk = W(
  function({
    className: e,
    buttonClassName: t,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: i,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const g = f(t, bg.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: i,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          te,
          {
            ref: p,
            disabled: r,
            ...u,
            className: g,
            children: h
          }
        )
      }
    );
  }
), yg = "h-inputDatePicker--inputDatePicker__root", xg = "h-inputDatePicker--inputDatePicker__inputContainer", _g = "h-inputDatePicker--inputDatePicker__input", Cg = "h-inputDatePicker--inputDatePicker__rootReadOnly", vg = "h-inputDatePicker--inputDatePicker__iconsContainer", wg = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", Sg = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", Ig = "h-inputDatePicker--inputDatePicker__calendarIcon", kg = "h-inputDatePicker--inputDatePicker__clearIcon", Oe = {
  root: yg,
  inputContainer: xg,
  input: _g,
  rootReadOnly: Cg,
  iconsContainer: vg,
  rootHasClearIcon: wg,
  rootHasWrapperIcon: Sg,
  calendarIcon: Ig,
  clearIcon: kg
}, Dg = "inputDatePickerTestId";
class Tg extends k {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(e) {
    super(e), this.inputRef = O(), this.rootRef = O(), this.datePickerContainerRef = O(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Ft(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(e) {
    const { onChange: t, value: n } = this.props;
    typeof t == "function" && t(e), (n ?? e !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: e } = this.props;
    e || this.showDropdown();
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: e }) {
    Yn(e) && this.showDropdown();
  }
  handleCalendarIconClick(e) {
    const { readOnly: t } = this.props;
    t || (e.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: e,
      name: t,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: i,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: g,
      clearable: m,
      minDate: b,
      maxDate: y,
      readOnly: v,
      ...w
    } = this.props, { isDropdownOpen: S } = this.state;
    return /* @__PURE__ */ s.jsx(
      Me,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: S,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Oe.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ...w,
              id: t,
              name: t,
              className: Oe.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Hn(n) ? void 0 : n?.format(r) ?? "",
              onChange: Hn(n) ? void 0 : L,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Oe.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      q,
      {
        className: Oe.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon() {
    const { clearable: e, value: t, disabled: n } = this.props;
    return !e || !t ? null : /* @__PURE__ */ s.jsx(
      q,
      {
        className: Oe.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: i,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(nt, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      eg,
      {
        disabled: i,
        ...r,
        dateFormat: c,
        date: e ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: t,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, i = f(Oe.root, e, {
      [Oe.rootHasClearIcon]: n && t,
      [Oe.rootHasWrapperIcon]: !!r,
      [Oe.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Dg,
        ref: this.rootRef,
        className: i,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Zk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      date: e?.date ? e.date.toISOString() : "",
      localDate: e?.localDate ? e.localDate.toISOString() : "",
      timezone: e?.timezone || "",
      localTimezone: e?.localTimezone || ""
    });
  }
  render() {
    const {
      className: e,
      input: { value: t, name: n, onChange: o, ...r },
      label: i,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: g,
      ...m
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: i,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: g,
        children: /* @__PURE__ */ s.jsx(
          Tg,
          {
            name: n,
            value: Ns(t?.localDate) ? j(t.localDate, j.ISO_8601) : null,
            timezone: t?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...m
          }
        )
      }
    );
  }
}
const jg = "h-inputDateRangePicker--inputDateRangePicker__root", Fg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", Ng = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Pg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", Rg = "h-inputDateRangePicker--inputDateRangePicker__input", Eg = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", Lg = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", Ag = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", $g = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", Og = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Bg = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Hg = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", Wg = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Mg = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", he = {
  root: jg,
  inputsContainer: Fg,
  arrowContainer: Ng,
  inputContainer: Pg,
  input: Rg,
  rootReadOnly: Eg,
  iconsContainer: Lg,
  rootStartDateHasClearIcon: Ag,
  startDateIconsContainer: $g,
  rootEndDateHasClearIcon: Og,
  endDateIconsContainer: Bg,
  rootHasWrapperIcon: Hg,
  calendarIcon: Wg,
  clearIcon: Mg
}, zg = "inputDateRangePickerTestId";
class on extends k {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(e, t) {
    return e[t] || `${e}__${t}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(e) {
    super(e), this.inputsRef = {
      startDate: O(),
      endDate: O()
    }, this.rootRef = O(), this.dateRangePickerContainerRef = O(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(e, t) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== t.isDropdownOpen || o !== t.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: e } = this.state, t = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    e === "startDate" ? t?.[0]?.focus() : t?.[1]?.focus();
  }
  handleWindowClick(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleWindowKeyDown(e) {
    Ft(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(e) {
    const { onChange: t, value: n } = this.props, { focusedInput: o } = this.state;
    typeof t == "function" && t(e), (n?.[o] ?? e[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(e, t) {
    const { value: n, timezone: o, localTimezone: r } = this.props, i = {
      startDate: t === "startDate" ? null : n?.startDate ?? null,
      localStartDate: t === "startDate" ? null : n?.localStartDate ?? null,
      endDate: t === "endDate" ? null : n?.endDate ?? null,
      localEndDate: t === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(i);
  }
  showDropdown(e) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: e,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(e, t) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(t);
  }
  handleInputBlur(e) {
    this.rootRef.current?.contains(e.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: e }, t) {
    Yn(e) && this.showDropdown(t);
  }
  handleInputClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  handleCalendarIconClick(e, t) {
    const { readOnly: n } = this.props;
    n || (e.stopPropagation(), this.showDropdown(t));
  }
  get dateFormat() {
    const { dateFormat: e } = this.props;
    return e || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: e, suffix: t, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: i } = this.state;
    return /* @__PURE__ */ s.jsx(
      Me,
      {
        prefix: e,
        suffix: t,
        disabled: r,
        icon: n,
        active: i,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: he.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: he.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(e, t) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: i,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: g,
      onChange: m,
      placeholder: b,
      prefix: y,
      readOnly: v,
      status: w,
      suffix: S,
      tabIndex: C,
      timezone: x,
      value: _,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: he.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: on.getInputName(g, e),
          name: on.getInputName(g, e),
          className: he.input,
          ref: this.inputsRef[e],
          onClick: (T) => this.handleInputClick(T, e),
          onFocus: (T) => this.handleInputFocus(T, e),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, e),
          disabled: l,
          placeholder: b?.[e] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: _ && j(_[e]).isValid() ? j(_[e]).format(this.dateFormat) : "",
          onChange: Hn(_) ? void 0 : L,
          tabIndex: t ?? C,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(he.iconsContainer, {
            [he.startDateIconsContainer]: e === "startDate",
            [he.endDateIconsContainer]: e === "endDate"
          }),
          children: [
            this.renderClearIcon(e),
            this.renderCalendarIcon(e)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(e) {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      q,
      {
        className: he.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, e),
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon(e) {
    const { clearable: t, value: n, disabled: o } = this.props;
    return !t || !n?.[e] ? null : /* @__PURE__ */ s.jsx(
      q,
      {
        className: he.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, e)
      }
    );
  }
  renderDropdown() {
    const {
      value: e,
      minDate: t,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: i,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(nt, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Up,
      {
        disabled: i,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: e?.startDate ?? null,
        endDate: e?.endDate ?? null,
        timezone: o ?? null,
        minDate: t,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: e, value: t, clearable: n, readOnly: o, icon: r } = this.props, i = f(he.root, e, {
      [he.rootStartDateHasClearIcon]: n && t?.startDate,
      [he.rootEndDateHasClearIcon]: n && t?.endDate,
      [he.rootHasWrapperIcon]: !!r,
      [he.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": zg,
        ref: this.rootRef,
        className: i,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Jk extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const {
      input: { onChange: t }
    } = this.props;
    t?.({
      startDate: e?.startDate ? e.startDate.toISOString() : "",
      localStartDate: e?.localStartDate ? e.localStartDate.toISOString() : "",
      endDate: e?.endDate ? e.endDate.toISOString() : "",
      localEndDate: e?.localEndDate ? e.localEndDate.toISOString() : "",
      timezone: e?.timezone ?? "",
      localTimezone: e?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: e,
    localEndDate: t
  }) {
    const n = Ns(e) ? j(e, j.ISO_8601) : null, o = Ns(t) ? j(t, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: e,
      input: { name: t, value: n, onChange: o, ...r },
      label: i,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: g,
      ...m
    } = this.props, { timezone: b, localTimezone: y } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: i,
        labelFor: on.getInputName(t, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: g,
        children: /* @__PURE__ */ s.jsx(
          on,
          {
            name: t,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: y,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...m
          }
        )
      }
    );
  }
}
const Vg = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode",
  "blockquote"
], dt = (a) => Ra(a), Zs = (a, e = window) => e.getComputedStyle(a).display === "block", Ze = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function ms(a, e) {
  const t = {
    ctrlKey: [
      "Control",
      ...Ze ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Ze ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Ze ? ["$metaOrCtrl"] : []]
  };
  return a.some((n) => {
    if (e.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(t).every(
      ([r, i]) => {
        const l = Ea(
          i,
          o
        ).length;
        return e[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Kg = (a, e, t) => {
  if (!a || e < 0 || t < 0) return !1;
  const n = a?.textContent?.length ?? 0;
  return !(e > n || t > n);
}, Ug = (a, e) => a.document.queryCommandState(e), qg = (a) => a.document.queryCommandValue("formatBlock"), Gg = (a) => a.type.indexOf("image/") === 0, Ao = (a, e) => {
  const t = tn();
  return {
    src: (a.URL || a.webkitURL).createObjectURL(e),
    uid: t
  };
}, Yg = (a) => {
  a && a.querySelectorAll("td").forEach((e) => {
    e.style.border = "1px solid currentColor";
  });
}, Rs = (a) => {
  a.setAttribute("dir", "auto");
  const e = window.getComputedStyle(a).direction;
  a.setAttribute("dir", e);
}, $o = (a) => {
  a && a.childNodes.forEach((e) => {
    e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE || dt(e) && Zs(e) && Rs(e);
  });
}, Js = (a, e = !0) => {
  const t = document.createElement("div");
  return t.style.display = "none", t.innerHTML = a, document.body.appendChild(t), t.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (dt(n) && Zs(n))
        n.innerHTML = Js(n.innerHTML, !1), Rs(n);
      else if (e) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), Rs(o);
      }
    }
  }), document.body.removeChild(t), t.innerHTML;
}, Oo = (a, e = { side: "both" }) => {
  const { side: t } = e, n = a.split(""), o = " ", r = "&nbsp;";
  let i = 0, l = n.length - 1;
  if (t === "both" || t === "start")
    for (; n[i] === o; )
      n[i++] = r;
  if (t === "both" || t === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Vn = (a, e) => a.split(/\r\n|\r|\n/g).map((t, n) => t ? e.inline && n === 0 ? Oo(t, { side: "end" }) : `<div>${Oo(t)}</div>` : "<br />").join("");
function Qg(a) {
  const e = "&nbsp;", o = Xg(a.anchorNode), r = Zg(a.anchorNode);
  if (a.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(e)) {
    const { focusOffset: i, anchorOffset: l } = a, c = Array.prototype.indexOf.call(
      a.anchorNode.parentElement?.childNodes,
      a.anchorNode
    ), d = r.replaceAll(e, " ").replace(/.$/, " "), h = document.createTextNode(d);
    if (a.anchorNode.parentElement?.childNodes[c].replaceWith(h), a?.rangeCount && a?.rangeCount > 0 && Kg(h, i, l)) {
      const u = a.getRangeAt(0);
      u.setStart(h, i), u.setEnd(h, l);
    }
  }
}
function Xg(a) {
  if (!a)
    return "";
  if (a instanceof Element)
    return a.innerHTML;
  const e = document.createElement("span");
  return e.appendChild(a.cloneNode()), e.innerHTML;
}
function Zg(a) {
  return !a || !a.textContent ? "" : a.textContent;
}
const Jg = "h-inputRichText-addonTrigger--addonTrigger__root", em = {
  root: Jg
};
function tm(a) {
  if (!a)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = a;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e) || null;
}
const Sn = (a, e) => {
  const t = Mr(a, e);
  return t && a.triggers.isAddonTrigger(t.matchedTrigger) ? t.matchedTrigger : null;
}, In = (a, e) => {
  const t = Mr(a, e);
  return t ? t.match : null;
}, Mr = (a, e) => e ? a.triggers.test(e) : null, Bo = "input-rich-text-addon-trigger", nm = (a, e) => {
  const t = a.selection.recreate({ focus: !1 });
  if (!t || !e) return null;
  const n = t.getRangeAt(0).getBoundingClientRect();
  return a.ref.current && n && t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0).getBoundingClientRect() : null;
}, sm = (a, e) => {
  if (a.ref.current && e) {
    const t = a.ref.current.getBoundingClientRect();
    return {
      left: `${e.x - t.x}px`,
      top: `${e.y - t.y}px`,
      height: "0",
      width: `${e.width}px`,
      position: "absolute"
    };
  }
  return {};
}, Ge = (a) => tm(a.selection.recreate({ focus: !1 })) || "", fs = (a, e) => !!e && a.triggers.isAddonTrigger(e), bs = (a) => a?.nodeType === Node.ELEMENT_NODE, Es = (a, e) => a.dataset.testid === e ? a : a.parentElement ? Es(a.parentElement, e) : null, xt = {};
class om extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(e, t, n) {
    super.addEventListener(e, t, n), t && this.callbacks[e].push(t);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(e) {
    this.callbacks[e].forEach((t) => {
      this.removeEventListener(e, t);
    }), this.callbacks[e] = [];
  }
}
const St = new om(), rm = Ie({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: St
});
var am = /* @__PURE__ */ ((a) => (a.FOCUS = "focus", a.INSERT = "insert", a.UP = "up", a.DOWN = "down", a))(am || {});
const im = (a) => {
  const { editor: e } = a, [t, n] = V(null), [o, r] = V(null), [i, l] = V(null), [c, d] = V(!1), h = sm(e, i), [u] = V(tn()), { dismissText: p } = xt[u] ?? { dismissText: "" }, g = t?.[0] ?? "", m = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  g?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = F(() => {
    const _ = Sn(e, Ge(e)), I = In(e, Ge(e)), T = nm(e, _);
    fs(e, _) && _?.shouldHandleSelectionChange?.() !== !1 ? (r(_), n(I), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [e]), y = F(() => {
    const _ = Sn(e, Ge(e)), I = In(e, Ge(e))?.[0];
    return fs(e, _) && !!I;
  }, [e]), v = F(() => {
    const _ = Sn(e, Ge(e)), I = In(e, Ge(e))?.[0], T = xt[u]?.dismissText || "", P = T ? I?.startsWith(T) : !1;
    return fs(e, _) && !!I && !P;
  }, [e, u]), w = F(() => {
    e.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: v,
        callback: () => {
          St.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: v,
        callback: () => {
          St.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: v,
        callback: () => {
          St.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: v,
        callback: () => {
          St.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: v,
        callback: (_, I) => {
          const T = In(e, Ge(e))?.[0];
          if (!T) {
            xt[u] = {
              dismissText: ""
            };
            return;
          }
          Sn(e, Ge(e))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), xt[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [e, v, u]);
  Z(() => {
    y() && p !== g && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (m && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !m && o?.persistOnEsc === !1) && (xt[u] = {
      dismissText: ""
    });
  }, [p, m, y, g, u, o]);
  const S = F((_) => {
    const I = _.nativeEvent.relatedTarget, T = bs(I) && Es(I, Xr), P = bs(I) && Es(I, Bo);
    (!bs(I) || !T && !P) && d(!1);
  }, []), C = F(
    (_, { inline: I } = {}) => {
      const T = e.selection.recreate();
      if (!T || !o)
        return;
      const M = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        Js(
          Vn(_, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Vn(_, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && e.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(M),
        {
          getSelection: () => {
            const D = e.selection.recreate();
            if (!D)
              return null;
            const { focusOffset: E } = D, se = o.trigger.exec(g)?.[1]?.length ?? 0, ne = g.length - se, $ = E - ne;
            if (D?.anchorNode && $ >= 0)
              try {
                D.extend(D.anchorNode, $);
              } catch {
              }
            return D;
          }
        }
      );
    },
    [e, g, o]
  );
  if (ht(() => {
    w(), e.selection.onUpdate(b), e.events.onBlur(S);
  }), tt(() => {
    delete xt[u];
  }), !o || !c || !g || m)
    return null;
  const x = o.customContainer?.current || e.ref.current?.ownerDocument?.body || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(La, { open: !0, children: [
    /* @__PURE__ */ s.jsx(Aa, {}),
    /* @__PURE__ */ s.jsx($a, { container: x, children: /* @__PURE__ */ s.jsx(
      Oa,
      {
        onOpenAutoFocus: (_) => _.preventDefault(),
        "data-testid": Bo,
        className: em.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? "start",
        children: /* @__PURE__ */ s.jsx(
          rm.Provider,
          {
            value: { matchText: g, insertContent: C, eventEmitter: St },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, lm = "h-inputRichText-toolbarButton--toolbarButton__root", cm = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", dm = "h-inputRichText-toolbarButton--toolbarButton__rootActive", hm = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", Mt = {
  root: lm,
  rootDisabled: cm,
  rootActive: dm,
  rootWithBadge: hm
};
function Re({
  className: a,
  isActive: e,
  icon: t,
  disabled: n,
  showBadge: o,
  tooltip: r,
  tabIndex: i = -1,
  ...l
}) {
  const c = f(
    {
      [Mt.root]: Mt.root,
      [Mt.rootActive]: e,
      [Mt.rootDisabled]: n,
      [Mt.rootWithBadge]: o
    },
    a
  ), d = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: i,
      type: "button",
      ...l,
      className: c,
      disabled: n,
      children: /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: t }) })
    }
  );
  return r ? /* @__PURE__ */ s.jsx(le, { content: r, side: "top", wrap: "none", children: d }) : d;
}
const um = "h-inputRichText-attachmentButton--attachmentButton__dropzone", pm = "h-inputRichText-attachmentButton--attachmentButton__fileInput", gm = "h-inputRichText-attachmentButton--attachmentButton__dropdown", mm = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", kn = {
  dropzone: um,
  fileInput: pm,
  dropdown: gm,
  dropzoneIcon: mm
};
let fm = class extends k {
  static displayName = "AttachmentButtonDropzone";
  constructor(e) {
    super(e), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowAttachments: t } = this.props;
    !t || !e.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && t(e.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: i,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(e), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          t,
          h && /* @__PURE__ */ s.jsx(et, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const bm = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class ym extends k {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(e) {
    super(e), this.fileInputRef = O(), this.unsubscribeAddAttachment = Xa;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (e) => {
    e.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  handleFileChanged = (e) => {
    const { onAttachFiles: t, editorWindow: n } = this.props, o = e.target;
    o !== null && o instanceof n.HTMLInputElement && (t(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: e, attachments: t, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: kn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        fm,
        {
          className: kn.dropzone,
          onAddAttachment: n,
          attachments: t,
          isAttachmentsUploading: e,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: kn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  render() {
    const {
      className: e,
      attachments: t,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: i,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      fixed: h,
      ...u
    } = this.props, p = /* @__PURE__ */ s.jsx(
      Re,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: t.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(le, { content: d, disabled: !d, children: p }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: kn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        Nt,
        {
          ...u,
          className: e,
          noStyle: !0,
          fixed: h,
          ref: i,
          dropdown: this.renderDropdown(),
          children: p
        }
      )
    ] });
  }
}
const xm = "h-inputRichText-dropzone--dropzone__root", _m = "h-inputRichText-dropzone--dropzone__inlineDropzone", Cm = "h-inputRichText-dropzone--dropzone__attachmentDropzone", vm = "h-inputRichText-dropzone--dropzone__rootDual", wm = "h-inputRichText-dropzone--dropzone__icon", _t = {
  root: xm,
  inlineDropzone: _m,
  attachmentDropzone: Cm,
  rootDual: vm,
  icon: wm
};
class Sm extends k {
  static displayName = "InputRichTextDropzone";
  internalDrag = !1;
  constructor(e) {
    super(e), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragStart = () => {
    this.internalDrag = !0;
  };
  handleDragEnd = () => {
    this.internalDrag = !1;
  };
  handleDragEnter = (e) => {
    e.preventDefault();
    const { allowInlineAttachments: t, allowAttachments: n } = this.props;
    if (!t && !n || this.internalDrag) return;
    const o = e.dataTransfer?.types, r = o?.includes("Files"), i = o?.includes("text/uri-list");
    !r && !i || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (e) => {
    e.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (e) => {
    e.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  async fetchDroppedUrl(e, t) {
    if (e.files.length > 0) {
      t(e.files);
      return;
    }
    const n = e.getData("text/uri-list");
    if (n) {
      try {
        const o = new URL(n);
        if (o.protocol !== "http:" && o.protocol !== "https:") return;
      } catch {
        return;
      }
      try {
        const o = await fetch(n);
        if (!o.ok) return;
        const r = await o.blob(), i = n.split("/").pop()?.split("?")[0] || "dropped-image", l = new File([r], i, { type: r.type }), c = new DataTransfer();
        c.items.add(l), t(c.files);
      } catch {
      }
    }
  }
  handleInlineDrop = (e) => {
    e.preventDefault();
    const { onAddInline: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (e) => {
    e.preventDefault();
    const { onAddAttachment: t } = this.props;
    e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: e,
      children: t,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: i,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [_t.root]: !0,
        [_t.rootDual]: n && o
      },
      e
    ), g = n || o, m = {};
    return i && (m.onClick = i), g && (m.onDragStart = this.handleDragStart, m.onDragEnd = this.handleDragEnd, m.onDragEnter = this.handleDragEnter, m.onDragOver = this.handleDragEnter, m.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...m,
        children: [
          t,
          (h || u) && /* @__PURE__ */ s.jsxs(et, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: _t.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: _t.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: _t.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: _t.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const zr = (a, e) => a.split(new RegExp(`(${Hs(e)})`, "gi")).map(
  (t, n) => t.toLowerCase() === e.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: t }, n) : t
), Im = "h-inputRichText-emoji--emoji__root", km = "h-inputRichText-emoji--emoji__decorator", Dm = "h-inputRichText-emoji--emoji__suggestion", Tm = "h-inputRichText-emoji--emoji__suggestionActive", jm = "h-inputRichText-emoji--emoji__suggestionName", Zt = {
  root: Im,
  decorator: km,
  suggestion: Dm,
  suggestionActive: Tm,
  suggestionName: jm
}, Fm = Ka(
  () => import("./emoji-r0LV8WWJ.js").then((a) => a.k).then((a) => ({
    default: a.EmojiPicker
  }))
), Kn = {};
Wa.emojis.forEach((a) => {
  a.forEach(
    (e) => {
      e.shortNames && e.shortNames.forEach((t) => {
        Kn[t.replace(/:/g, "")] = e.emoji;
      });
    }
  );
});
const Nm = (a) => {
  const { active: e, item: t, match: n, onSelect: o } = a, r = n ? zr(t, n) : t;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(t),
      type: "button",
      "aria-current": e,
      className: f(Zt.suggestion, {
        [Zt.suggestionActive]: e
      }),
      children: [
        Kn[t],
        /* @__PURE__ */ s.jsx("span", { className: Zt.suggestionName, children: r })
      ]
    }
  );
};
class Pm extends k {
  constructor(e) {
    super(e), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Nm,
      insertContent: this.insertContent
    });
  }
  insertContent(e, t = "", n) {
    this.insertEmoji(Kn[e], t, n);
  }
  insertEmoji(e, t, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(Zt.decorator), r.innerHTML = e, o.content.insert(r, {
      getSelection: () => {
        const i = o.selection.recreate();
        return t && i?.anchorNode && i.extend(i.anchorNode, n), i;
      }
    });
  }
  getSuggestions = (e) => Object.keys(Kn).filter((n) => n.indexOf(e) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Ua, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ s.jsx(
    Fm,
    {
      onSelect: (t) => {
        this.insertEmoji(t), e();
      }
    }
  ) }) });
  render() {
    const { className: e, fixed: t } = this.props, n = f(
      {
        [Zt.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { className: n, children: /* @__PURE__ */ s.jsx(
      Nt,
      {
        icon: "smile",
        dropdown: this.renderDropdown(),
        noStyle: !0,
        fixed: t,
        children: /* @__PURE__ */ s.jsx(
          Re,
          {
            icon: "smile",
            tooltip: "Emojis",
            onMouseDown: this.preventDefault
          }
        )
      }
    ) });
  }
}
const Rm = "h-inputRichText--inputRichText__inputWrapper", Em = "h-inputRichText--inputRichText__root", Lm = "h-inputRichText--inputRichText__toolbar", Am = "h-inputRichText--inputRichText__toolbarEnd", $m = "h-inputRichText--inputRichText__toolbarHint", Om = "h-inputRichText--inputRichText__toolbarHintVisible", Bm = "h-inputRichText--inputRichText__toolbarHintHidden", Hm = "h-inputRichText--inputRichText__editorWrap", Wm = "h-inputRichText--inputRichText__placeholder", Mm = "h-inputRichText--inputRichText__editor", zm = "h-inputRichText--inputRichText__editorDisabled", Vm = "h-inputRichText--inputRichText__fileInput", Km = "h-inputRichText--inputRichText__uiBlocker", ue = {
  inputWrapper: Rm,
  root: Em,
  toolbar: Lm,
  toolbarEnd: Am,
  toolbarHint: $m,
  toolbarHintVisible: Om,
  toolbarHintHidden: Bm,
  editorWrap: Hm,
  placeholder: Wm,
  editor: Mm,
  editorDisabled: zm,
  fileInput: Vm,
  uiBlocker: Km
};
function Vr(a, e) {
  const t = (n) => n.replace(/&/g, "&amp;");
  return `<a href="${t(a)}">${t(e)}</a>`;
}
function eo(a) {
  if (!a || a.length === 0)
    return "";
  const [e = [], t = ""] = a[0];
  if (!t)
    return "";
  const n = e.map((r) => Um(r)).filter(Boolean), o = qm(t);
  return Ze ? [...n, o].join("") : [...n, o].join("+");
}
function Um(a) {
  if (Ze)
    switch (a) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return a;
    }
  switch (a) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return a;
  }
}
function qm(a) {
  if (a.startsWith("Key"))
    return a.slice(3);
  if (a.startsWith("Digit"))
    return a.slice(5);
  switch (a) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Ze ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Ze ? "⌫" : "Backspace";
    case "Delete":
      return Ze ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return a;
  }
}
const Gm = "h-inputRichText-linkButton--linkButton__linkOpener", Ym = "h-inputRichText-linkButton--linkButton__dropdownContainer", Ho = {
  linkOpener: Gm,
  dropdownContainer: Ym
}, Qm = "h-inputRichText-linkButton--linkMenu__root", Xm = "h-inputRichText-linkButton--linkMenu__field", ys = {
  root: Qm,
  field: Xm
};
class Zm extends k {
  constructor(e) {
    super(e);
    const { initialText: t, initialUrl: n } = e;
    this.state = {
      textValue: t,
      urlValue: n
    };
  }
  componentDidUpdate(e) {
    const { initialText: t, initialUrl: n } = this.props;
    (t !== e.initialText || n !== e.initialUrl) && this.setState({
      textValue: t,
      urlValue: n
    });
  }
  handleTextChange = (e) => {
    e && this.setState({
      textValue: e.target.value
    });
  };
  handleUrlChange = (e) => {
    e && this.setState({
      urlValue: e.target.value
    });
  };
  handleAddLink = (e) => {
    e?.preventDefault();
    const { onAddLink: t, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (t(o || void 0, r), n());
  };
  handleUnlink = (e) => {
    e.preventDefault();
    const { onUnlink: t, toggleDropdown: n } = this.props;
    t(), n();
  };
  handleKeyDown = (e) => {
    e.key === "Enter" && (e.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: e,
      initialText: t,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: i,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [ys.root]: !0 }, e);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Ps,
        {
          label: "Link title",
          noAlert: !0,
          className: ys.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ps,
        {
          label: "Link URL",
          noAlert: !0,
          className: ys.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(B, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(te, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(te, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const Kr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (a) => a.command.run("unlink")
  }
], Jm = ({ editor: a }) => {
  const [e, t] = qa((w) => w + 1, 0), [n, o] = Ga(!1), r = Q(null), i = Q(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Ya({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  ht(() => {
    a.events.onMouseOver((w) => {
      g(w);
    }), i.current = a.events.subscribe("hyperlink", () => {
      o(!0);
    }), a.selection.onUpdate(() => {
      p();
    });
  }), tt(() => {
    i.current?.();
  });
  const p = () => {
    const w = a.selection.recreate();
    if (!w)
      return;
    const { anchorNode: S, focusNode: C } = w;
    if (S && C === S && S.parentElement?.nodeName === "A") {
      const { href: x, innerText: _ } = S.parentElement;
      u({
        selectedLink: x,
        selectedText: _
      });
    } else
      u({
        selectedLink: "",
        selectedText: w.toString()
      });
  }, g = F(
    (w) => {
      const { target: S } = w, { current: C } = a.ref;
      if (C && S && S instanceof HTMLAnchorElement) {
        const x = C.getBoundingClientRect(), _ = S.getBoundingClientRect();
        u({
          hoverLinkHref: S.getAttribute("href"),
          hoverLinkBounds: {
            top: _.top - x.top,
            left: _.left - x.left,
            width: _.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [a.ref, u]
  ), m = F(() => {
    const w = a.selection.recreate();
    if (!w)
      return;
    const { anchorNode: S, focusNode: C } = w;
    if (S && S === C && S.parentElement?.nodeName === "A") {
      const x = document.createRange();
      x.selectNodeContents(S.parentElement), w.removeAllRanges(), w.addRange(x);
    }
  }, [a.selection]), b = F(
    (w, S) => {
      S && (m(), a.command.run("insertHTML", Vr(S, w || S)), t());
    },
    [a.command, m]
  ), y = F(() => {
    m(), a.command.run("unlink");
  }, [a.command, m]), v = F((w) => {
    w.preventDefault();
  }, []);
  return vr(r, () => {
    o(!1);
  }), Cr("Escape", () => {
    o(!1), m();
  }), /* @__PURE__ */ s.jsxs(et, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Ho.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Re,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: v,
          onClick: () => o(),
          tooltip: `Insert link (${eo(Kr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(nt, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        Zm,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: y
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Ho.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, ef = "h-tabs--tabs__root", tf = "h-tabs--tabs__tabs", nf = "h-tabs--tabs__tab", sf = "h-tabs--tabs__tabTop", of = "h-tabs--tabs__tabTopActive", rf = "h-tabs--tabs__tabTopSelected", af = "h-tabs--tabs__tabLeft", lf = "h-tabs--tabs__tabLeftActive", cf = "h-tabs--tabs__tabLeftSelected", df = "h-tabs--tabs__tabBottom", hf = "h-tabs--tabs__tabBottomActive", uf = "h-tabs--tabs__tabBottomSelected", pf = "h-tabs--tabs__tabRight", gf = "h-tabs--tabs__tabRightActive", mf = "h-tabs--tabs__tabRightSelected", ff = "h-tabs--tabs__tabDisabled", ae = {
  root: ef,
  tabs: tf,
  tab: nf,
  tabTop: sf,
  tabTopActive: of,
  tabTopSelected: rf,
  tabLeft: af,
  tabLeftActive: lf,
  tabLeftSelected: cf,
  tabBottom: df,
  tabBottomActive: hf,
  tabBottomSelected: uf,
  tabRight: pf,
  tabRightActive: gf,
  tabRightSelected: mf,
  tabDisabled: ff
}, bf = 13;
class yf extends k {
  constructor(e) {
    super(e), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: e, onChange: t, disabled: n } = this.props;
    n || t(e);
  }
  handleOnKeyDown(e) {
    e.keyCode === bf && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: e,
      placement: t,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: i
    } = this.props;
    let l = f(ae.tab, n, {
      [ae.tabDisabled]: o,
      [ae.tabTop]: t === "top",
      [ae.tabRight]: t === "right",
      [ae.tabLeft]: t === "left",
      [ae.tabBottom]: t === "bottom",
      [ae.tabTopSelected]: t === "top" && e,
      [ae.tabRightSelected]: t === "right" && e,
      [ae.tabLeftSelected]: t === "left" && e,
      [ae.tabBottomSelected]: t === "bottom" && e,
      [ae.tabTopActive]: t === "top" && r,
      [ae.tabRightActive]: t === "right" && r,
      [ae.tabLeftActive]: t === "left" && r,
      [ae.tabBottomActive]: t === "bottom" && r
    });
    return i && (l = f(l, { [i]: e })), l;
  }
  render() {
    const { id: e, label: t, icon: n, disabled: o, slotEnd: r, slotStart: i } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          i || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          t,
          r
        ]
      },
      e
    );
  }
}
class to extends k {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.containerRef = O(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: e,
    label: t,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: i
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      yf,
      {
        selected: e === l,
        className: u,
        selectedClassName: p,
        id: e,
        label: t,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: e === c,
        slotEnd: r,
        slotStart: i
      },
      e
    );
  }
  renderTabs() {
    const { tabs: e } = this.props;
    return e.map(this.renderTab);
  }
  render() {
    const {
      className: e,
      tabClassName: t,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: i,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(ae.root, e);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: ae.tabs, children: this.renderTabs() }) });
  }
}
const xf = ln(to, {
  fallback: null
}), _f = "h-inputRichText-quickResponseSelector--quickResponseItem__root", Cf = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", vf = "h-inputRichText-quickResponseSelector--quickResponseItem__name", zt = {
  root: _f,
  rootActive: Cf,
  name: vf
};
class xs extends k {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: e, onSelect: t, item: n } = this.props;
    e || t(n);
  }
  render() {
    const {
      className: e,
      item: t,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: i,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && t ? t : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [zt.root]: zt.root,
        [zt.rootActive]: r
      },
      e
    ), g = u ? zr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(H.Heading, { variant: "heading-3", className: zt.name, children: g }),
          /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "4", className: zt.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const wf = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", Sf = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", If = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", kf = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", Df = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Tf = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", Ct = {
  container: wf,
  dropdownButtonContainer: Sf,
  tabbedDropdown: If,
  tabbedDropdownTabs: kf,
  tabbedDropdownTabsContent: Df,
  regularDropdown: Tf
}, Wo = /(^|\s)=/, _s = "Quick replies";
class jf extends xe {
  constructor(e) {
    super(e), this.state = {
      searchTerm: "",
      selectedTab: e.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.triggers.add({
      trigger: Wo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: xs,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(e) {
    const { quickResponsesApi: t } = this.props;
    return {
      id: e.name,
      matched: t.params.search ?? "",
      ...e
    };
  }
  getTabDefinitions() {
    const { languages: e } = this.props;
    return e.map((t) => ({
      id: t.code,
      label: t.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: e } = this.props;
    return new Promise((t) => e.getItemsAsyncStatus === "loading" ? t(e.items.map(this.normalizeSuggestion)) : t(
      e.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (e) => {
    e.preventDefault();
  };
  handleSelect = (e, t) => {
    this.insertContent(e)?.then(() => {
      t && t();
    });
  };
  insertContent = (e, t, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: i } = this.props;
    return o(e).then((l) => {
      const c = i.selection.recreate();
      if (!c)
        return;
      const d = !!t, h = d && !!c.anchorNode?.textContent?.match(
        `^${Wo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = Js(
        Vn(r(l), { inline: !1 })
      ) : u = Vn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && i.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = i.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(e) {
    const { quickResponsesApi: t, languages: n } = this.props;
    e && (t.params.search !== "" || t.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: e } = this.props;
    return {
      nextEnable: e.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(e, t, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: e, locale: t }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(e) {
    this.setState({ searchTerm: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n);
    });
  }
  handleTabChange(e) {
    this.setState({ selectedTab: e }, () => {
      const { searchTerm: t, selectedTab: n } = this.state;
      this.handleSearchChange(t, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Re,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: e, quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(le, { content: `${_s} (=)`, children: /* @__PURE__ */ s.jsx(
      Wr,
      {
        className: e,
        dropdownProps: {
          className: Ct.regularDropdown
        },
        containerProps: { className: Ct.container },
        items: t.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: xs,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: e } = this.props, { selectedTab: t } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: Ct.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(le, { content: `${_s} (=)`, children: /* @__PURE__ */ s.jsx(
      Nt,
      {
        className: e,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: _s },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: Ct.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            to,
            {
              className: Ct.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: t,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: Ct.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ dropdownOpen: t, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      Hr,
      {
        dropdownOpen: t,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: e.items.map(this.normalizeSuggestion),
        itemComponent: xs,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: Zn,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: e } = this.props;
    return e?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Ff = "h-inputRichText-formatSelector--formatSelector__root", Nf = "h-inputRichText-formatSelector--formatSelector__list", Pf = "h-inputRichText-formatSelector--formatSelector__selector", Rf = "h-inputRichText-formatSelector--formatSelector__option", Ef = "h-inputRichText-formatSelector--formatSelector__optionActive", Lf = "h-inputRichText-formatSelector--formatSelector__button", vt = {
  root: Ff,
  list: Nf,
  selector: Pf,
  option: Rf,
  optionActive: Ef,
  button: Lf
}, Ls = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "div"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H1>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H2>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H3>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H4>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H5>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (a) => a.allowFormatting.includes("format")
  }
], Mo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Af extends k {
  preventDefault = (e) => {
    e.preventDefault();
  };
  renderDropdown() {
    const { editor: e } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ closeDropdown: t }) => /* @__PURE__ */ s.jsx("ul", { className: vt.list, children: Ls.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(e)))
        return;
      const i = Mo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(vt.option, {
            [vt.optionActive]: this.isActiveFormat(i)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: vt.button,
              onClick: () => {
                n.callback?.(e), t();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(e) {
    const { formatBlock: t } = this.props;
    return !!(!t && e.default || e.tag === t || e.tag === `<${t.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return Ls.find(
      (e) => this.isActiveFormat(Mo[e.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: e, editor: t, formatBlock: n, ...o } = this.props, r = f(vt.root, e);
    return /* @__PURE__ */ s.jsx(
      Nt,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: vt.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const $f = "h-inputRichText-stylingMenu--stylingMenu__menu", Of = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", zo = {
  menu: $f,
  buttonsContainer: Of
}, Ur = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (a) => a.command.run("bold"),
    condition: (a) => a.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (a) => a.command.run("italic"),
    condition: (a) => a.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (a) => a.command.run("insertOrderedList"),
    condition: (a) => a.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (a) => a.command.run("insertUnorderedList"),
    condition: (a) => a.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (a) => a.command.run("inlineCode"),
    condition: (a) => a.allowFormatting.includes("inlineCode")
  },
  {
    name: "blockquote",
    label: "Quote text",
    icon: "quote",
    keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
    callback: (a) => {
      const e = a.window.getSelection();
      if (!e) return;
      const t = e.anchorNode, o = !!(dt(t) ? t : t?.parentElement)?.closest("blockquote");
      a.command.run("formatBlock", o ? "div" : "<BLOCKQUOTE>");
    },
    condition: (a) => a.allowFormatting.includes("blockquote")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (a) => a.command.run("removeFormat")
  }
], qr = [...Ls, ...Ur];
class Bf extends k {
  domRef;
  constructor(e) {
    super(e), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = O(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(e, t) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== t.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: e } = this.state, { editorWindow: t } = this.props;
    e && t.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: e } = this.props;
    this.setState({
      currentFormat: qg(e)
    });
  }
  handleClickOutside = (e) => {
    const { current: t } = this.domRef;
    t && e.target instanceof Element && e.target !== t && !t.contains(e.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (e) => {
    e.preventDefault();
    const { isOpen: t } = this.state;
    this.setState({
      isOpen: !t
    });
  };
  handleToolbarButtonClick(e) {
    return (t) => {
      const { editor: n } = this.props;
      t.preventDefault(), e && (qr.find(
        (r) => r.name === e
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(e) {
    const { editor: t } = this.props;
    if (e === "blockquote") {
      const n = t.window.getSelection();
      if (!n) return !1;
      const o = n.anchorNode;
      return !!(dt(o) ? o : o?.parentElement)?.closest("blockquote");
    }
    return t.command.active(e);
  }
  render() {
    const { className: e, isActive: t, editor: n, editorWindow: o, ...r } = this.props, { isOpen: i, currentFormat: l } = this.state, c = f(e);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      i && /* @__PURE__ */ s.jsxs("div", { className: zo.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Af,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: zo.buttonsContainer, children: Ur.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = eo(d.keybindings), g = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Re,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: g
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Re,
        {
          isActive: t,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Hf = "h-inputRichText-suggestions--suggestions__dropdown", Wf = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Mf = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", zf = "h-inputRichText-suggestions--suggestions__dropdownTabs", Vf = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Vt = {
  dropdown: Hf,
  dropdownWithTabs: Wf,
  dropdownWithoutTabs: Mf,
  dropdownTabs: zf,
  dropdownTabsContent: Vf
};
function Kf(a) {
  if (!a)
    return null;
  const { focusOffset: e, anchorOffset: t, anchorNode: n } = a;
  return e !== t || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, e);
}
class Uf extends k {
  dropdownRef;
  tabsRef;
  constructor(e) {
    super(e), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = O(), this.tabsRef = O(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: e } = this.props;
    e.selection.onUpdate(this.handleSelectionChange), e.events.onBlur(this.handleBlur), e.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (t, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(e, t) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== t.suggestionIndex && this.updateSuggestionScroll(), o !== t.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: e } = this.state;
    return e === "suggestion" && this.hasSuggestions() || e === "tab" && this.hasTabs();
  }
  handleArrowKey(e) {
    const { selectionMode: t } = this.state;
    t === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(e) : t === "tab" && this.hasTabs() && this.tabsNavigate(e);
  }
  handleEscapeKey(e) {
    const { selectionMode: t } = this.state;
    this.shouldRenderDropdown() && e.stopPropagation(), t === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: e, tabIndex: t, suggestionTrigger: n } = this.state;
    if (e === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (e === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[t];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(e) {
    const {
      nativeEvent: { relatedTarget: t }
    } = e;
    t === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: e } = this.state;
    return !!e?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: e, selectedTab: t } = this.state;
    return this.hasTabs() ? e?.getTabs?.().findIndex((n) => n.id === t) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(e) {
    this.setState(({ suggestionIndex: t, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return e < 0 ? o = t > 0 ? t - 1 : n.length - 1 : o = (t + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(e) {
    this.setState(({ tabIndex: t, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return e < 0 ? r = t > 0 ? t - 1 : o.length - 1 : r = (t + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(e, t) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, i = Kf(n.selection.recreate({ focus: !1 }));
    if (i) {
      const l = n.triggers.test(i);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (e ? p = {
            selectionMode: "suggestion",
            selectedTab: e,
            tabIndex: -1
          } : o ? e = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            e || this.lookForTriggers();
          }), !e)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], e, t)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(e, t) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: i, anchorNode: l } = r;
          if (l) {
            if (i - e >= 0)
              try {
                r.extend(l, i - e);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                t(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(e, t, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(e[0].length, (r) => {
      const i = o.selection.recreate();
      if (!i)
        return;
      const { focusOffset: l } = i, h = new RegExp(t.trigger).exec(e[0])?.[1]?.length ?? 0, u = e[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: t,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: e[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: e } = this.state, { current: t } = this.dropdownRef;
    if (t) {
      if (t.infiniteListRef.current)
        t.infiniteListRef.current.scrollToItem(e);
      else if (t.listRef.current) {
        const n = t.listRef.current, r = t.listRef.current.children[e].getBoundingClientRect(), i = n.getBoundingClientRect();
        i.bottom < r.bottom ? n.scrollTop += r.bottom - i.bottom : i.top > r.top && (n.scrollTop -= i.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: e } = this.state, { current: t } = this.tabsRef;
    if (!(e < 0 || !t) && t.containerRef.current) {
      const n = t.containerRef.current, r = t.containerRef.current.children[0].children[e].getBoundingClientRect(), i = n.getBoundingClientRect();
      i.bottom < r.bottom ? n.scrollTop += r.bottom - i.bottom : i.top > r.top && (n.scrollTop -= i.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: e,
      suggestionIndex: t,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!e || !e[t] || !o))
      return o.insertContent(
        e[t],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: e } = this.state;
    e && this.lookForTriggers();
  }
  handleSuggestionClick(e) {
    this.setState(
      (t) => ({
        suggestionIndex: t.suggestions ? t.suggestions.indexOf(e) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - e.bottom + e.height,
        left: e.x - n.x + e.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: e } = this.state, { editor: t } = this.props;
    if (t.ref.current && e) {
      const n = t.ref.current.getBoundingClientRect();
      return {
        left: `${e.x - n.x}px`,
        top: `${e.y - n.y + e.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: e.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: e } = this.state;
    if (!e || !e.getPagination)
      return !1;
    const t = e.getPagination();
    return !t || !t.onNext ? !1 : {
      ...t,
      onNext: () => t.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(e) {
    this.lookForTriggers(e, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(Zn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: e, suggestionTrigger: t, selectedTab: n, tabIndex: o } = this.state, r = t?.getTabs?.() ?? [], i = !!e?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        to,
        {
          ref: this.tabsRef,
          className: Vt.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Vt.dropdownTabsContent, children: i ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: e, suggestionIndex: t, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Gs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: e || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? e?.[t] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: e, selectedTab: t, suggestions: n } = this.state;
    return !(!e || !this.hasTabs() && !n?.length || this.hasTabs() && !t);
  }
  render() {
    const { editor: e, onError: t, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Vt.dropdown, {
      [Vt.dropdownWithTabs]: this.hasTabs(),
      [Vt.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(nt, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function qf({ children: a, className: e }) {
  const t = Q(null), [n, o] = V(0), r = () => t.current ? Array.from(
    t.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === t.current) : [];
  Z(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const i = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!t.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return Z(() => {
    const l = t.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, g = u.indexOf(p);
      g !== -1 && o(g);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      className: e,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: i,
      children: a
    }
  );
}
function Vo(a) {
  return a instanceof RegExp ? a.source : a;
}
function Gf(a) {
  return a.replace(/\(/g, "(?:");
}
class Gr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (e) => `(?!${Vo(e.trigger)})`
    ).join("");
  }
  add(e) {
    this.storedTriggers.push(e);
  }
  update(e) {
    const t = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === e.id
    );
    t !== -1 && (this.storedTriggers[t] = e);
  }
  test(e) {
    let t;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: i, minChars: l } = o, c = Gf(
        Vo(r)
      ), d = this.excludeTriggersRegex, h = i ? "." : "\\S";
      if (t = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(e), t && (!l || t[1].length >= l))
        return {
          match: t,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(e) {
    return "getSuggestions" in e;
  }
  isAddonTrigger(e) {
    return !this.isSuggestionTrigger(e);
  }
}
function Yr(a, e) {
  const t = a.getSelection();
  if (!t || t.rangeCount === 0) return !1;
  let n = t.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Yf(a, e) {
  e?.();
  const t = a.getSelection();
  if (!t || t.rangeCount === 0) return;
  const n = t.getRangeAt(0);
  if (Yr(a)) {
    Qf(a, "CODE");
    return;
  }
  const o = n.collapsed, r = a.document.createElement("code");
  if (o) {
    const i = a.document.createTextNode("​");
    r.appendChild(i), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const i = n.extractContents();
    r.appendChild(i), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  t.removeAllRanges(), t.addRange(n);
}
function Qf(a, e) {
  const t = a.getSelection();
  if (!t || t.rangeCount === 0) return;
  let n = t.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === e) {
        const r = o.parentNode;
        if (r) {
          const i = a.document.createDocumentFragment();
          for (; o.firstChild; )
            i.appendChild(o.firstChild);
          r.replaceChild(i, o);
          const l = a.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), t.removeAllRanges(), t.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const Dn = 25;
let we = null, ct = null;
function Xf(a, e) {
  const t = e.document.createElement("div");
  return t.className = `image-resize-handle image-resize-handle-${a}`, t.dataset.handle = a, t;
}
function Zf(a, e) {
  const t = e.document.createElement("div");
  return t.className = "image-resize-wrapper", t.contentEditable = "false", a.parentNode?.insertBefore(t, a), t.appendChild(a), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = Xf(o, e);
    t.appendChild(r);
  }), t;
}
function Qr(a) {
  const e = a.querySelector("img");
  e && a.parentNode && (a.parentNode.insertBefore(e, a), a.remove());
}
function Jf(a, e, t) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: i } = a, l = e - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / i;
  c < Dn && (c = Dn, d = Dn / i);
  const h = Dn / i;
  return d < h && (d = h, c = h * i), { width: c, height: d };
}
function no(a) {
  if (!we) return;
  a.preventDefault(), a.stopPropagation();
  const { width: e } = Jf(
    we,
    a.clientX,
    a.clientY
  );
  we.img.style.width = `${e}px`, we.img.style.height = "auto";
}
function so(a) {
  if (!we) return;
  a.preventDefault(), a.stopPropagation();
  const { img: e } = we, t = e.ownerDocument.defaultView;
  t.document.removeEventListener("mousemove", no), t.document.removeEventListener("mouseup", so), we = null;
  const n = new Event("input", { bubbles: !0 });
  e.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function eb(a, e, t) {
  a.preventDefault(), a.stopPropagation();
  const n = e.ownerDocument.defaultView, o = e.closest(".image-resize-wrapper");
  if (!o) return;
  const r = e.naturalWidth, i = e.naturalHeight, l = r / i, c = e.getBoundingClientRect(), d = c.width, h = c.height;
  we = {
    img: e,
    originalWidth: r,
    originalHeight: i,
    aspectRatio: l,
    startX: a.clientX,
    startY: a.clientY,
    startWidth: d,
    startHeight: h,
    handle: t,
    wrapper: o
  }, n.document.addEventListener("mousemove", no), n.document.addEventListener("mouseup", so);
}
function tb(a, e) {
  ct && (Qr(ct), ct = null);
  const t = Zf(a, e);
  ct = t, t.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (i) => eb(i, a, r)
    );
  });
}
function Cs() {
  if (ct && (Qr(ct), ct = null), we) {
    const a = we.img.ownerDocument.defaultView;
    a.document.removeEventListener("mousemove", no), a.document.removeEventListener("mouseup", so), we = null;
  }
}
function nb(a) {
  return a ? a.classList.contains("image-resize-wrapper") || a.classList.contains("image-resize-handle") || a.closest(".image-resize-wrapper") !== null : !1;
}
function Ko(a) {
  if (!a) return a;
  const n = new DOMParser().parseFromString(`<div>${a}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const i = r.querySelector("img");
    i && r.parentNode && (r.parentNode.insertBefore(i, r), r.remove());
  }), n.innerHTML) : a;
}
const Xr = "input-rich-text-editor", Zr = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], Uo = [
  ...Zr,
  ...qr,
  ...Kr,
  ...bm
], sb = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, ob = Ie({
  command: {
    run: L,
    active: () => !1
  },
  content: {
    insert: L,
    setUiBlocker: L
  },
  hotkeys: {
    add: L,
    updateKeybindings: L
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: L
  },
  events: {
    subscribe: () => L,
    publish: L,
    onMouseOver: L,
    onBlur: L
  },
  allowFormatting: [],
  triggers: new Gr(),
  ref: O(),
  window,
  history: {
    canUndo: () => !1,
    undo: L,
    takeSnapshot: L,
    reset: L
  }
});
class oo extends k {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Re;
  /** Context containing props and methods to interact with the editor. */
  static Context = ob;
  static contextType = Un;
  get effectiveWindow() {
    return this.context ?? window;
  }
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: L,
    sendOnEnter: !1,
    onMount: L,
    onUnmount: L,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(e) {
    super(e), this.editorRef = O(), this.currentSuggestionRef = O(), this.fileInputRef = O(), this.attachmentDropdownButtonRef = O(), this.unsubscribeInlineAttachment = L, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Uo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: e.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Gr(),
      ref: this.editorRef,
      window: this.effectiveWindow,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const e = this.effectiveWindow, { onMount: t } = this.props;
    e.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), t(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(e) {
    this.editor.window !== this.effectiveWindow && (this.editor.window = this.effectiveWindow);
    const { fileUploadStatuses: t, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: i } = this.editorRef;
    t && t !== e.fileUploadStatuses && i && (Object.keys(t).forEach((l) => {
      this.updateFileLoader(l, t[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== e.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), br(e.keybindings, o) || this.updateKeyCommandsKeybindings(o), e.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: e } = this.props;
    this.unsubscribeInlineAttachment?.(), Cs(), e(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: e } = this.props;
    return Uo.map((t) => ({
      ...t,
      keybindings: e && t.name ? e[t.name] ?? [] : t.keybindings
    }));
  }
  subscribe(e, t) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [e]: [...n.pubsub[e] ?? [], t]
      }
    })), () => {
      this.setState((n) => xr(n, e));
    };
  }
  publish(e) {
    this.state.pubsub[e]?.forEach((t) => t(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: e, onSelectionChange: t } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const i = this.extractEditorContent();
      i !== n && (this.setState({
        htmlOld: i
      }), e(i));
    }
    o.forEach((i) => {
      i();
    }), t && t();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (e) => {
    const { mouseOverListeners: t } = this.state;
    t.forEach((n) => {
      n(e);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (e) => {
    const t = e.target, n = this.effectiveWindow;
    if (dt(t) && t.tagName === "IMG") {
      e.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(t), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      tb(t, n);
    } else nb(t) || Cs();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (e) => {
    const { blurListeners: t } = this.state;
    t.forEach(
      (n) => {
        n(e);
      }
    );
  };
  handleKeyDown = (e) => {
    if (e.getModifierState(e.key))
      return;
    const { keyCommands: t } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(e), t.some(
      ({ preventDefaultKeybinding: i }) => i && ms(i, e)
    ) && e.preventDefault(), t.some(
      ({ name: i, keybindings: l, condition: c, callback: d }) => {
        if (ms(l, e) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, e), i && this.editor.events.publish(i), !0;
      }
    )) {
      this.setKeyDownHandled(e), e.stopPropagation();
      return;
    }
    if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && this.editor.allowFormatting.includes("blockquote")) {
      const i = this.effectiveWindow, l = i.getSelection();
      if (!l) return;
      const c = l.anchorNode, h = (dt(c) ? c : c?.parentElement)?.closest("blockquote");
      if (h && this.editorRef.current?.contains(h)) {
        const u = i.document, p = u.createElement("div");
        p.appendChild(u.createElement("br")), h.after(p);
        const g = u.createRange();
        g.setStart(p, 0), g.collapse(!0), l.removeAllRanges(), l.addRange(g), this.setKeyDownHandled(e), this.handleSelectionChange();
        return;
      }
    }
    if (ms([[["$metaOrCtrl"], "Enter"]], e)) {
      const { onTriggerSend: i } = this.props;
      this.setKeyDownHandled(e), i();
    } else if (e.key === "Enter" && n && !e.shiftKey) {
      const { onTriggerSend: i } = this.props;
      this.setKeyDownHandled(e), i();
    }
    return null;
  };
  getBlockLevelParent = (e) => {
    const t = this.effectiveWindow;
    let n = dt(e) ? e : e.parentElement;
    for (; !Zs(n, t); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (e) => {
    const { current: t } = this.editorRef, n = e?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      $o(t), Yg(t);
      return;
    }
    const i = document.getSelection()?.anchorNode;
    if (o === "insertText" && i && i.textContent?.length === 1) {
      const l = this.getBlockLevelParent(i);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: e } = this.state;
    e || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (e) => {
    e.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (e) => {
    this.setState(({ keyCommands: t }) => ({
      keyCommands: [...t, ...e]
    }));
  };
  updateKeyCommandsKeybindings = (e) => {
    if (!e)
      return;
    const { keyCommands: t } = this.state;
    Object.entries(e).forEach(([n, o]) => {
      const r = t.findIndex(
        ({ name: i }) => i === n
      );
      r > -1 && o && (t[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(e) {
    this.setState(({ selectionUpdateListeners: t }) => ({
      selectionUpdateListeners: [...t, e]
    }));
  }
  addMouseOverListener(e) {
    this.setState(({ mouseOverListeners: t }) => ({
      mouseOverListeners: [...t, e]
    }));
  }
  addBlurListener(e) {
    this.setState(({ blurListeners: t }) => ({
      blurListeners: [...t, e]
    }));
  }
  handlePaste = (e) => {
    const { onFileDropped: t, allowInlineAttachments: n, sanitize: o } = this.props, r = this.effectiveWindow, { clipboardData: i } = e;
    if (!i)
      return;
    let l = i.getData("text/html");
    const c = i.getData("text/plain"), d = i.files.item(0);
    if (l) {
      e.preventDefault(), this.commandRun("insertHTML", o?.(l));
      return;
    }
    if (c && sb.test(c)) {
      e.preventDefault();
      const h = r.getSelection(), u = h && !h.isCollapsed ? h.toString() : "", p = u && this.editor.allowFormatting.includes("link") ? u : c;
      l = Vr(c, p), this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && t) {
        const { src: h, uid: u } = Ao(r, d);
        this.insertImageLoader(h, u), t(d, u);
      }
      e.preventDefault();
    }
  };
  commandRun(e, t = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, r = this.effectiveWindow;
      if (o) {
        if (n || this.recreateSelection(), e === "inlineCode") {
          Yf(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          e,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          t
        );
      }
    });
  }
  commandActive(e) {
    const { hasFocus: t } = this.state, n = this.effectiveWindow;
    return e === "inlineCode" ? !!(t && Yr(n)) : !!(t && Ug(n, e));
  }
  getText = () => {
    const { current: e } = this.editorRef;
    return e && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: e } = this.editorRef, t = (
      // innerHTML of <div></div> should count as empty
      e && this.hasContent(this.extractEditorContent()) ? e.innerText : ""
    );
    return t ? t.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(e) {
    const { current: t } = this.editorRef, n = this.props.sanitize?.(e);
    t && (t.innerHTML = n || "", $o(t)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (e) => {
    if (e === null) return;
    const { onFileDropped: t } = this.props, n = this.effectiveWindow;
    e && t && Array.from(e).forEach((r) => {
      if (Gg(r)) {
        const { src: i, uid: l } = Ao(n, r);
        this.insertImageLoader(i, l), t(r, l);
      } else {
        const i = tn();
        this.insertFileLoader(r.name, i), t(r, i);
      }
    });
  };
  handleAttachmentUpload = (e) => {
    const { onAttachmentsFile: t } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), e && typeof t == "function" && Array.from(e).forEach((r) => {
      const i = tn();
      t(r, i);
    });
  };
  handleDetachAttachmentFile = (e) => {
    const { onDetachAttacmentFile: t } = this.props;
    typeof t == "function" && t(e);
  };
  handleFileSelect = (e) => {
    const t = e.target;
    t?.ownerDocument?.defaultView && t instanceof t.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(t.files), t.value = "");
  };
  openFileBrowser = (e) => {
    e?.preventDefault();
    const { current: t } = this.fileInputRef;
    t && t.click();
  };
  insertImageLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("src", e), this.insertContent(o);
  }
  insertFileLoader(e, t) {
    const o = this.effectiveWindow.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", t), o.setAttribute("href", "#"), o.innerText = e, this.insertContent(o);
  }
  updateFileLoader(e, { link: t, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const i = r.querySelector(`[data-uid="${e}"]`);
      i && (n === "failed" && i.parentElement ? i.parentElement.removeChild(i) : (i.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), i.classList.add(`async-${n}`), t && i.tagName === "IMG" && (i.src = t, o && (i.title = o)), t && i.tagName === "A" && (i.href = t)));
    }
  }
  handleToggleSendOnEnter = (e) => {
    e.preventDefault();
    const { onToggleSendOnEnter: t } = this.props;
    t();
  };
  handleToggleAutocompleteSuggestions = (e) => {
    e.preventDefault();
    const { autocomplete: t } = this.props;
    t && t.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(e) {
    const { anchorNode: t } = e;
    let { parentElement: n = null } = t || {};
    const o = `.${ue.editor}`;
    let r = t !== null && t.nodeType === Node.ELEMENT_NODE ? t.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (e, t) => {
    this.contentInsertionQueue.push(e), t?.getSelection ? this.processContentInsertionQueue(t.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (e) => {
    if (!e || !this.isSelectionWithinEditor(e)) {
      this.contentInsertionQueue = [];
      return;
    }
    if (Qg(e), e?.rangeCount && e?.rangeCount > 0) {
      const t = e.getRangeAt(0);
      if (e.isCollapsed || t.deleteContents(), this.contentInsertionQueue.length === 1)
        t.insertNode(this.contentInsertionQueue[0]);
      else if (this.contentInsertionQueue.length > 1) {
        const n = document.createElement("span");
        this.contentInsertionQueue.forEach((o) => {
          n.appendChild(o);
        }), t.insertNode(n);
      }
    }
    this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
      e.collapseToEnd();
    }), this.handleSelectionChange();
  };
  setUiBlocker(e) {
    this.setState({ uiBlocker: e });
  }
  getSelectionRange() {
    const e = this.effectiveWindow;
    if (e.document.activeElement === this.editorRef.current) {
      const t = e.document.getSelection();
      return t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection(e) {
    const { current: t } = this.editorRef, { lastSelection: n } = this.state, r = this.effectiveWindow.getSelection();
    return t && (!r || !this.isSelectionWithinEditor(r)) && e?.focus !== !1 && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const e = this.effectiveWindow;
    this.setState({
      hasFocus: !0
    }), e.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (e) => {
    const t = this.effectiveWindow, n = t.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    Cs(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), t.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(e);
  };
  focus = () => {
    const { current: e } = this.editorRef, { hasFocus: t } = this.state;
    e && (t || e.focus());
  };
  moveCursorToEnd = () => {
    const { current: e } = this.editorRef, t = this.effectiveWindow;
    if (!e) return;
    const n = t.getSelection();
    if (n) {
      const o = t.document.createRange();
      o.selectNodeContents(e), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(e) {
    return e?.length ? !e.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: e } = this.props;
    return Array.isArray(e) ? e : e ? Vg : [];
  }
  lastExtractedContent = O();
  extractEditorContent() {
    const { editorContentExtractor: e, sanitize: t } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!e)
      return Ko(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = e(n);
    return this.lastExtractedContent.current = Ko(
      t?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: e } = this.state;
    if (e.length > 0) {
      const t = e[e.length - 1];
      this.setHtml(t), this.setState({
        undoStack: e.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: e,
      wrapperClassName: t,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: i,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: g,
      attachments: m,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: y,
      languages: v,
      disabled: w,
      status: S,
      onError: C,
      icon: x,
      prefix: _,
      suffix: I,
      id: T,
      autocomplete: P,
      toolbarAddons: M,
      toolbarEnd: D
    } = this.props, { htmlOld: E, uiBlocker: A } = this.state, K = this.effectiveWindow, se = f(ue.root, e);
    return /* @__PURE__ */ s.jsx(oo.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Me,
      {
        status: S,
        icon: x,
        prefix: _,
        suffix: I,
        disabled: w,
        className: f(ue.inputWrapper, t),
        children: /* @__PURE__ */ s.jsxs("div", { className: se, children: [
          /* @__PURE__ */ s.jsxs(
            Sm,
            {
              className: ue.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(m) ? m : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: T,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(ue.editor, {
                      [ue.editorDisabled]: u
                    }),
                    "data-testid": Xr,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(E) && !!i && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: ue.placeholder, children: i })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(qf, { className: ue.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Bf,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: K
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(Jm, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Re,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${eo(Zr[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              ym,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(m) ? m : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: K,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                fixed: !0,
                children: g
              }
            ),
            p && /* @__PURE__ */ s.jsx(Pm, { "data-tip": "Emojis", editor: this.editor, fixed: !0 }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              jf,
              {
                languages: v,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            P && P.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Re,
              {
                isActive: P.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            M,
            !y && /* @__PURE__ */ s.jsx(
              Re,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            P ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(ue.toolbarHint, {
                  [ue.toolbarHintVisible]: this.state.showHint,
                  [ue.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  P.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null,
            D && /* @__PURE__ */ s.jsx("div", { className: ue.toolbarEnd, children: D })
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: ue.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Uf, { editor: this.editor, onError: C }),
          /* @__PURE__ */ s.jsx(im, { editor: this.editor }),
          A && /* @__PURE__ */ s.jsx("div", { className: ue.uiBlocker, children: A })
        ] })
      }
    ) });
  }
}
const rb = "h-textarea--textarea__inputWrapper", ab = "h-textarea--textarea__input", qo = {
  inputWrapper: rb,
  input: ab
}, ib = "textarea", Jr = W(function(e, t) {
  const n = Q(null), {
    className: o,
    disabled: r,
    readOnly: i,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: g,
    autoGrow: m,
    ...b
  } = e, [y, v] = V(p), w = {
    ...g,
    height: y ? `${y}px` : void 0
  }, S = F(() => {
    if (!n.current)
      return;
    const C = n.current.clientHeight, x = window.getComputedStyle(n.current), _ = parseInt(x.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + _, T = Math.max(
      p,
      Math.min(C, I)
    ), P = I > T ? I : T;
    n.current.style.height = `${P}px`, v(P);
  }, [p]);
  return Z(() => {
    if (m)
      return S(), window.addEventListener("resize", S), () => {
        window.removeEventListener("resize", S);
      };
  }, [m, S]), /* @__PURE__ */ s.jsx(
    Me,
    {
      className: qo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": ib,
          className: qo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (C) => {
            b?.onChange?.(C), m && S();
          },
          ref: n,
          style: w,
          name: l,
          disabled: r,
          readOnly: i
        }
      )
    }
  );
}), lb = "h-fieldRichText--fieldRichText__editorContainer", cb = "h-fieldRichText--fieldRichText__fallbackTextArea", Go = {
  editorContainer: lb,
  fallbackTextArea: cb
};
class tD extends k {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: i,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          jt,
          {
            fallback: /* @__PURE__ */ s.jsx(
              Jr,
              {
                ...t,
                className: Go.fallbackTextArea,
                disabled: i,
                value: t.value,
                onChange: (p) => t.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Go.editorContainer, children: /* @__PURE__ */ s.jsx(
              oo,
              {
                disabled: i,
                status: z.getStatus(o),
                ...t,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: L
              }
            ) })
          }
        )
      }
    );
  }
}
class nD extends k {
  constructor(e) {
    super(e), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: e },
      items: t
    } = this.props;
    return typeof e == "string" && t?.some((n) => n.id === e) ? [e] : Array.isArray(e) && e.length && t?.some((n) => e.some((o) => o === n.id)) ? e : [];
  }
  handleSelect(e) {
    const {
      input: { onChange: t }
    } = this.props;
    typeof t == "function" && t(e === null ? "" : e.id.toString());
  }
  handleClear() {
    const {
      input: { value: e },
      onClear: t
    } = this.props;
    typeof e == "string" && this.handleSelect(null), typeof t == "function" && t();
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: i,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: o,
        labelFor: t.name,
        meta: n,
        required: r,
        disabled: i,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Tt,
          {
            ...u,
            id: t.name,
            disabled: i,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function hn(a, e) {
  const t = Ms(), n = Q(e);
  n.current = e, Z(() => {
    function o(r) {
      n.current?.(r);
    }
    return t.addEventListener(a, o), () => t.removeEventListener(a, o);
  }, [t, a]);
}
function ea(a, e = "") {
  return Ee.toArray(a).reduce((t, n) => Se(n) ? n.type === et ? [
    ...t,
    ...ea(n.props.children, n.key)
  ] : [...t, { ...n, key: `${e}${n.key}` }] : t, []);
}
const es = (a) => G(() => ea(a), [a]), db = "h-selectionList--selectionList__root", hb = "h-selectionList--selectionList__disabled", Yo = {
  root: db,
  disabled: hb
}, Rt = Ba(
  () => Ie({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: L,
      register: L,
      isSelected: () => !1,
      onSelect: L,
      isOnlyVisibleItem: !1
    }
  })
), ro = ({ defaultActiveItemIndex: a = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [e, t] = V(!1), [n, o] = V(-1), [r, i] = V([]), [l, c] = V({}), d = F(
    ({
      isActivatable: m,
      isLastChild: b,
      isOnlyVisibleItem: y,
      keysTakenOverHandlingFromParent: v
    }, w) => {
      m !== void 0 && i((S) => {
        const C = m ? [...S, w].sort((x, _) => x - _) : S.filter((x) => x !== w);
        return m && b && o((x) => (C.includes(w) && !S.includes(w) || w !== x) && C.includes(x) && w !== C[a] ? x : C[a] ?? C[0] ?? x), C;
      }), y !== void 0 && t(y), v !== void 0 && c((S) => ({
        ...S,
        [w]: v
      }));
    },
    [a]
  ), h = F(
    (m) => "index" in m ? m.index : m.step === "first" ? r[0] : m.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + m.step + r.length) % r.length],
    [r, n]
  ), u = F(
    (m) => {
      o(h(m));
    },
    [h]
  );
  Z(() => {
    if (n < 0 || n === void 0) {
      o(r[a]);
      return;
    }
    r.length && !r.includes(n) && o(
      r[a] ?? r[0]
    );
  }, [n, r, a]);
  const p = G(
    () => l[n] ?? [],
    [n, l]
  );
  return G(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: e,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      e,
      p,
      u
    ]
  );
}, Qo = ({
  className: a,
  selectedValues: e = [],
  isActive: t,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = L,
  equalityFn: i = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, g] = V(!1), [m, b] = V({ isActive: !!t, source: "parent" }), y = Rt(), {
    activeItemIndex: v,
    setActiveItem: w,
    handleItemRegister: S,
    isOnlyActiveItemVisible: C,
    keysDelegatedHandlingToItem: x
  } = ro({ defaultActiveItemIndex: c }), _ = es(d), I = F(
    (D) => D !== void 0 && (e || []).some(
      (E) => i(E, D)
    ),
    [i, e]
  ), T = F(
    ({ value: D, meta: E }, A) => {
      w({ index: A }), D !== void 0 && r(o ? {
        selectedValues: I(D) ? e.filter(
          (K) => !i(K, D)
        ) : [...e, D],
        selectedItem: {
          isNode: E?.isNode,
          isSelected: !I(D),
          value: D
        },
        event: E?.event
      } : {
        selectedValues: [D],
        selectedItem: {
          isNode: E?.isNode,
          isSelected: !0,
          value: D
        },
        event: E?.event
      });
    },
    [
      i,
      I,
      o,
      r,
      e,
      w
    ]
  ), P = G(
    () => !n && (m.isActive || p),
    [n, m.isActive, p]
  ), M = (D) => {
    !P || x.includes(D.key) || (D.key === "Enter" ? D.preventDefault() : D.key === "Home" ? (w({ step: "first" }), D.preventDefault()) : D.key === "End" ? (w({ step: "last" }), D.preventDefault()) : D.key === "ArrowDown" ? (w({ step: 1 }), D.preventDefault()) : D.key === "ArrowUp" && (w({ step: -1 }), D.preventDefault()));
  };
  return Z(() => {
    b({ isActive: !!t, source: "parent" });
  }, [t]), hn("keydown", M), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || t ? -1 : l,
      ...h,
      className: f(a, Yo.root, {
        [Yo.disabled]: n
      }),
      onFocus: () => g(!0),
      onBlur: () => g(!1),
      onMouseLeave: () => {
        m.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: _.map(
        (D, E) => Se(D) && (!C || E === v) && /* @__PURE__ */ s.jsx(
          y.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: m.isActive,
                isDisabled: n
              },
              item: {
                isActive: P && E === v,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), w({ index: E });
                },
                register: (A) => S(A, E),
                isSelected: I,
                onSelect: (A) => T(A, E),
                isOnlyVisibleItem: C,
                isLastChild: E === _.length - 1
              }
            },
            children: D
          },
          E
        )
      )
    }
  );
}, Xo = ({ className: a, label: e, ...t }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = We(Rt());
  return ht(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), tt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    qn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...t,
      children: /* @__PURE__ */ s.jsx(H.Paragraph, { as: "span", variant: "4", color: "secondary", children: e })
    }
  );
}, ta = Object.assign(W(Xo), {
  name: Xo.name
}), ub = "h-selectionList-subComponents-item--selectionListItem__root", pb = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", gb = "h-selectionList-subComponents-item--selectionListItem__rootActive", mb = "h-selectionList-subComponents-item--selectionListItem__selectionState", fb = "h-selectionList-subComponents-item--selectionListItem__fixedSize", bb = "h-selectionList-subComponents-item--selectionListItem__content", yb = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", it = {
  root: ub,
  rootDisabled: pb,
  rootActive: gb,
  selectionState: mb,
  fixedSize: fb,
  content: bb,
  contentDisabled: yb
}, Zo = ({
  value: a,
  isDisabled: e = !1,
  isIndeterminate: t = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: i,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: g,
      isActive: m,
      isFocused: b
    },
    item: {
      register: y,
      isSelected: v,
      onSelect: w,
      isActive: S,
      isNode: C = !1,
      isLastChild: x = !1,
      setActive: _
    }
  } = We(Rt()), I = v(a), T = G(
    () => !g && (m || b),
    [m, g, b]
  ), P = G(
    () => !e && S && T,
    [S, e, T]
  ), M = Q(null);
  an(
    u,
    () => M.current
  );
  const D = F(
    ($) => {
      !e && !g && (c?.({ value: a, meta: { target: $?.target } }), w({
        value: a,
        meta: {
          target: $?.target,
          event: $ || void 0
        }
      }));
    },
    [e, g, c, w, a]
  ), E = F(
    ($) => {
      P && $.key === "Enter" && !e && !g && (c?.({
        value: a,
        meta: { target: $.target ?? void 0 }
      }), w({
        value: a,
        meta: { target: $.target ?? void 0, event: $ }
      }));
    },
    [P, e, g, c, w, a]
  );
  Z(() => {
    S && T && M.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [S]);
  const A = F(
    () => ({
      isActive: S,
      isSelected: I,
      isLastChild: x,
      isNode: C,
      value: a
    }),
    [S, x, C, I, a]
  ), K = en(S), se = en(I);
  Je(() => {
    S !== K && i?.(A()), I !== se && l?.(A());
  }, [
    A,
    S,
    I,
    i,
    l,
    K,
    se
  ]), hn("keydown", E), Z(() => (y({ isActivatable: !e, isLastChild: x }), () => y({ isActivatable: !1, isLastChild: x })), [e]);
  const ne = !p && I || p && a !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: M,
      role: "option",
      "aria-selected": I,
      "aria-disabled": e,
      onClick: D,
      onMouseMove: _,
      className: f(it.root, n, {
        [it.rootActive]: P,
        [it.rootDisabled]: e
      }),
      ...h,
      children: [
        ne && /* @__PURE__ */ s.jsxs(
          B,
          {
            className: f(it.selectionState, {
              [it.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && a !== void 0 && /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: I,
                  indeterminate: !I && t,
                  disabled: e,
                  onChange: L,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          ie,
          {
            className: f(it.content, o, {
              [it.contentDisabled]: e
            }),
            children: d
          }
        ),
        C && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, xb = Object.assign(W(Zo), {
  name: Zo.name
}), _b = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", Cb = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", Jo = {
  root: _b,
  rootActive: Cb
}, er = ({
  className: a,
  content: e,
  onActiveStateChange: t,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: i,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = We(Rt()), g = G(
    () => !i && (l || c),
    [l, i, c]
  ), m = G(
    () => h && g,
    [h, g]
  ), b = Q(null);
  an(
    r,
    () => b.current
  );
  const y = F(() => {
    u({}), n?.();
  }, [u, n]), v = F(
    (S) => {
      !m || i || S.key === "Enter" && y();
    },
    [y, m, i]
  );
  Z(() => {
    h && g && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [h]);
  const w = en(h);
  return Je(() => {
    h !== w && t?.({ isActive: h });
  }, [h, t, w]), hn("keydown", v), ht(() => {
    d({ isActivatable: !0 });
  }), tt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(Jo.root, a, {
        [Jo.rootActive]: m
      }),
      onClick: y,
      onMouseMove: p,
      ...o,
      children: e || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, na = Object.assign(
  W(er),
  {
    name: er.name
  }
), vb = "h-selectionList-subComponents-list--selectionListList__list", wb = {
  list: vb
}, tr = ({
  parentItem: a,
  children: e,
  backItemProps: t = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...i
}, l) => {
  const c = Rt(), d = We(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: g,
      onSelect: m,
      isOnlyVisibleItem: b,
      register: y,
      setActive: v,
      isLastChild: w = !1
    }
  } = d, S = G(
    () => !p && (u || h),
    [u, p, h]
  ), C = es(e), {
    activeItemIndex: x,
    setActiveItem: _,
    handleItemRegister: I,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: P
  } = ro({ defaultActiveItemIndex: 1 }), M = F(
    ($, oe) => {
      _({ index: oe }), m($);
    },
    [m, _]
  ), D = ($) => {
    !S || !b || P.includes($.key) || ($.key === "Home" ? (_({ step: "first" }), $.preventDefault()) : $.key === "End" ? (_({ step: "last" }), $.preventDefault()) : $.key === "ArrowDown" ? (_({ step: 1 }), $.preventDefault()) : $.key === "ArrowUp" && (_({ step: -1 }), $.preventDefault()));
  }, E = en(
    b
  );
  Je(() => {
    b !== E && r?.({
      isActive: b,
      isLastChild: w
    });
  }, [
    b,
    r,
    E
  ]), Z(() => {
    y(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), hn("keydown", D);
  const A = F(
    ({ value: $, meta: oe }) => {
      oe?.target instanceof HTMLInputElement && oe.target.type === "checkbox" ? m({ value: $, meta: { isNode: !0 } }) : y({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m]
  ), K = F(() => {
    y({ isOnlyVisibleItem: !1 });
  }, []);
  Z(() => {
    b || _({ index: -1 });
  }, [b, _]);
  const se = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: A,
        isNode: !0
      }
    }),
    [A, d]
  ), ne = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: K,
        isActive: x === 0,
        setActive: () => {
          v(), _({ index: 0 });
        },
        register: ($) => I($, 0)
      }
    }),
    [
      x,
      K,
      I,
      d,
      v,
      _
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: ne, children: /* @__PURE__ */ s.jsx(na, { ...t }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...i, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(wb.list, n),
        ...o,
        children: C.map(($, oe) => {
          const ke = oe + 1;
          return Se($) && (!T || ke === x) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: g && ke === x,
                  setActive: () => {
                    v(), _({ index: ke });
                  },
                  register: (De) => I(De, ke),
                  onSelect: (De) => M(De, ke),
                  isOnlyVisibleItem: T,
                  isLastChild: oe === C.length - 1
                }
              },
              children: $
            },
            oe
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: se, children: a });
}, Sb = Object.assign(W(tr), {
  name: tr.name
}), Ib = "h-selectionList-subComponents-section--selectionListSection__section", kb = {
  section: Ib
}, nr = ({
  title: a,
  children: e,
  listProps: { className: t, ...n } = {},
  onActiveStateChange: o,
  ...r
}, i) => {
  const l = Rt(), c = We(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: g,
      onSelect: m,
      register: b,
      isLastChild: y = !1
    }
  } = c, v = G(
    () => !u && (h || d),
    [h, u, d]
  ), w = es(e), {
    activatableItemIndices: S,
    activeItemIndex: C,
    setActiveItem: x,
    handleItemRegister: _,
    keysDelegatedHandlingToItem: I
  } = ro(), T = F(
    (D, E) => {
      x({ index: E }), m(D);
    },
    [m, x]
  ), P = (D) => {
    !v || I.includes(D.key) || (D.key === "Home" ? x({ step: "first" }) : D.key === "End" && x({ step: "last" }), p ? D.key === "ArrowDown" && C !== S[S.length - 1] ? (x({ step: 1 }), D.preventDefault()) : D.key === "ArrowUp" && C !== S[0] && (x({ step: -1 }), D.preventDefault()) : D.key === "ArrowDown" ? x({ step: "first" }) : D.key === "ArrowUp" && x({ step: "last" }));
  }, M = en(p);
  return Je(() => {
    p !== M && o?.({
      isActive: p,
      isLastChild: y
    });
  }, [p, o, M]), Z(() => {
    const D = [];
    p && (C !== S[S.length - 1] && D.push("ArrowDown"), C !== S[0] && D.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: D });
  }, [S, C, p]), ht(() => b({ isActivatable: !0 })), tt(() => b({ isActivatable: !1 })), hn("keydown", P), /* @__PURE__ */ s.jsx("li", { ref: i, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(kb.section, t),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(ta, { label: a }),
        w.map(
          (D, E) => Se(D) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && E === C,
                  setActive: () => {
                    g(), x({ index: E });
                  },
                  register: (A) => _(A, E),
                  onSelect: (A) => T(A, E),
                  isLastChild: y && E === w.length - 1
                }
              },
              children: D
            },
            E
          )
        )
      ]
    }
  ) });
}, Db = Object.assign(W(nr), {
  name: nr.name
}), Tb = Object.assign(W(Qo), {
  name: Qo.name,
  Item: xb,
  BackItem: na,
  Divider: ta,
  Section: Db,
  List: Sb
}), jb = "h-inputSelectionList-chip--inputSelectionListChip__root", Fb = "h-inputSelectionList-chip--inputSelectionListChip__name", sr = {
  root: jb,
  name: Fb
}, vs = ({
  onDelete: a,
  className: e,
  disabled: t,
  readOnly: n,
  ...o
}) => {
  const r = G(() => {
    if (!(!a || t || n))
      return (i) => {
        i.stopPropagation(), a();
      };
  }, [t, a, n]);
  return /* @__PURE__ */ s.jsx(
    nn,
    {
      ...o,
      onDelete: r,
      className: f(sr.root, e),
      tagNameClassName: sr.name
    }
  );
}, Nb = "h-inputSelectionList--inputSelectionList__root", Pb = "h-inputSelectionList--inputSelectionList__inputWrapper", Rb = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Eb = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", Lb = "h-inputSelectionList--inputSelectionList__rootReadOnly", Ab = "h-inputSelectionList--inputSelectionList__titleContainer", $b = "h-inputSelectionList--inputSelectionList__filterInput", Ob = "h-inputSelectionList--inputSelectionList__placeholder", Bb = "h-inputSelectionList--inputSelectionList__titleBox", Hb = "h-inputSelectionList--inputSelectionList__iconContainer", Wb = "h-inputSelectionList--inputSelectionList__iconButton", Mb = "h-inputSelectionList--inputSelectionList__dropdown", zb = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", Vb = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", ce = {
  root: Nb,
  inputWrapper: Pb,
  inputWrapperChild: Rb,
  rootHasWrapperIcon: Eb,
  rootReadOnly: Lb,
  titleContainer: Ab,
  filterInput: $b,
  placeholder: Ob,
  titleBox: Bb,
  iconContainer: Hb,
  iconButton: Wb,
  dropdown: Mb,
  hiddenItemsTooltip: zb,
  hiddenItemsChip: Vb
}, Kb = "inputSelectionListTestId", or = ({
  className: a,
  name: e,
  value: t,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: i,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: g,
  getItemTitleByValue: m,
  tabIndex: b,
  keepOpen: y,
  onToggleDropdown: v,
  autoFocus: w,
  onClick: S,
  onBlur: C,
  onKeyDown: x,
  limit: _ = Number.POSITIVE_INFINITY,
  clearable: I = !1,
  equalityFn: T = Object.is,
  defaultActiveItemIndex: P,
  valueArrayToStringFn: M = JSON.stringify,
  rootClassName: D,
  dropdownProps: E,
  selectionListProps: A,
  slotBeforeList: K,
  slotAfterList: se,
  ...ne
}, $) => {
  const oe = Ms(), ke = Q(null), De = Q(null), un = Q(null), ao = Q(null), [U, oa] = V(!1), [ns] = V(() => !!w);
  an(
    $,
    () => De.current
  );
  const pn = G(
    () => p?.value !== void 0 && p.onChange !== void 0,
    [p]
  ), ut = G(() => pn ? U ? !0 : ns && (!!g || !t?.length) : !1, [pn, ns, U, g, t?.length]), ss = G(() => !ut || !U && t?.length ? !0 : g && !!t?.length, [U, g, ut, t?.length]), ra = G(() => {
    if (!t?.length)
      return c;
    if (ss)
      return "";
    if (!g) {
      const R = m(t[0]);
      return typeof R == "object" ? "" : R?.toString();
    }
    return "";
  }, [g, c, m, ss, t]), os = F(
    (R) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: R
        },
        selectedValues: t?.filter((Ae) => !T(Ae, R)) ?? []
      });
    },
    [d, T, n, h, t]
  ), aa = G(() => {
    if (!t?.length)
      return /* @__PURE__ */ s.jsx(B, { alignItems: "center", className: ce.placeholder, children: c });
    if (g) {
      const R = _ < t.length ? t.slice(0, _) : t, Ae = _ < t.length ? t.slice(_) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        R?.map((At, rs) => /* @__PURE__ */ s.jsx(
          vs,
          {
            onDelete: () => {
              os(At);
            },
            disabled: d,
            readOnly: h,
            children: m(At)
          },
          rs
        )),
        !!Ae.length && /* @__PURE__ */ s.jsx(
          le,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              B,
              {
                className: ce.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Ae?.map((At, rs) => /* @__PURE__ */ s.jsx(
                  vs,
                  {
                    onDelete: () => {
                      os(At);
                    },
                    disabled: d,
                    readOnly: h,
                    children: m(At)
                  },
                  rs
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              vs,
              {
                className: ce.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Ae.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(ie, { className: ce.titleBox, children: m(t[0]) });
  }, [
    t,
    g,
    m,
    c,
    _,
    d,
    h,
    os
  ]), re = F(
    (R) => {
      (h || d) && R || (R !== U && v?.(R), oa(R));
    },
    [d, U, v, h]
  ), Le = F(() => {
    (ut ? un.current : De.current)?.focus();
  }, [ut]), gn = F(
    (R) => {
      if (!pn || !R)
        return !1;
      const Ae = `${p?.value ?? ""}${R}`;
      return p?.onChange?.({
        target: { value: Ae, name: p?.name },
        currentTarget: { value: Ae, name: p?.name }
      }), re(!0), !0;
    },
    [p, pn, re]
  ), ia = F(
    (R) => {
      U || re(!0), p?.onChange?.(R);
    },
    [p, U, re]
  ), Et = F(
    ({ target: R }) => {
      ao.current?.contains(R) || (ke.current?.contains(R) && Le(), re(!1));
    },
    [Le, re]
  ), Lt = F(
    (R) => {
      Ft(R.key) && U && (re(!1), Le());
    },
    [Le, U, re]
  ), la = F(
    (R) => {
      R.relatedTarget && ke.current?.contains(R.relatedTarget) || (re(!1), C?.(R));
    },
    [C, re]
  ), ca = F(
    (R) => {
      U || R.stopPropagation(), re(!0), S?.(R);
    },
    [U, S, re]
  ), da = F(
    (R) => {
      if (R.key.length === 1 && R.key !== " " && !R.metaKey && !R.ctrlKey && !R.altKey && !U && R.target === De.current && gn(R.key)) {
        R.preventDefault(), x?.(R);
        return;
      }
      Yn(R.key) && re(!0), x?.(R);
    },
    [U, x, gn, re]
  ), ha = F(
    (R) => {
      U || R.target !== De.current || gn(R.clipboardData.getData("text").trim()) && R.preventDefault();
    },
    [U, gn]
  ), ua = F(
    (R) => {
      R.stopPropagation(), re(!U), Le();
    },
    [Le, U, re]
  ), pa = F(
    (R) => {
      R.stopPropagation(), Le(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, Le, n, h]
  ), ga = F(
    (R) => {
      n?.(R), !y && !g ? (re(!1), De.current?.focus()) : un.current?.focus();
    },
    [g, y, n, re]
  );
  return Z(() => (U ? (oe.addEventListener("click", Et), oe.addEventListener("keydown", Lt)) : (oe.removeEventListener("click", Et), oe.removeEventListener("keydown", Lt)), () => {
    oe.removeEventListener("click", Et), oe.removeEventListener("keydown", Lt);
  }), [Et, Lt, U, oe]), ht(() => {
    !ns || d || h || Le();
  }), Z(() => {
    U && un.current?.focus();
  }, [U]), tt(() => {
    oe.removeEventListener("click", Et), oe.removeEventListener("keydown", Lt);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Kb,
      ref: ke,
      className: f(ce.root, D, {
        [ce.rootHasWrapperIcon]: !!i,
        [ce.rootReadOnly]: h
      }),
      "aria-expanded": U,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Me,
          {
            ...ne,
            ref: De,
            className: f(a, ce.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: i,
            active: U,
            status: l,
            onClick: ca,
            onBlur: la,
            onKeyDown: da,
            onPaste: ha,
            tabIndex: d ? -1 : b ?? (ut ? -1 : 0),
            children: /* @__PURE__ */ s.jsxs(B, { className: ce.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(B, { gap: "100", flexWrap: "wrap", className: ce.titleContainer, children: [
                ss && aa,
                ut && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: un,
                    onChange: ia,
                    className: f(ce.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: ra,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(B, { alignItems: "center", className: ce.iconContainer, children: [
                I && !d && !h && !!t?.length && /* @__PURE__ */ s.jsx(
                  q,
                  {
                    className: ce.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: pa,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  q,
                  {
                    className: ce.iconButton,
                    variant: "tertiary",
                    icon: U ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: ua,
                    "aria-label": U ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        e && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: e,
            value: M(t)
          }
        ),
        /* @__PURE__ */ s.jsx(
          nt,
          {
            isOpen: U,
            ...E,
            className: f(E?.className, ce.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: ao, style: { width: "100%" }, children: U && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              K,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Tb,
                {
                  ...A,
                  equalityFn: T,
                  defaultActiveItemIndex: P,
                  isActive: U,
                  isMultiple: g,
                  selectedValues: t,
                  onChange: ga,
                  children: u
                }
              ),
              se
            ] }) })
          }
        )
      ]
    }
  );
}, Ub = Object.assign(W(or), {
  name: or.name
}), sD = ({
  className: a,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...g
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: a,
    label: r,
    labelFor: t,
    meta: i,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Ub,
      {
        name: t,
        value: e || [],
        onChange: (m) => {
          n(m.selectedValues);
        },
        ...o,
        status: z.getStatus(i),
        disabled: c,
        required: l,
        ...g
      }
    )
  }
), qb = "h-slider--slider__rootWrapper", Gb = "h-slider--slider__rootWrapperNoAnnotations", Yb = "h-slider--slider__root", Qb = "h-slider--slider__rootDark", Xb = "h-slider--slider__rootDisabled", Zb = "h-slider--slider__handle", Jb = "h-slider--slider__trackWrapper", ey = "h-slider--slider__track", ty = "h-slider--slider__highlight", ny = "h-slider--slider__minValueIndicator", sy = "h-slider--slider__maxValueIndicator", me = {
  rootWrapper: qb,
  rootWrapperNoAnnotations: Gb,
  root: Yb,
  rootDark: Qb,
  rootDisabled: Xb,
  handle: Zb,
  trackWrapper: Jb,
  track: ey,
  highlight: ty,
  minValueIndicator: ny,
  maxValueIndicator: sy
};
var Ne = /* @__PURE__ */ ((a) => (a.LowBoundIndicator = "input-slider-low-indicator", a.HighBoundIndicator = "input-slider-high-indicator", a.Handle = "input-slider-handle", a.Value = "input-slider-value", a.TrackBackground = "input-slider-tack-background", a.Track = "input-slider-track", a.Highlight = "input-slider-highlight", a))(Ne || {});
const oy = (a) => {
  a.preventDefault();
}, ry = (a, e, t) => typeof a != "number" && !Array.isArray(a) ? "" : typeof a == "number" ? /* @__PURE__ */ s.jsxs(H.Paragraph, { variant: "3", children: [
  e,
  a,
  t
] }) : /* @__PURE__ */ s.jsxs(H.Paragraph, { variant: "3", children: [
  e,
  a[0],
  t,
  " - ",
  e,
  a[1],
  t
] });
class ay extends k {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: ry,
    hideAnnotations: !1
  };
  constructor(e) {
    super(e), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = O();
  isInterval(e) {
    return Array.isArray(e);
  }
  handleChange(e) {
    typeof e == "number" ? this.props.onChange?.(Math.round(e)) : this.props.onChange?.(
      e.map((t) => Math.round(t))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(e) {
    e.target instanceof Element && this.setState({
      currentIndex: parseInt(
        e.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(e) {
    e.preventDefault();
    const { startVal: t, startX: n, sliderWidth: o, currentIndex: r } = this.state, i = t + (e.clientX - n) / o, l = this.getAbsoluteValue(i, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(e) {
    const { step: t = 1, value: n } = this.props;
    e.preventDefault();
    const o = this.isInterval(n) && e.target instanceof Element ? parseInt(e.target.getAttribute("data-index") || "", 10) : null;
    switch (e.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(t, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-t, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(e) {
    if (!this.sliderRef.current) return;
    const { value: t } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (e.clientX - o.left) / o.width;
    this.setState({
      startX: e.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let i;
    if (this.isInterval(t)) {
      const l = n ?? this.findTheNearestHandle(r, t);
      this.setState({
        currentIndex: l
      }), i = this.getAbsoluteValue(r, l);
    } else
      i = this.getAbsoluteValue(r);
    this.handleChange(i), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(e, t) {
    const [n, o] = t.map(
      this.absoluteValueToRelativeValue
    );
    return e > o && e > n ? 1 : e < o && e < n ? 0 : Math.abs(n - e) > Math.abs(o - e) ? 1 : 0;
  }
  getAdjustedStep(e) {
    const { min: t, max: n } = this.props;
    return e / (n - t);
  }
  getAbsoluteValue(e, t) {
    const { value: n, step: o } = this.props;
    let r = Ln(e, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [i, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    t === 0 && c > l ? c = l : t === 1 && c < i && (c = i);
    const d = [i, l];
    return typeof t == "number" && (d[t] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(e) {
    const { min: t, max: n } = this.props, o = t + (n - t) * e;
    return Ln(o, t, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(e) {
    const { min: t, max: n } = this.props, o = (e - t) / (n - t);
    return Ln(o, 0, 1);
  }
  increment(e, t) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[t ?? 0] = r[t ?? 0] + e, o = r;
    } else
      o = n + e;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: e, min: t } = this.props, n = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[1]) - this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(e), o = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(t);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(e) {
    const { value: t } = this.props;
    return {
      left: `${(this.isInterval(t) ? this.absoluteValueToRelativeValue(t[e ?? 0]) : this.absoluteValueToRelativeValue(t)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: e } = this.props;
    if (ye(e)) return {};
    const [t, n] = e.map(this.absoluteValueToRelativeValue);
    return {
      left: `${t * 100}%`,
      width: `${(n - t) * 100}%`
    };
  }
  render() {
    const {
      className: e,
      value: t,
      step: n,
      highlightRange: o,
      min: r,
      max: i,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: g,
      onBlur: m,
      onFocus: b,
      children: y,
      ...v
    } = this.props, w = f(
      me.root,
      { [me.rootDark]: l },
      { [me.rootDisabled]: c },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(me.rootWrapper, {
          [me.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...v,
              className: w,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: me.trackWrapper,
                    "data-testid": Ne.TrackBackground,
                    children: [
                      !ye(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: me.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Ne.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: me.track,
                          style: this.getTrackStyles(),
                          "data-testid": Ne.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(t) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": i,
                    "aria-valuenow": t,
                    className: me.handle,
                    onClick: oy,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Ne.Handle
                  }
                ),
                this.isInterval(t) && /* @__PURE__ */ s.jsxs(et, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: me.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Ne.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: me.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Ne.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Ne.LowBoundIndicator,
                    className: me.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(H.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      g
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: me.maxValueIndicator,
                    "data-testid": Ne.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(H.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      i,
                      g
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Ne.Value, children: h(t, p, g) })
        ]
      }
    );
  }
}
const As = ln(ay, {
  fallback: null
}), iy = "h-fieldSlider--fieldSlider__root", ly = {
  root: iy
};
class oD extends k {
  constructor(e) {
    super(e), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(e) {
    const t = new Event("change");
    Object.defineProperty(t, "target", {
      writable: !0,
      value: { value: e, name: this.props.input.name }
    }), this.props.input.onChange(t);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(e) {
    const { input: t } = this.props, n = new FocusEvent(
      "blur",
      e
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: t.value, name: t.name }
    }), t.onBlur?.(n);
  }
  render() {
    const {
      className: e,
      input: t,
      meta: n,
      label: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(ly.root, e);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: i,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          As,
          {
            ...t,
            onChange: this.handleChange,
            disabled: i,
            ...u
          }
        )
      }
    );
  }
}
const cy = "h-switch--switch__root", dy = "h-switch--switch__input", hy = "h-switch--switch__inner", uy = "h-switch--switch__pending", py = "h-switch--switch__active", Kt = {
  root: cy,
  input: dy,
  inner: hy,
  pending: uy,
  active: py
}, rr = {
  input: "Switch-input",
  label: "Switch-label"
};
class gy extends k {
  render() {
    const { id: e, className: t, variant: n, ...o } = this.props, r = e || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(t, Kt.root), "data-testid": e, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Kt.input,
          "data-testid": rr.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Kt.inner, {
            [Kt.active]: n === "active",
            [Kt.pending]: n === "pending"
          }),
          "data-testid": rr.label
        }
      )
    ] });
  }
}
class rD extends k {
  render() {
    const { input: e, ...t } = this.props, { ref: n, ...o } = e;
    return /* @__PURE__ */ s.jsx(gy, { ...o, ...t });
  }
}
class aD extends k {
  render() {
    const {
      className: e,
      input: t,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: e,
        label: n,
        labelFor: t.name,
        meta: o,
        required: r,
        disabled: i,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Jr,
          {
            status: z.getStatus(o),
            disabled: i,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const iD = ({
  className: a,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...g
}) => {
  const m = F(
    (b) => {
      n(b ?? "");
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: a,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: i,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        sn,
        {
          selectedItems: t ? [t] : [],
          ...o,
          ...g,
          disabled: c,
          id: e,
          onSelect: m,
          status: z.getStatus(i)
        }
      )
    }
  );
}, lD = ({
  className: a,
  input: { name: e, value: t, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...g
}) => {
  const m = F(
    (b) => {
      n({
        startTime: b.startTime ?? "",
        endTime: b.endTime ?? ""
      });
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: a,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: e,
      meta: i,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        $p,
        {
          endTime: t.endTime,
          startTime: t.startTime,
          ...o,
          ...g,
          disabled: c,
          id: e,
          onSelect: m,
          status: z.getStatus(i)
        }
      )
    }
  );
}, my = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", fy = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", by = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", yy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", Tn = {
  root: my,
  rootAlpha: fy,
  indicator: by,
  indicatorNoColor: yy
}, xy = ({
  color: a,
  alpha: e,
  className: t,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(Tn.root, t, {
      [Tn.rootAlpha]: e
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(Tn.indicator, {
          [Tn.indicatorNoColor]: !a
        }),
        style: { backgroundColor: a }
      }
    )
  }
), _y = "h-inputColorPicker--inputColorPicker__root", Cy = "h-inputColorPicker--inputColorPicker__inputContainer", vy = "h-inputColorPicker--inputColorPicker__input", wy = "h-inputColorPicker--inputColorPicker__rootReadOnly", Sy = "h-inputColorPicker--inputColorPicker__iconContainer", Iy = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", ky = "h-inputColorPicker--inputColorPicker__clearIcon", Dy = "h-inputColorPicker--inputColorPicker__colorIndicator", Ye = {
  root: _y,
  inputContainer: Cy,
  input: vy,
  rootReadOnly: wy,
  iconContainer: Sy,
  rootHasWrapperIcon: Iy,
  clearIcon: ky,
  colorIndicator: Dy
}, Ty = "inputColorPickerTestId", jy = W(function({
  className: e,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: n,
  onChange: o,
  dropdownProps: r,
  prefix: i,
  suffix: l,
  icon: c,
  status: d,
  placeholder: h,
  disabled: u,
  colorPickerProps: p,
  clearable: g,
  readOnly: m,
  children: b,
  ...y
}, v) {
  const w = Q(null), S = Q(null), C = Q(null), [x, _] = V(!1);
  Z(() => {
    x ? (window.addEventListener("click", T), window.addEventListener("keydown", P)) : (window.removeEventListener("click", T), window.removeEventListener("keydown", P)), x && I();
  }, [x]), tt(() => {
    window.removeEventListener("click", T), window.removeEventListener("keydown", P);
  });
  const I = () => {
    C.current?.querySelector("input")?.focus();
  }, T = ({ target: K }) => {
    S.current?.contains(K) || _(!1);
  }, P = (K) => {
    Ft(K.key) && x && (K.stopPropagation(), _(!1));
  }, M = () => {
    m || _(!0);
  }, D = ({ target: K }) => {
    S.current?.contains(K) || _(!1);
  }, E = () => {
    m || _(!0);
  }, A = ({ key: K }) => {
    Yn(K) && _(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Ty,
      ref: S,
      className: f(Ye.root, e, {
        [Ye.rootHasWrapperIcon]: !!c,
        [Ye.rootReadOnly]: m
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Me,
          {
            prefix: i,
            suffix: l,
            disabled: u,
            icon: c,
            active: x,
            status: d,
            children: /* @__PURE__ */ s.jsxs("div", { className: Ye.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...y,
                  id: t,
                  name: t,
                  className: Ye.input,
                  ref: w,
                  onClick: E,
                  onFocus: M,
                  onBlur: D,
                  onKeyDown: A,
                  disabled: u,
                  placeholder: h,
                  autoComplete: "off",
                  value: n,
                  onChange: Hn(n) ? void 0 : L,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Ye.iconContainer, children: g && n && /* @__PURE__ */ s.jsx(
                q,
                {
                  className: Ye.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: u,
                  onClick: () => o?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                xy,
                {
                  className: Ye.colorIndicator,
                  onClick: E,
                  color: n,
                  alpha: p?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(nt, { ...r, isOpen: x, children: /* @__PURE__ */ s.jsx("div", { ref: C, children: /* @__PURE__ */ s.jsx(
          Qn,
          {
            margin: "300",
            ...p,
            color: n,
            onChange: o ?? L,
            children: b
          }
        ) }) })
      ]
    }
  );
}), cD = ({
  className: a,
  input: { value: e, name: t, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...g
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: a,
    label: r,
    labelFor: t,
    meta: i,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      jy,
      {
        name: t,
        value: e,
        onChange: n,
        ...o,
        status: z.getStatus(i),
        disabled: c,
        required: l,
        ...g
      }
    )
  }
), Fy = "h-fieldAddonDropdown--fieldAddonDropdown__root", Ny = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Py = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", Ry = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", jn = {
  root: Fy,
  prefix: Ny,
  suffix: Py,
  angleDown: Ry
}, dD = ({
  className: a,
  noArrow: e,
  ...t
}) => fr(t) ? null : /* @__PURE__ */ s.jsx(Ma.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  Wr,
  {
    ...xr(t, "meta"),
    noStyle: !0,
    itemComponent: Or,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          jn.root,
          {
            [jn.prefix]: n === "prefix",
            [jn.suffix]: n === "suffix"
          },
          a
        ),
        disabled: o || t.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: t.meta.selectedValue }),
          !e && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", jn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Ey = "h-countryFlag--countryFlag__flag", Ly = "h-countryFlag--countryFlag__ad", Ay = "h-countryFlag--countryFlag__ae", $y = "h-countryFlag--countryFlag__af", Oy = "h-countryFlag--countryFlag__ag", By = "h-countryFlag--countryFlag__ai", Hy = "h-countryFlag--countryFlag__al", Wy = "h-countryFlag--countryFlag__am", My = "h-countryFlag--countryFlag__ao", zy = "h-countryFlag--countryFlag__aq", Vy = "h-countryFlag--countryFlag__ar", Ky = "h-countryFlag--countryFlag__as", Uy = "h-countryFlag--countryFlag__at", qy = "h-countryFlag--countryFlag__au", Gy = "h-countryFlag--countryFlag__aw", Yy = "h-countryFlag--countryFlag__ax", Qy = "h-countryFlag--countryFlag__az", Xy = "h-countryFlag--countryFlag__ba", Zy = "h-countryFlag--countryFlag__bb", Jy = "h-countryFlag--countryFlag__bd", ex = "h-countryFlag--countryFlag__be", tx = "h-countryFlag--countryFlag__bf", nx = "h-countryFlag--countryFlag__bg", sx = "h-countryFlag--countryFlag__bh", ox = "h-countryFlag--countryFlag__bi", rx = "h-countryFlag--countryFlag__bj", ax = "h-countryFlag--countryFlag__bl", ix = "h-countryFlag--countryFlag__bm", lx = "h-countryFlag--countryFlag__bn", cx = "h-countryFlag--countryFlag__bo", dx = "h-countryFlag--countryFlag__bq", hx = "h-countryFlag--countryFlag__br", ux = "h-countryFlag--countryFlag__bs", px = "h-countryFlag--countryFlag__bt", gx = "h-countryFlag--countryFlag__bv", mx = "h-countryFlag--countryFlag__bw", fx = "h-countryFlag--countryFlag__by", bx = "h-countryFlag--countryFlag__bz", yx = "h-countryFlag--countryFlag__ca", xx = "h-countryFlag--countryFlag__cd", _x = "h-countryFlag--countryFlag__cf", Cx = "h-countryFlag--countryFlag__cg", vx = "h-countryFlag--countryFlag__ch", wx = "h-countryFlag--countryFlag__ci", Sx = "h-countryFlag--countryFlag__ck", Ix = "h-countryFlag--countryFlag__cl", kx = "h-countryFlag--countryFlag__cm", Dx = "h-countryFlag--countryFlag__cn", Tx = "h-countryFlag--countryFlag__co", jx = "h-countryFlag--countryFlag__cp", Fx = "h-countryFlag--countryFlag__cr", Nx = "h-countryFlag--countryFlag__cu", Px = "h-countryFlag--countryFlag__cv", Rx = "h-countryFlag--countryFlag__cw", Ex = "h-countryFlag--countryFlag__cy", Lx = "h-countryFlag--countryFlag__cz", Ax = "h-countryFlag--countryFlag__de", $x = "h-countryFlag--countryFlag__dj", Ox = "h-countryFlag--countryFlag__dk", Bx = "h-countryFlag--countryFlag__dm", Hx = "h-countryFlag--countryFlag__dz", Wx = "h-countryFlag--countryFlag__ec", Mx = "h-countryFlag--countryFlag__ee", zx = "h-countryFlag--countryFlag__eg", Vx = "h-countryFlag--countryFlag__eh", Kx = "h-countryFlag--countryFlag__er", Ux = "h-countryFlag--countryFlag__es", qx = "h-countryFlag--countryFlag__et", Gx = "h-countryFlag--countryFlag__eu", Yx = "h-countryFlag--countryFlag__fi", Qx = "h-countryFlag--countryFlag__fj", Xx = "h-countryFlag--countryFlag__fm", Zx = "h-countryFlag--countryFlag__fo", Jx = "h-countryFlag--countryFlag__fr", e_ = "h-countryFlag--countryFlag__ga", t_ = "h-countryFlag--countryFlag__gb", n_ = "h-countryFlag--countryFlag__gd", s_ = "h-countryFlag--countryFlag__ge", o_ = "h-countryFlag--countryFlag__gg", r_ = "h-countryFlag--countryFlag__gh", a_ = "h-countryFlag--countryFlag__gi", i_ = "h-countryFlag--countryFlag__gl", l_ = "h-countryFlag--countryFlag__gm", c_ = "h-countryFlag--countryFlag__gn", d_ = "h-countryFlag--countryFlag__gp", h_ = "h-countryFlag--countryFlag__gq", u_ = "h-countryFlag--countryFlag__gr", p_ = "h-countryFlag--countryFlag__gt", g_ = "h-countryFlag--countryFlag__gu", m_ = "h-countryFlag--countryFlag__gw", f_ = "h-countryFlag--countryFlag__gy", b_ = "h-countryFlag--countryFlag__hk", y_ = "h-countryFlag--countryFlag__hn", x_ = "h-countryFlag--countryFlag__hr", __ = "h-countryFlag--countryFlag__ht", C_ = "h-countryFlag--countryFlag__hu", v_ = "h-countryFlag--countryFlag__id", w_ = "h-countryFlag--countryFlag__ie", S_ = "h-countryFlag--countryFlag__il", I_ = "h-countryFlag--countryFlag__im", k_ = "h-countryFlag--countryFlag__iq", D_ = "h-countryFlag--countryFlag__ir", T_ = "h-countryFlag--countryFlag__is", j_ = "h-countryFlag--countryFlag__it", F_ = "h-countryFlag--countryFlag__je", N_ = "h-countryFlag--countryFlag__jm", P_ = "h-countryFlag--countryFlag__jo", R_ = "h-countryFlag--countryFlag__jp", E_ = "h-countryFlag--countryFlag__ke", L_ = "h-countryFlag--countryFlag__kg", A_ = "h-countryFlag--countryFlag__kh", $_ = "h-countryFlag--countryFlag__ki", O_ = "h-countryFlag--countryFlag__km", B_ = "h-countryFlag--countryFlag__kn", H_ = "h-countryFlag--countryFlag__kp", W_ = "h-countryFlag--countryFlag__kr", M_ = "h-countryFlag--countryFlag__kw", z_ = "h-countryFlag--countryFlag__ky", V_ = "h-countryFlag--countryFlag__kz", K_ = "h-countryFlag--countryFlag__la", U_ = "h-countryFlag--countryFlag__lb", q_ = "h-countryFlag--countryFlag__lc", G_ = "h-countryFlag--countryFlag__li", Y_ = "h-countryFlag--countryFlag__lk", Q_ = "h-countryFlag--countryFlag__lr", X_ = "h-countryFlag--countryFlag__ls", Z_ = "h-countryFlag--countryFlag__lt", J_ = "h-countryFlag--countryFlag__lu", eC = "h-countryFlag--countryFlag__lv", tC = "h-countryFlag--countryFlag__ly", nC = "h-countryFlag--countryFlag__ma", sC = "h-countryFlag--countryFlag__mc", oC = "h-countryFlag--countryFlag__md", rC = "h-countryFlag--countryFlag__me", aC = "h-countryFlag--countryFlag__mf", iC = "h-countryFlag--countryFlag__mg", lC = "h-countryFlag--countryFlag__mh", cC = "h-countryFlag--countryFlag__mk", dC = "h-countryFlag--countryFlag__ml", hC = "h-countryFlag--countryFlag__mm", uC = "h-countryFlag--countryFlag__mn", pC = "h-countryFlag--countryFlag__mo", gC = "h-countryFlag--countryFlag__mq", mC = "h-countryFlag--countryFlag__mr", fC = "h-countryFlag--countryFlag__ms", bC = "h-countryFlag--countryFlag__mt", yC = "h-countryFlag--countryFlag__mu", xC = "h-countryFlag--countryFlag__mv", _C = "h-countryFlag--countryFlag__mw", CC = "h-countryFlag--countryFlag__mx", vC = "h-countryFlag--countryFlag__my", wC = "h-countryFlag--countryFlag__mz", SC = "h-countryFlag--countryFlag__na", IC = "h-countryFlag--countryFlag__nc", kC = "h-countryFlag--countryFlag__ne", DC = "h-countryFlag--countryFlag__ng", TC = "h-countryFlag--countryFlag__ni", jC = "h-countryFlag--countryFlag__nl", FC = "h-countryFlag--countryFlag__no", NC = "h-countryFlag--countryFlag__np", PC = "h-countryFlag--countryFlag__nq", RC = "h-countryFlag--countryFlag__nr", EC = "h-countryFlag--countryFlag__nu", LC = "h-countryFlag--countryFlag__nz", AC = "h-countryFlag--countryFlag__om", $C = "h-countryFlag--countryFlag__pa", OC = "h-countryFlag--countryFlag__pe", BC = "h-countryFlag--countryFlag__pf", HC = "h-countryFlag--countryFlag__pg", WC = "h-countryFlag--countryFlag__ph", MC = "h-countryFlag--countryFlag__pk", zC = "h-countryFlag--countryFlag__pl", VC = "h-countryFlag--countryFlag__pr", KC = "h-countryFlag--countryFlag__ps", UC = "h-countryFlag--countryFlag__pt", qC = "h-countryFlag--countryFlag__pw", GC = "h-countryFlag--countryFlag__py", YC = "h-countryFlag--countryFlag__qa", QC = "h-countryFlag--countryFlag__re", XC = "h-countryFlag--countryFlag__ro", ZC = "h-countryFlag--countryFlag__rs", JC = "h-countryFlag--countryFlag__ru", ev = "h-countryFlag--countryFlag__rw", tv = "h-countryFlag--countryFlag__sa", nv = "h-countryFlag--countryFlag__sb", sv = "h-countryFlag--countryFlag__sc", ov = "h-countryFlag--countryFlag__sd", rv = "h-countryFlag--countryFlag__se", av = "h-countryFlag--countryFlag__sg", iv = "h-countryFlag--countryFlag__sh", lv = "h-countryFlag--countryFlag__si", cv = "h-countryFlag--countryFlag__sj", dv = "h-countryFlag--countryFlag__sk", hv = "h-countryFlag--countryFlag__sl", uv = "h-countryFlag--countryFlag__sm", pv = "h-countryFlag--countryFlag__sn", gv = "h-countryFlag--countryFlag__so", mv = "h-countryFlag--countryFlag__sr", fv = "h-countryFlag--countryFlag__ss", bv = "h-countryFlag--countryFlag__st", yv = "h-countryFlag--countryFlag__sv", xv = "h-countryFlag--countryFlag__sx", _v = "h-countryFlag--countryFlag__sy", Cv = "h-countryFlag--countryFlag__sz", vv = "h-countryFlag--countryFlag__tc", wv = "h-countryFlag--countryFlag__td", Sv = "h-countryFlag--countryFlag__tg", Iv = "h-countryFlag--countryFlag__th", kv = "h-countryFlag--countryFlag__tj", Dv = "h-countryFlag--countryFlag__tl", Tv = "h-countryFlag--countryFlag__tm", jv = "h-countryFlag--countryFlag__tn", Fv = "h-countryFlag--countryFlag__to", Nv = "h-countryFlag--countryFlag__tr", Pv = "h-countryFlag--countryFlag__tt", Rv = "h-countryFlag--countryFlag__tv", Ev = "h-countryFlag--countryFlag__tw", Lv = "h-countryFlag--countryFlag__tz", Av = "h-countryFlag--countryFlag__ua", $v = "h-countryFlag--countryFlag__ug", Ov = "h-countryFlag--countryFlag__us", Bv = "h-countryFlag--countryFlag__uy", Hv = "h-countryFlag--countryFlag__uz", Wv = "h-countryFlag--countryFlag__va", Mv = "h-countryFlag--countryFlag__vc", zv = "h-countryFlag--countryFlag__ve", Vv = "h-countryFlag--countryFlag__vg", Kv = "h-countryFlag--countryFlag__vi", Uv = "h-countryFlag--countryFlag__vn", qv = "h-countryFlag--countryFlag__vu", Gv = "h-countryFlag--countryFlag__ws", Yv = "h-countryFlag--countryFlag__ye", Qv = "h-countryFlag--countryFlag__yt", Xv = "h-countryFlag--countryFlag__za", Zv = "h-countryFlag--countryFlag__zm", Jv = "h-countryFlag--countryFlag__zw", ar = {
  flag: Ey,
  ad: Ly,
  ae: Ay,
  af: $y,
  ag: Oy,
  ai: By,
  al: Hy,
  am: Wy,
  ao: My,
  aq: zy,
  ar: Vy,
  as: Ky,
  at: Uy,
  au: qy,
  aw: Gy,
  ax: Yy,
  az: Qy,
  ba: Xy,
  bb: Zy,
  bd: Jy,
  be: ex,
  bf: tx,
  bg: nx,
  bh: sx,
  bi: ox,
  bj: rx,
  bl: ax,
  bm: ix,
  bn: lx,
  bo: cx,
  bq: dx,
  br: hx,
  bs: ux,
  bt: px,
  bv: gx,
  bw: mx,
  by: fx,
  bz: bx,
  ca: yx,
  cd: xx,
  cf: _x,
  cg: Cx,
  ch: vx,
  ci: wx,
  ck: Sx,
  cl: Ix,
  cm: kx,
  cn: Dx,
  co: Tx,
  cp: jx,
  cr: Fx,
  cu: Nx,
  cv: Px,
  cw: Rx,
  cy: Ex,
  cz: Lx,
  de: Ax,
  dj: $x,
  dk: Ox,
  dm: Bx,
  do: "h-countryFlag--countryFlag__do",
  dz: Hx,
  ec: Wx,
  ee: Mx,
  eg: zx,
  eh: Vx,
  er: Kx,
  es: Ux,
  et: qx,
  eu: Gx,
  fi: Yx,
  fj: Qx,
  fm: Xx,
  fo: Zx,
  fr: Jx,
  ga: e_,
  gb: t_,
  gd: n_,
  ge: s_,
  gg: o_,
  gh: r_,
  gi: a_,
  gl: i_,
  gm: l_,
  gn: c_,
  gp: d_,
  gq: h_,
  gr: u_,
  gt: p_,
  gu: g_,
  gw: m_,
  gy: f_,
  hk: b_,
  hn: y_,
  hr: x_,
  ht: __,
  hu: C_,
  id: v_,
  ie: w_,
  il: S_,
  im: I_,
  in: "h-countryFlag--countryFlag__in",
  iq: k_,
  ir: D_,
  is: T_,
  it: j_,
  je: F_,
  jm: N_,
  jo: P_,
  jp: R_,
  ke: E_,
  kg: L_,
  kh: A_,
  ki: $_,
  km: O_,
  kn: B_,
  kp: H_,
  kr: W_,
  kw: M_,
  ky: z_,
  kz: V_,
  la: K_,
  lb: U_,
  lc: q_,
  li: G_,
  lk: Y_,
  lr: Q_,
  ls: X_,
  lt: Z_,
  lu: J_,
  lv: eC,
  ly: tC,
  ma: nC,
  mc: sC,
  md: oC,
  me: rC,
  mf: aC,
  mg: iC,
  mh: lC,
  mk: cC,
  ml: dC,
  mm: hC,
  mn: uC,
  mo: pC,
  mq: gC,
  mr: mC,
  ms: fC,
  mt: bC,
  mu: yC,
  mv: xC,
  mw: _C,
  mx: CC,
  my: vC,
  mz: wC,
  na: SC,
  nc: IC,
  ne: kC,
  ng: DC,
  ni: TC,
  nl: jC,
  no: FC,
  np: NC,
  nq: PC,
  nr: RC,
  nu: EC,
  nz: LC,
  om: AC,
  pa: $C,
  pe: OC,
  pf: BC,
  pg: HC,
  ph: WC,
  pk: MC,
  pl: zC,
  pr: VC,
  ps: KC,
  pt: UC,
  pw: qC,
  py: GC,
  qa: YC,
  re: QC,
  ro: XC,
  rs: ZC,
  ru: JC,
  rw: ev,
  sa: tv,
  sb: nv,
  sc: sv,
  sd: ov,
  se: rv,
  sg: av,
  sh: iv,
  si: lv,
  sj: cv,
  sk: dv,
  sl: hv,
  sm: uv,
  sn: pv,
  so: gv,
  sr: mv,
  ss: fv,
  st: bv,
  sv: yv,
  sx: xv,
  sy: _v,
  sz: Cv,
  tc: vv,
  td: wv,
  tg: Sv,
  th: Iv,
  tj: kv,
  tl: Dv,
  tm: Tv,
  tn: jv,
  to: Fv,
  tr: Nv,
  tt: Pv,
  tv: Rv,
  tw: Ev,
  tz: Lv,
  ua: Av,
  ug: $v,
  us: Ov,
  uy: Bv,
  uz: Hv,
  va: Wv,
  vc: Mv,
  ve: zv,
  vg: Vv,
  vi: Kv,
  vn: Uv,
  vu: qv,
  ws: Gv,
  ye: Yv,
  yt: Qv,
  za: Xv,
  zm: Zv,
  zw: Jv
}, ew = 127365, tw = /^[a-z]{2}$/, nw = (a) => tw.test(a) ? String.fromCodePoint(
  ...a.split("").map((e) => ew + e.charCodeAt(0))
) : "", hD = ({
  className: a,
  countryCode: e,
  size: t = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(ie, { style: { width: t, height: t }, children: /* @__PURE__ */ s.jsx(
  ie,
  {
    className: f(ar.flag, ar[e], a),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${t} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: a, style: { fontSize: t }, children: nw(e) }), uD = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], sw = "h-formGrid--formGrid__root", ow = {
  root: sw
}, rw = "formGridTestId", pD = W(function({ className: e, children: t, ...n }, o) {
  const r = f(ow.root, e);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": rw,
      className: r,
      ...n,
      ref: o,
      children: t
    }
  );
}), aw = "h-formGrid-field--formField__root", iw = "h-formGrid-field--formField__rootSpan5", lw = "h-formGrid-field--formField__rootSpan4", cw = "h-formGrid-field--formField__rootSpan3", dw = "h-formGrid-field--formField__rootSpan2", hw = "h-formGrid-field--formField__rootSpan1", It = {
  root: aw,
  rootSpan5: iw,
  rootSpan4: lw,
  rootSpan3: cw,
  rootSpan2: dw,
  rootSpan1: hw
}, uw = "formFieldTestId", pw = {
  1: It.rootSpan1,
  2: It.rootSpan2,
  3: It.rootSpan3,
  4: It.rootSpan4,
  5: It.rootSpan5,
  6: void 0
};
class gD extends k {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: e, className: t, children: n, ...o } = this.props, r = f(
      It.root,
      t,
      pw[e]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": uw, className: r, ...o, children: n });
  }
}
const gw = "h-helperField--helperField__root", mw = "h-helperField--helperField__label", fw = "h-helperField--helperField__helpIcon", bw = "h-helperField--helperField__error", yw = "h-helperField--helperField__rootRequired", Ut = {
  root: gw,
  label: mw,
  helpIcon: fw,
  error: bw,
  rootRequired: yw
};
class mD extends k {
  render() {
    const {
      className: e,
      label: t,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: i,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [Ut.root]: !0,
        [Ut.rootRequired]: n
      },
      e
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!t && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: Ut.label,
          htmlFor: i,
          id: `${i}-label`,
          children: t
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Us,
        {
          ...c,
          className: f(Ut.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: Ut.error, children: r }),
      l
    ] });
  }
}
const xw = "h-inputDuration--inputDuration__root", _w = {
  root: xw
}, ws = (a, e = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const t = Math.floor(a / 1e3), n = {};
  let o = t;
  return e.includes("days") && (n.days = Math.floor(t / (24 * 3600)), o = t % (24 * 3600)), e.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), e.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), e.includes("seconds") && (n.seconds = o), n;
}, Ss = (a) => ((a.days ?? 0) * 86400 + (a.hours ?? 0) * 3600 + (a.minutes ?? 0) * 60 + (a.seconds ?? 0)) * 1e3, Cw = [
  "hours",
  "minutes",
  "seconds"
], fD = W(
  function(e, t) {
    const n = Q(null);
    an(t, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: i = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = Cw,
      status: u,
      onChange: p,
      onBlur: g
    } = e, [m, b] = V(
      () => ws(i, h)
    );
    Z(() => {
      const C = Ss(m);
      if (i !== C) {
        const x = ws(i, h);
        b(x);
      }
    }, [i, h]);
    const y = F(
      (C, x) => {
        const _ = Math.max(0, parseInt(x) || 0);
        if ((C === "minutes" || C === "seconds") && _ > 60)
          return;
        const I = { ...m, [C]: _ };
        b(I);
        const T = Ss(I);
        p?.(T);
      },
      [m, p]
    ), v = F(() => {
      const C = Ss(m), x = ws(
        C,
        h
      );
      b(x), g?.();
    }, [m, h, g]), w = (C) => {
      const x = m[C] ?? 0, _ = x === 0;
      return {
        type: "number",
        id: `${r}-${C}`,
        name: `${r}-${C}`,
        value: _ ? "" : x,
        placeholder: _ ? "0" : void 0,
        suffix: {
          type: "custom",
          value: C.charAt(0).toUpperCase() + C.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: v,
        onChange: (I) => y(C, I.target.value)
      };
    }, S = f(o, _w.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: S, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Xe, { ...w("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Xe, { ...w("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Xe, { ...w("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Xe, { ...w("seconds"), max: 60 })
    ] });
  }
), qt = /* @__PURE__ */ new Map();
function vw({
  containerId: a,
  children: e
}) {
  const [t, n] = V(null), o = (i) => {
    const l = qt.get(a);
    l !== void 0 && qt.set(a, l + i);
  }, r = () => {
    const i = document.createElement("div");
    return i.id = a, i;
  };
  return Z(() => {
    let i = document.getElementById(a);
    return i || (i = r(), document.body.appendChild(i), qt.set(a, 0)), n(i), o(1), () => {
      o(-1), qt.get(a) === 0 && i && (qt.delete(a), i.remove());
    };
  }, [a]), t ? Za.createPortal(e, t) : null;
}
const ww = "h-modal--modal__root", Sw = "h-modal--modal__rootSkipAnimation", Iw = "h-modal--modal__modalContainer", kw = "h-modal--modal__modalContent", Dw = "h-modal--modal__rootDisplayed", Tw = "h-modal--modal__rootOpened", jw = "h-modal--modal__modal", Fw = "h-modal--modal__modalStacked", Nw = "h-modal--modal__ghostPanel", Pw = "h-modal--modal__ghostLabel", Te = {
  root: ww,
  rootSkipAnimation: Sw,
  modalContainer: Iw,
  modalContent: kw,
  rootDisplayed: Dw,
  rootOpened: Tw,
  modal: jw,
  modalStacked: Fw,
  ghostPanel: Nw,
  ghostLabel: Pw
}, Rw = Ie(!1);
class Ew extends k {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(e) {
    super(e), this.rootRef = O(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: e } = this.props;
    e && this.animateOpening();
  }
  componentDidUpdate(e) {
    const { isOpen: t, allowEscClose: n } = this.props, { isOpen: o } = e;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), t !== o && (t ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(e) {
    const { isOpen: t, onClose: n } = this.props;
    t && Ft(e.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (e.preventDefault(), e.stopPropagation(), this.animateClosing(), n(e)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: e } = this.rootRef;
    e && e.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: e } = this.props;
    e ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: e } = this.props;
    this.removeKeyDownEventListener(), e ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: e,
      isOpen: t,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: i,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: g, opened: m } = this.state, b = f(Te.root, c?.className, {
      [Te.rootDisplayed]: g,
      [Te.rootOpened]: m,
      [Te.rootSkipAnimation]: l
    });
    return /* @__PURE__ */ s.jsx(vw, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: Te.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: m && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          Sr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: Te.modalContent, children: /* @__PURE__ */ s.jsx(Rw.Consumer, { children: (y) => /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: f(Te.modal, e, {
                  [Te.modalStacked]: y
                }),
                onClick: (v) => r && v.stopPropagation(),
                children: [
                  y && /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      role: "button",
                      tabIndex: -1,
                      className: Te.ghostPanel,
                      onClick: o,
                      children: /* @__PURE__ */ s.jsxs("span", { className: Te.ghostLabel, children: [
                        /* @__PURE__ */ s.jsx(N, { name: "arrow-left", size: 12 }),
                        "Go back"
                      ] })
                    }
                  ),
                  n
                ]
              }
            ) }) })
          }
        )
      }
    ) }) });
  }
}
const Lw = "h-lightbox--lightbox__lightSource", Aw = "h-lightbox--lightbox__closeButton", $w = "h-lightbox--lightbox__downloadButton", Ow = "h-lightbox--lightbox__image", Bw = "h-lightbox--lightbox__loadingContainer", Hw = "h-lightbox--lightbox__navButton", Ww = "h-lightbox--lightbox__navButtonPrevious", Mw = "h-lightbox--lightbox__navButtonNext", zw = "h-lightbox--lightbox__counter", je = {
  lightSource: Lw,
  closeButton: Aw,
  downloadButton: $w,
  image: Ow,
  loadingContainer: Bw,
  navButton: Hw,
  navButtonPrevious: Ww,
  navButtonNext: Mw,
  counter: zw
};
class bD extends k {
  render() {
    const {
      className: e,
      src: t,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: i = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      Ew,
      {
        className: e,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: je.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: je.loadingContainer, children: /* @__PURE__ */ s.jsx(Ws, { size: 64 }) }) : t && /* @__PURE__ */ s.jsx(zs, { className: je.image, alt: n, src: t }),
          r && /* @__PURE__ */ s.jsx(
            q,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: je.closeButton
            }
          ),
          t && typeof t == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: t,
              target: "_blank",
              download: !0,
              className: je.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          i && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              q,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${je.navButton} ${je.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              q,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${je.navButton} ${je.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: je.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const Vw = "h-list-items--item__root", Kw = "h-list-items--item__rootWithHoverEffect", Uw = "h-list-items--item__rootDense", qw = "h-list-items--item__rootLarge", Gw = "h-list-items--item__contentLeft", Yw = "h-list-items--item__contentRight", Qw = "h-list-items--item__titles", Xw = "h-list-items--item__title", Zw = "h-list-items--item__titleSecondary", Jw = "h-list-items--item__arrow", Fe = {
  root: Vw,
  rootWithHoverEffect: Kw,
  rootDense: Uw,
  rootLarge: qw,
  contentLeft: Gw,
  contentRight: Yw,
  titles: Qw,
  title: Xw,
  titleSecondary: Zw,
  arrow: Jw
};
class ts extends k {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: e, titleSecondary: t } = this.props;
    return e || t ? /* @__PURE__ */ s.jsxs("div", { className: Fe.titles, children: [
      !!e && /* @__PURE__ */ s.jsx(H.Paragraph, { as: "div", variant: "2", className: Fe.title, children: e }),
      !!t && /* @__PURE__ */ s.jsx(
        H.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Fe.titleSecondary,
          children: t
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: Fe.contentLeft, children: e }) : null;
  }
  renderContentRight() {
    const { contentRight: e } = this.props;
    return e ? /* @__PURE__ */ s.jsx("div", { className: Fe.contentRight, children: e }) : null;
  }
  renderIcon() {
    const { isLink: e, contentRight: t } = this.props;
    return e && !t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(Fe.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(et, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: e,
      children: t,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: i,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Fe.root, e, {
      [Fe.rootDense]: d === "dense",
      [Fe.rootLarge]: d === "large",
      [Fe.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const eS = "h-list-items--keyValue__root", tS = {
  root: eS
};
class nS extends k {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: e, className: t, pair: n, ...o } = this.props, r = f(tS.root, t);
    return e && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ts,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(H.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(H.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const sS = "h-list-items--text__root", oS = {
  root: sS
};
class rS extends k {
  render() {
    const { children: e, className: t, ...n } = this.props, o = f(oS.root, t);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(H.Paragraph, { variant: "2", children: e })
      }
    );
  }
}
const aS = "h-list-items--user__root", iS = "h-list-items--user__avatarWrapper", ir = {
  root: aS,
  avatarWrapper: iS
};
class lS extends k {
  getTitle() {
    const { user: e, title: t } = this.props;
    return t || e.display_name || e.name || e.phone_number || e.id;
  }
  getSubTitle() {
    const { user: e, titleSecondary: t } = this.props;
    return t || e.email;
  }
  render() {
    const { className: e, user: t, title: n, titleSecondary: o, ...r } = this.props, i = f(e, ir.root);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: i,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: ir.avatarWrapper, children: /* @__PURE__ */ s.jsx(wr, { user: t }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const cS = "h-list--list__root", dS = {
  root: cS
};
class hS extends k {
  static Item = ts;
  static Text = rS;
  static User = lS;
  static KeyValue = nS;
  render() {
    const { className: e, ...t } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...t, className: f(dS.root, e) });
  }
}
const yD = ln(hS, {
  fallback: null
}), uS = () => {
  document.exitFullscreen && document.exitFullscreen();
}, pS = (a) => {
  a.requestFullscreen ? a.requestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.webkitRequestFullscreen ? a.webkitRequestFullscreen() : a.msRequestFullscreen && a.msRequestFullscreen();
}, gS = (a) => document.fullscreenElement === a;
class mS extends Error {
  status;
  url;
  response;
  constructor(e) {
    super(`NetworkError ${e.status} ${e.url}`), this.status = e.status, this.url = e.url, this.response = e;
  }
}
const fS = {
  fetch: (a, ...e) => fetch(a, ...e).then((t) => {
    if (!(t.status >= 200 && t.status < 300))
      throw new mS(t);
    return t;
  })
}, bS = "h-mediaPlayer--mediaPlayer__root", yS = "h-mediaPlayer--mediaPlayer__controls", xS = "h-mediaPlayer--mediaPlayer__unstyled", _S = "h-mediaPlayer--mediaPlayer__rootFullScreen", CS = "h-mediaPlayer--mediaPlayer__rootHideControls", vS = "h-mediaPlayer--mediaPlayer__control", wS = "h-mediaPlayer--mediaPlayer__progress", SS = "h-mediaPlayer--mediaPlayer__progressSlider", IS = "h-mediaPlayer--mediaPlayer__volumeSlider", kS = "h-mediaPlayer--mediaPlayer__timestamp", DS = "h-mediaPlayer--mediaPlayer__videoWrapper", TS = "h-mediaPlayer--mediaPlayer__rootWaiting", jS = "h-mediaPlayer--mediaPlayer__rootAudio", FS = "h-mediaPlayer--mediaPlayer__video", NS = "h-mediaPlayer--mediaPlayer__volume", PS = "h-mediaPlayer--mediaPlayer__volumeMuteControl", RS = "h-mediaPlayer--mediaPlayer__downloadLink", J = {
  root: bS,
  controls: yS,
  unstyled: xS,
  rootFullScreen: _S,
  rootHideControls: CS,
  control: vS,
  progress: wS,
  progressSlider: SS,
  volumeSlider: IS,
  timestamp: kS,
  videoWrapper: DS,
  rootWaiting: TS,
  rootAudio: jS,
  video: FS,
  volume: NS,
  volumeMuteControl: PS,
  downloadLink: RS
};
function ES(a) {
  const e = a >= 3600 ? 8 : 5;
  return Number.isNaN(a) || !Number.isFinite(a) ? "00:00" : new Date(a * 1e3).toISOString().substr(19 - e, e);
}
class xD extends k {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(e) {
    super(e), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: e } = this.props, { current: t } = this.playerRef;
    t && t.addEventListener("fullscreenchange", this.handleFullscreenChange), e ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(e, t) {
    const {
      mediaFile: { src: n }
    } = e, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(t);
  }
  componentWillUnmount() {
    const { current: e } = this.playerRef;
    e && e.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = O();
  playerRef = O();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: e },
      isPrivateFile: t
    } = this.props;
    this.tryStopPlayer(), t ? this.fetchFile() : this.setSrc(e);
  }
  setSrc(e) {
    this.setState({
      src: e
    });
  }
  handleIntersection([e]) {
    const { src: t, asyncStatus: n } = this.state;
    !t && !(n === "loading") && e.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: e } = this.playerRef;
    e && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(e));
  }
  tryStopPlayer() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    e.currentTime = 0;
    const { playing: t, actuallyPlaying: n } = this.state;
    t && n && (e.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(e) {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { src: n } = this.state;
    n !== e.src && t.load();
  }
  fetchFile(e) {
    const {
      mediaFile: { src: t },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    fS.fetch(t, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((i) => i.blob()).then((i) => {
      const l = window.URL.createObjectURL(i);
      e ? Ha.saveAs(
        i,
        o || decodeURIComponent(t.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((i) => {
      i && i.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", i), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: e } = this.videoRef;
    e && this.setState({
      time: e.currentTime,
      duration: e.duration
    });
  }
  updateBuffer() {
    const { current: e } = this.videoRef, { time: t, duration: n } = this.state;
    if (e) {
      let o = null;
      const r = e.buffered;
      for (let i = 0; i < r.length; i += 1) {
        const l = r.start(i), c = r.end(i);
        l <= t && t <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: e, actuallyPlaying: t } = this.state, { current: n } = this.videoRef;
    n && (e && t ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : e || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: e } = this.playerRef, t = gS(e);
    this.setState({
      isFullScreen: t
    }), t ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: e } = this.playerRef, { isFullScreen: t } = this.state;
    e && (t ? uS() : pS(e));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(e) {
    const { current: t } = this.videoRef, { duration: n } = this.state;
    t && e && !Number.isNaN(e) && (t.currentTime = n * e);
  }
  handleVolume = (e) => {
    const { current: t } = this.videoRef;
    !t || typeof e > "u" || !Number.isFinite(e) || this.setState({ volume: e }, () => {
      this.setPlayerVolume(e);
    });
  };
  handleMute() {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { volume: t, prevVolume: n } = this.state, o = t === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : t
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(e) {
    const { current: t } = this.videoRef;
    t && (t.volume = e / 100);
  }
  render() {
    const {
      className: e,
      mediaFile: { type: t },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: i,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: g,
      hideControls: m,
      isFullScreen: b,
      isWaiting: y,
      buffer: v,
      asyncStatus: w
    } = this.state, S = i?.play ?? !0, C = i?.download ?? !0, x = i?.progress ?? !0, _ = i?.volume ?? !0, I = i?.maximize ?? !0, T = S || C || x || _ || I, P = typeof t == "string" && t.startsWith("audio"), M = !d || w === "loading", D = b ? "primary" : "secondary", E = f(
      J.root,
      {
        [J.rootFullScreen]: b,
        [J.rootHideControls]: m,
        [J.rootWaiting]: h && y,
        [J.rootAudio]: P
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: E,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: J.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: J.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(J.controls, {
                [J.unstyled]: l
              }),
              children: [
                S && /* @__PURE__ */ s.jsx(
                  q,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: J.control,
                    disabled: M,
                    icon: h ? "pause" : "play",
                    variant: D
                  }
                ),
                C && (o ? /* @__PURE__ */ s.jsx(
                  te,
                  {
                    variant: D,
                    className: J.control,
                    disabled: M,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: J.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  q,
                  {
                    icon: "download",
                    variant: D,
                    className: J.control,
                    disabled: M,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                x && /* @__PURE__ */ s.jsxs("div", { className: J.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    As,
                    {
                      hideAnnotations: !0,
                      className: J.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (A) => !Array.isArray(A) && this.seek(A / u),
                      dark: b,
                      highlightRange: v?.map((A) => A * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: J.timestamp, children: ES(u) })
                ] }),
                _ && /* @__PURE__ */ s.jsxs("div", { className: J.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: J.volumeMuteControl,
                      name: g === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    As,
                    {
                      hideAnnotations: !0,
                      className: J.volumeSlider,
                      value: g,
                      onChange: (A) => !Array.isArray(A) && this.handleVolume(A),
                      dark: b
                    }
                  )
                ] }),
                I && !P && /* @__PURE__ */ s.jsx(
                  q,
                  {
                    variant: D,
                    onClick: this.handleFullscreenToggle,
                    className: J.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const LS = "h-modalBody--modalBody__root", AS = {
  root: LS
};
class _D extends k {
  render() {
    const { className: e, children: t, ...n } = this.props, o = f(
      {
        [AS.root]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: t });
  }
}
const $S = "h-modalFoot--modalFoot__root", OS = "h-modalFoot--modalFoot__confirm", BS = "h-modalFoot--modalFoot__confirmSecondary", HS = "h-modalFoot--modalFoot__cancel", Fn = {
  root: $S,
  confirm: OS,
  confirmSecondary: BS,
  cancel: HS
};
class WS extends k {
  static defaultProps;
  render() {
    const {
      className: e,
      confirmOnClick: t,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: i,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, g = f(
      {
        [Fn.root]: !0
      },
      e
    ), m = f(
      {
        [Fn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Fn.confirm]: !0
      },
      c?.className
    ), y = f(
      {
        [Fn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: g, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "secondary",
          ...d,
          className: y,
          onClick: n,
          children: i
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "tertiary",
          ...h,
          className: m,
          onClick: o,
          children: l
        }
      ),
      t && /* @__PURE__ */ s.jsx(
        te,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: t,
          children: r
        }
      )
    ] });
  }
}
WS.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const MS = "h-modalHead--modalHead__root", zS = "h-modalHead--modalHead__top", VS = "h-modalHead--modalHead__title", KS = "h-modalHead--modalHead__buttons", US = "h-modalHead--modalHead__caption", Gt = {
  root: MS,
  top: zS,
  title: VS,
  buttons: KS,
  caption: US
}, CD = ({
  className: a,
  title: e,
  children: t,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  buttonsSlot: i,
  ...l
}) => {
  const c = f(
    {
      [Gt.root]: !0
    },
    a
  );
  return /* @__PURE__ */ s.jsxs("div", { ...l, className: c, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Gt.top, children: [
      /* @__PURE__ */ s.jsx(H.Heading, { className: Gt.title, children: e }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Gt.buttons, r), children: [
        i,
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(le, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          q,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          q,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!t && /* @__PURE__ */ s.jsx(
      H.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Gt.caption,
        children: t
      }
    )
  ] });
}, qS = "h-page-body--pageBody__root", GS = {
  root: qS
}, YS = W(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pe.Row,
    {
      ...n,
      ref: o,
      className: f(GS.root, t),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: e
    }
  );
}), QS = "h-page-head--pageHead__root", XS = {
  root: QS
}, ZS = W(function({ className: e, title: t, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    pe.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(XS.root, e),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(pe.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(H.Heading, { variant: "heading-2", as: "h1", children: t }) }),
        n && /* @__PURE__ */ s.jsx(pe.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), JS = "h-page-section--pageSection__root", eI = "h-page-section--pageSection__head", tI = "h-page-section--pageSection__callout", nI = "h-page-section--pageSection__content", Nn = {
  root: JS,
  head: eI,
  callout: tI,
  content: nI
}, sI = W(function({
  children: e,
  className: t,
  title: n,
  titleMeta: o,
  controls: r,
  callout: i,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    pe.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Nn.root, t),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          pe.Row,
          {
            className: Nn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(pe.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(B, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(H.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(pe.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        i && /* @__PURE__ */ s.jsx(
          pe.Row,
          {
            className: Nn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: i
          }
        ),
        /* @__PURE__ */ s.jsx(
          pe.Row,
          {
            className: Nn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: e
          }
        )
      ]
    }
  );
}), oI = W(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pe.Row,
    {
      ...n,
      ref: o,
      className: t,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: e
    }
  );
}), lr = ({ children: a, className: e, ...t }, n) => /* @__PURE__ */ s.jsx(Ac, { ...t, ref: n, as: "article", className: e, children: /* @__PURE__ */ s.jsx(pe, { children: a }) }), vD = Object.assign(W(lr), {
  name: lr.name,
  Head: ZS,
  Body: YS,
  Section: sI,
  Tabs: oI
}), rI = "h-radio--radio__radio", aI = "h-radio--radio__radioDisabled", iI = "h-radio--radio__radioChecked", lI = "h-radio--radio__input", Pn = {
  radio: rI,
  radioDisabled: aI,
  radioChecked: iI,
  input: lI
}, wD = W(function(e, t) {
  const { id: n, checked: o, disabled: r, className: i, labelProps: l, ...c } = e, d = f(
    Pn.radio,
    { [Pn.radioChecked]: o },
    { [Pn.radioDisabled]: r },
    i
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: t,
          id: h,
          onChange: c.onChange || L,
          checked: o,
          disabled: r,
          type: "radio",
          className: Pn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), cI = "h-reverseScroll--reverseScroll__root", dI = "h-reverseScroll--reverseScroll__column", hI = "h-reverseScroll--reverseScroll__row", uI = "h-reverseScroll--reverseScroll__scrollHandle", Yt = {
  root: cI,
  column: dI,
  row: hI,
  scrollHandle: uI
}, pI = "reverse-scroll", SD = W(function({
  children: e,
  className: t,
  direction: n = "column",
  ...o
}, r) {
  const i = Q(null), l = Q(null), c = Q(null), d = es(e), h = G(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), g = (b) => i.current?.children[1]?.scrollIntoView(b), m = (b) => i.current?.children[i.current.children.length - 2]?.scrollIntoView(b);
  return an(r, () => ({
    rootElem: i.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: m,
    scrollToLastChild: g
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": pI,
      ref: i,
      className: f(t, Yt.root, {
        [Yt.row]: n === "row",
        [Yt.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Yt.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Yt.scrollHandle })
      ]
    }
  );
}), gI = "h-removableCard--removableCard__root", mI = "h-removableCard--removableCard__close", fI = "h-removableCard--removableCard__title", bI = "h-removableCard--removableCard__titleIcon", Qt = {
  root: gI,
  close: mI,
  title: fI,
  titleIcon: bI
};
class ID extends k {
  render() {
    const { icon: e, title: t, children: n, onRemove: o, className: r, ...i } = this.props, l = f(
      {
        [Qt.root]: Qt.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      ie,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...i,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            ie,
            {
              as: "button",
              "aria-label": "Remove",
              className: Qt.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            B,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Qt.title,
              children: [
                e && /* @__PURE__ */ s.jsx(N, { name: e, className: Qt.titleIcon }),
                t
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(ie, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const cr = ({
  colorMode: a = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${a}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${a};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, yI = "h-sandboxIframe--sandboxIframe__frame", xI = {
  frame: yI
};
class sa extends k {
  frameRef;
  static defaultProps;
  constructor(e) {
    super(e), this.state = {
      iframeHeight: 0
    }, this.frameRef = O(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(e) {
    const { content: t, headContent: n, colorMode: o } = this.props;
    (e.content !== t || e.headContent !== n || e.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: e, headContent: t = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      e.indexOf("</body>") !== -1 ? r = e.replace(
        "</body>",
        `${cr({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${t}</head><body>${e}${cr(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(e) {
    const { current: t } = this.frameRef;
    if (t && e.source === t.contentWindow) {
      const { data: n } = e;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: e,
      content: t,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...i
    } = this.props, { iframeHeight: l } = this.state, c = f({}, e);
    return /* @__PURE__ */ s.jsx("div", { ...i, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? sa.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: xI.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const _I = "h-scrollbar--scrollbar__track", CI = "h-scrollbar--scrollbar__handle", dr = {
  track: _I,
  handle: CI
};
class kD extends k {
  constructor(e) {
    super(e), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: e } = this.props;
    e.current && e.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: e } = this.props;
    e.current && e.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: e } = this.props;
    if (e.current) {
      const { current: t } = e;
      this.setState({
        size: t.offsetHeight / t.scrollHeight,
        progress: t.scrollTop / t.scrollHeight
      });
    }
  };
  handleTrackClick(e) {
    const { container: t } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), t.current) {
      const o = t.current.getBoundingClientRect();
      let r = (e.clientY - o.top) / t.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), t.current.scrollTop = r * t.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(e) {
    const { size: t } = this.state;
    if (e.stopPropagation(), !(e.target instanceof Element)) return;
    const n = e.target.getBoundingClientRect();
    this.setState({
      offset: (e.clientY - n.top) / n.height * t
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(e) {
    e.preventDefault();
    const { container: t } = this.props, { size: n, offset: o } = this.state;
    if (t.current) {
      const r = t.current.getBoundingClientRect();
      let i = (e.clientY - r.top) / t.current.offsetHeight - o;
      i < 0 && (i = 0), i + n > 1 && (i = 1 - n), t.current.scrollTop = i * t.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: e, thumbClassName: t, trackClassName: n, ...o } = this.props, { size: r, progress: i } = this.state, l = f(e);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(dr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(dr.handle, t),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${i * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const vI = "h-scrollShadow--scrollShadow__wrapper", wI = "h-scrollShadow--scrollShadow__content", hr = {
  wrapper: vI,
  content: wI
}, DD = ({
  className: a,
  children: e,
  ...t
}) => {
  const n = f(hr.wrapper, a);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...t, children: /* @__PURE__ */ s.jsx("div", { className: hr.content, children: e }) });
}, SI = "h-searchInput--searchInput__root", II = "h-searchInput--searchInput__input", kI = "h-searchInput--searchInput__inputButton", Rn = {
  root: SI,
  input: II,
  inputButton: kI
}, DI = 275, ur = 300, TD = ({
  className: a,
  initialSearch: e,
  maxWidth: t = DI,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: i,
  ...l
}) => {
  const c = Q(null), [d, h] = V(!!e), [u, p] = V(!1), [g, m] = V(e ?? "");
  Qa(
    () => {
      u && (h(!1), p(!1), m(""));
    },
    ur,
    [u]
  ), Je(() => {
    i?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = F(() => {
    h(!0);
  }, []), y = F(() => {
    p(!0);
  }, []), v = F(
    (x) => {
      x.preventDefault(), r(g);
    },
    [r, g]
  ), w = F(
    (x) => {
      const {
        target: { value: _ }
      } = x;
      m(_), o?.(_);
    },
    [o]
  ), S = F(
    ({ key: x }) => {
      x === "Enter" && b();
    },
    [b]
  ), C = F(
    ({ key: x }) => {
      (x === "Esc" || x === "Escape") && y();
    },
    [y]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(Rn.root, a),
      style: {
        "--max-width": `${d && !u ? t : 32}px`,
        "--transition-delay": `${ur}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: v, children: /* @__PURE__ */ s.jsx(
        Xe,
        {
          className: Rn.input,
          ref: c,
          onChange: w,
          placeholder: n ?? "Search...",
          type: "search",
          value: g,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: v,
              className: Rn.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: y,
              className: Rn.inputButton
            }
          },
          onKeyDown: C
        }
      ) }) : /* @__PURE__ */ s.jsx(
        q,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: S,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, TI = "h-selectOption--selectOption__root", jI = "h-selectOption--selectOption__checkbox", FI = "h-selectOption--selectOption__content", Is = {
  root: TI,
  checkbox: jI,
  content: FI
}, jD = (a) => {
  const e = f(Is.root);
  return /* @__PURE__ */ s.jsxs("label", { className: e, children: [
    /* @__PURE__ */ s.jsx(
      cn,
      {
        ...a,
        className: f(Is.checkbox, a.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: Is.content, children: a.name })
  ] });
}, NI = "h-simpleProgressBar--simpleProgressBar__container", PI = "h-simpleProgressBar--simpleProgressBar__progressBar", RI = "h-simpleProgressBar--simpleProgressBar__progressBarFill", ks = {
  container: NI,
  progressBar: PI,
  progressBarFill: RI
}, EI = "simpleProgressBarId";
function FD({
  progress: a,
  base: e = 100,
  progressColor: t = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...i
}) {
  const [l, c] = V(0), d = 4;
  Z(() => c(a), [a]);
  const h = e >= l ? l / e : 1, u = () => d / h, p = {
    backgroundColor: Jt(n)
  }, g = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: Jt(t)
  };
  return /* @__PURE__ */ s.jsx(
    B,
    {
      "test-id": EI,
      "align-items": "center",
      "justify-content": "center",
      className: ks.container,
      ...i,
      children: /* @__PURE__ */ s.jsx(
        le,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: ks.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: ks.progressBarFill,
              style: g
            }
          ) })
        }
      )
    }
  );
}
const LI = "h-tabsWithContent--tabsWithContent__container", AI = "h-tabsWithContent--tabsWithContent__containerTop", $I = "h-tabsWithContent--tabsWithContent__containerLeft", OI = "h-tabsWithContent--tabsWithContent__containerRight", BI = "h-tabsWithContent--tabsWithContent__containerBottom", HI = "h-tabsWithContent--tabsWithContent__childrenContainer", wt = {
  container: LI,
  containerTop: AI,
  containerLeft: $I,
  containerRight: OI,
  containerBottom: BI,
  childrenContainer: HI
};
class $s extends xe {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(e) {
    super(e), this.state = { activeTab: e.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(e) {
    this.ensureTabIsValid(e) && (this.setState({ activeTab: e }), this.props.onChange?.(e));
  }
  ensureTabIsValid(e) {
    return this.props.tabs.some((t) => t.id === e);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: e }) => e === this.state.activeTab);
  }
  render() {
    const {
      className: e,
      tabsClassName: t,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: i,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Ee.toArray(l);
    if (h.length !== i.length) {
      const m = `${$s.name}: Number of tabs don't match the number of children.`;
      console.warn(m);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const m = `${$s.name}: The selected tab does not exist in tabs array!`;
      console.warn(m);
    }
    const p = f(e, wt.container, {
      [wt.containerTop]: c === "top",
      [wt.containerLeft]: c === "left",
      [wt.containerBottom]: c === "bottom",
      [wt.containerRight]: c === "right"
    }), g = f(
      r,
      wt.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        xf,
        {
          className: t,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: i,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: g, children: h[u] })
    ] });
  }
}
const WI = "h-tagsInput--tagsInput__root", MI = "h-tagsInput--tagsInput__wrapper", zI = "h-tagsInput--tagsInput__input", VI = "h-tagsInput--tagsInput__inputIsHidden", KI = "h-tagsInput--tagsInput__placeholder", UI = "h-tagsInput--tagsInput__placeholderText", qI = "h-tagsInput--tagsInput__iconBox", GI = "h-tagsInput--tagsInput__iconText", YI = "h-tagsInput--tagsInput__tag", QI = "h-tagsInput--tagsInput__tagIsActive", XI = "h-tagsInput--tagsInput__tagButton", fe = {
  root: WI,
  wrapper: MI,
  input: zI,
  inputIsHidden: VI,
  placeholder: KI,
  placeholderText: UI,
  iconBox: qI,
  iconText: GI,
  tag: YI,
  tagIsActive: QI,
  tagButton: XI
};
function pr(a = [], e) {
  switch (e) {
    case "asc":
      return a.sort();
    case "desc":
      return a.sort().reverse();
    default:
      return a;
  }
}
const ZI = 255, ND = ({
  className: a,
  disabled: e,
  limit: t,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: i
}) => {
  const l = Q(null), c = Q(null), [d, h] = V(""), [u, p] = V(
    pr(o, r)
  ), [g, m] = V(""), [b, y] = V(!1);
  vr(l, () => y(!1)), Je(() => i(u), [u, i]), Je(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const v = (I) => {
    h(I.target.value ?? "");
  }, w = (I) => {
    const T = u.indexOf(g);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !g && d && p((P) => {
          const M = Array.from(/* @__PURE__ */ new Set([...P, d]));
          return h(""), pr(M, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !g && d.length === 0 && m(u[u.length - 1]), g && (S(g), m(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        g && T > 0 && m(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        g && T < u.length - 1 && m(u[T + 1]);
        break;
      default:
        g && m("");
    }
  }, S = (I) => {
    p((T) => {
      const P = [...T];
      return P.splice(P.indexOf(I), 1), P;
    });
  }, C = b ? u.length : t || u.length, x = C < u.length, _ = u.slice(0, C);
  return /* @__PURE__ */ s.jsx(
    Me,
    {
      ref: l,
      className: f(fe.root, a),
      onClick: () => y(!0),
      disabled: e,
      children: /* @__PURE__ */ s.jsxs("div", { className: fe.wrapper, "data-testid": "tags-wrapper", children: [
        _.map((I) => /* @__PURE__ */ s.jsx(
          nn,
          {
            className: f(fe.tag, {
              [fe.tagIsActive]: I === g
            }),
            onDelete: () => S(I),
            "data-testid": "tag",
            children: I
          },
          I
        )),
        !b && x && /* @__PURE__ */ s.jsxs(
          nn,
          {
            className: f(fe.tag, fe.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - C
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(B, { className: fe.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(H.Paragraph, { className: fe.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(H.Paragraph, { className: fe.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: fe.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(H.Paragraph, { className: fe.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(fe.input, {
              [fe.inputIsHidden]: !b
            }),
            onChange: v,
            onKeyDown: w,
            maxLength: ZI,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, JI = "h-textWithHighlight--textWithHighlight__highlight", ek = {
  highlight: JI
}, tk = ({
  text: a,
  highlight: e,
  className: t,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!e?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: a });
  const r = new RegExp(
    Hs(e.trim()),
    o ? "ig" : "g"
  ), i = a.match(r), l = a.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: t, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    i?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(ek.highlight, n), children: i[d] })
  ] }, d)) });
}, nk = _r(tk);
nk.name = "TextWithHighlight";
const sk = "h-timestamp--timestamp__timestamp", ok = "h-timestamp--timestamp__print", rk = "h-timestamp--timestamp__screen", Ds = {
  timestamp: sk,
  print: ok,
  screen: rk
}, ak = 1e4;
class PD extends xe {
  interval;
  static defaultProps = {
    refreshRate: ak
  };
  constructor(e) {
    super(e);
    const { relative: t, counter: n, initialFormat: o } = e;
    let r = o ?? "absolute";
    t ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: e } = this.state;
    (e === "ago" || e === "counter") && this.startTicker();
  }
  componentDidUpdate(e) {
    const { relative: t, initialFormat: n } = this.props, { pristine: o } = this.state;
    t !== e.relative && o && this.setState({
      format: t ? "ago" : "absolute"
    }), n && n !== e.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(e) {
    const { onClick: t } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), t?.(o, e);
  }
  getTimeString(e) {
    let { time: t } = this.props;
    const { isSecondsDisplayed: n, customFormatters: o } = this.props;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const i = j(t).utc().local();
    if (e === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / 3600), u = Math.floor(h / 24), p = h % 24, g = h * 60 * 60, m = Math.floor((d - g) / 60), b = m * 60, y = Math.floor(
        d - g - b
      );
      r = [
        p.toString().padStart(2, "0"),
        m.toString().padStart(2, "0"),
        y.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (e === "full") {
      const l = o?.full ?? (n ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = i.format(l);
    } else if (e === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = o?.absolute ?? `D MMMM LT${n ? "S" : ""}`;
        r = i.format(l);
      } else {
        const l = o?.absolute ?? `LT${n ? "S" : ""}`;
        r = i.format(l);
      }
    else
      r = Dh(i);
    return r;
  }
  render() {
    const {
      className: e,
      relative: t,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: i,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [Ds.timestamp]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          ...h,
          ...Gn(this.handleClick),
          className: f(u, Ds.screen),
          children: this.getTimeString(this.state.format)
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: f(u, Ds.print), "aria-hidden": !0, children: this.getTimeString("full") })
    ] });
  }
}
const ik = "h-token--token__root", lk = "h-token--token__select", ck = "h-token--token__label", dk = "h-token--token__rootReadonly", hk = "h-token--token__rootPrimary", uk = "h-token--token__rootWithError", pk = "h-token--token__value", gk = "h-token--token__icon", Be = {
  root: ik,
  select: lk,
  label: ck,
  rootReadonly: dk,
  rootPrimary: hk,
  rootWithError: uk,
  value: pk,
  icon: gk
};
class RD extends k {
  render() {
    const {
      onDelete: e,
      id: t,
      label: n,
      options: o,
      valueLabel: r,
      primary: i,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [Be.root]: !0,
        [Be.rootPrimary]: i,
        [Be.rootWithError]: c?.error,
        [Be.rootReadonly]: !o && !e
      },
      h
    );
    let g = r;
    if (!g && l && o && o.length) {
      const m = o.filter(({ value: b }) => l.value === b);
      m.length && (g = m[0].label);
    }
    return !g && d && (g = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: Be.select, id: t, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((m) => /* @__PURE__ */ s.jsx("option", { value: m.value, children: m.label }, m.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: Be.label, htmlFor: t, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: Be.value, children: g }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: Be.icon, name: "angle-down" }),
        !!e && /* @__PURE__ */ s.jsx("span", { ...Gn(e), children: /* @__PURE__ */ s.jsx(N, { className: Be.icon, name: "close", onClick: e }) })
      ] })
    ] });
  }
}
const mk = "h-skeleton--skeleton__root", fk = "h-skeleton--skeleton__rootAnimationPulse", bk = "h-skeleton--skeleton__rootAnimationWave", Ts = {
  root: mk,
  rootAnimationPulse: fk,
  rootAnimationWave: bk
};
function gr({ className: a, animation: e = "pulse", ...t }, n) {
  const o = f(
    {
      [Ts.root]: !0,
      [Ts.rootAnimationPulse]: e === "pulse",
      [Ts.rootAnimationWave]: e === "wave"
    },
    a
  );
  return /* @__PURE__ */ s.jsx(ie, { className: o, ...t, ref: n });
}
const ED = Object.assign(W(gr), {
  name: gr.name
}), yk = "h-breadcrumbs--breadcrumbs__root", xk = "h-breadcrumbs--breadcrumbs__list", _k = "h-breadcrumbs--breadcrumbs__item", Ck = "h-breadcrumbs--breadcrumbs__separator", En = {
  root: yk,
  list: xk,
  item: _k,
  separator: Ck
}, LD = W(function({
  className: e,
  children: t,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...i
}, l) {
  const c = n ?? "nav", d = Ee.toArray(t).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...i,
      ref: l,
      className: f(En.root, e),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: En.list, children: d.map((h, u) => {
        const p = u === d.length - 1, g = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(et, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: En.item,
              "aria-current": p ? "page" : void 0,
              children: g
            }
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: En.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] }, u);
      }) })
    }
  );
});
export {
  rm as AddonTriggerContext,
  am as AddonTriggerEvents,
  Pk as Attachment,
  wr as Avatar,
  wu as AvatarSelectItem,
  Ek as Badge,
  Lk as Banner,
  ie as Box,
  LD as Breadcrumbs,
  te as Button,
  Ak as ButtonGroup,
  po as ButtonList,
  Uk as CheckableAvatarSelectItem,
  Ys as CheckableBaseItem,
  zk as CheckableSelectItem,
  Kk as CheckableTagSelectItem,
  cn as Checkbox,
  Mu as Chip,
  Ok as CollapseCard,
  Bk as Collapsible,
  Qn as ColorPicker,
  pe as Column,
  Ac as Columns,
  ed as CopyToClipboard,
  Hk as CopyToClipboardButton,
  hD as CountryFlag,
  Wk as DataTable,
  eg as DatePicker,
  Xt as DatePickerOld,
  Up as DateRangePicker,
  Gk as DeselectItem,
  Qk as Dialer,
  qn as Divider,
  nt as Dropdown,
  Nt as DropdownButton,
  dn as DropdownButtonContext,
  Gs as DropdownInfinite,
  Po as DropdownItem,
  Wr as DropdownSelect,
  Hr as DropdownSelectContainer,
  Wa as EMOJIS,
  OD as EmojiPicker,
  Zn as EmptySelectItem,
  Dd as EmptyState,
  jt as ErrorBoundary,
  pi as ErrorBoundaryContext,
  dD as FieldAddonDropdown,
  Jn as FieldAlert,
  Xk as FieldButton,
  cD as FieldColorPicker,
  Zk as FieldDatePicker,
  Jk as FieldDateRangePicker,
  qs as FieldLabel,
  tD as FieldRichText,
  nD as FieldSelect,
  sD as FieldSelectionList,
  oD as FieldSlider,
  rD as FieldSwitch,
  Ps as FieldText,
  aD as FieldTextarea,
  iD as FieldTimePicker,
  lD as FieldTimeRangePicker,
  z as FieldWrapper,
  B as FlexBox,
  Sr as FocusScope,
  gD as FormField,
  pD as FormGrid,
  Us as HelpIcon,
  mD as HelperField,
  N as Icon,
  q as IconButton,
  zs as Image,
  jy as InputColorPicker,
  Tg as InputDatePicker,
  on as InputDateRangePicker,
  fD as InputDuration,
  oo as InputRichText,
  Ub as InputSelectionList,
  Xe as InputText,
  Me as InputWrapper,
  bD as Lightbox,
  yD as List,
  yD as ListV2,
  xD as MediaPlayer,
  Ew as Modal,
  _D as ModalBody,
  WS as ModalFoot,
  CD as ModalHead,
  Rw as ModalStackContext,
  BD as NavigationButton,
  vD as Page,
  xd as Pagination,
  vw as Portal,
  $r as Presets,
  wD as Radio,
  ID as RemovableCard,
  SD as ReverseScroll,
  sa as SandboxIframe,
  DD as ScrollShadow,
  kD as Scrollbar,
  TD as SearchInput,
  yp as Select,
  Or as SelectItem,
  jD as SelectOption,
  Tb as SelectionList,
  sd as SimplePagination,
  FD as SimpleProgressBar,
  ED as Skeleton,
  As as Slider,
  Ws as Spinner,
  gy as Switch,
  ge as Table,
  Xn as TableContext,
  xf as Tabs,
  $s as TabsWithContent,
  nn as Tag,
  Yk as TagDeselectItem,
  Vk as TagSelectItem,
  qk as TagSelectSuggestion,
  ND as TagsInput,
  H as Text,
  nk as TextWithHighlight,
  Jr as Textarea,
  sn as TimePicker,
  $p as TimeRangePicker,
  PD as Timestamp,
  RD as Token,
  le as Tooltip,
  Un as WindowContext,
  Nk as WindowProvider,
  HD as addSvgIconsToDocument,
  Mi as badgeTestId,
  Pc as colorPickerTestId,
  uD as countryCodes,
  Mk as datepickerDisableWeekends,
  WD as defaultElementType,
  eo as formatShortcut,
  Vg as formattingOptions,
  Rt as getSelectionListContext,
  MD as iconMeta,
  Uo as inputRichTextCommands,
  Kb as inputSelectionListTestId,
  pI as reverseScrollTestId,
  Ms as useWindowContext,
  ln as withErrorBoundary
};
//# sourceMappingURL=index.js.map
